import F from "clsx";
import { jsx as o, jsxs as d, Fragment as P } from "react/jsx-runtime";
import { useMultiStyleConfig as V, Box as E, StylesProvider as z, useStyles as x, chakra as i, Icon as y, Button as N, Flex as j, useStyleConfig as H, Popover as Ze, PopoverTrigger as Ne, Text as J, PopoverContent as De, PopoverCloseButton as Ve, PopoverBody as _e, usePopper as Ie, Grid as K, Heading as he, Editable as Te, useEditable as $e, useEditableControls as ge, ButtonGroup as We, IconButton as Y, theme as ue, extendTheme as ke } from "@chakra-ui/react";
import * as e from "react";
import { createElement as Pe, useState as B, useEffect as T, cloneElement as Ce, useRef as ze, useMemo as Le, createContext as Oe, useContext as Ge, useCallback as Q } from "react";
import { createTheme as Ue } from "@material-ui/core";
import { useMap as qe } from "react-map-gl";
import { css as S } from "@emotion/react";
import { jsx as O } from "@emotion/react/jsx-runtime";
import { Temporal as W } from "@js-temporal/polyfill";
import Ye from "@chakra-ui/descendant";
const Qe = "ui";
function f(t, ...n) {
  return F(`${Qe}-${t}`, n);
}
const lt = (t) => {
  const {
    text: n,
    className: r
  } = t;
  if (!n)
    return null;
  const l = n.split(`
`), s = [];
  for (let a = 0; a < l.length; a++)
    s.push(l[a]), a < l.length - 1 && s.push(/* @__PURE__ */ o("br", {}, l.length + a));
  return /* @__PURE__ */ o("p", {
    className: f("paragraph", r),
    children: s
  });
}, st = ({
  children: t,
  ...n
}) => {
  const r = V("AdBanner", {});
  return /* @__PURE__ */ o(E, {
    as: "aside",
    __css: r.adBanner,
    ...n,
    children: /* @__PURE__ */ o(z, {
      value: r,
      children: t
    })
  });
}, at = ({
  src: t,
  children: n,
  ...r
}) => {
  const l = x();
  return /* @__PURE__ */ o(i.img, {
    __css: l.image,
    ...r,
    src: t
  });
}, it = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.div, {
    __css: r.heading,
    ...n,
    children: t
  });
}, ct = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.a, {
    __css: r.button,
    ...n,
    children: t
  });
}, dt = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.div, {
    __css: r.logoWrapper,
    ...n,
    children: t
  });
}, Xe = {
  left: 180,
  right: 0,
  up: -90,
  down: 90
}, ee = ({
  arrowDirection: t,
  size: n,
  ...r
}) => {
  const l = `rotate(${Xe[t]}, 9, 9)`;
  return /* @__PURE__ */ o(y, {
    width: n,
    height: n,
    viewBox: "0 0 18 18",
    fill: "none",
    ...r,
    children: /* @__PURE__ */ o("g", {
      transform: l,
      children: /* @__PURE__ */ o("path", {
        d: "M5,1l8,8l-8,8",
        stroke: "currentColor",
        strokeWidth: "2",
        vectorEffect: "non-scaling-stroke"
      })
    })
  });
}, pt = (t) => /* @__PURE__ */ d(y, {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    d: "M5 16.3991V19.9643V43H22V0L5 16.3991Z",
    fill: "white"
  }), /* @__PURE__ */ o("path", {
    d: "M22 0V43H39V19.9643V16.3991L22 0Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M21 0L6 16.8929V19.9643V43H36V19.9643V17.6607L21 0Z",
    fill: "#E3E7F2"
  }), /* @__PURE__ */ o("path", {
    d: "M43.2414 21C43.0499 21.0003 42.8653 20.9287 42.725 20.7997L21.9995 1.77373L1.27394 20.7997C0.966701 21.0805 0.487501 21.0624 0.202782 20.7593C-0.0819365 20.4562 -0.0647485 19.9824 0.241197 19.7003L21.4831 0.200527C21.7743 -0.0668422 22.2247 -0.0668422 22.5158 0.200527L43.7578 19.7003C43.9863 19.9102 44.0615 20.237 43.9474 20.5241C43.8335 20.811 43.5534 20.9999 43.2414 21Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M18.6827 17.0181H11.0498V26.1775H18.6827H20.2093V17.0181H18.6827Z",
    fill: "url(#paint0_linear)"
  }), /* @__PURE__ */ o("path", {
    d: "M32.4219 17.0181H24.7891V26.1775H32.4219H33.9485V17.0181H32.4219Z",
    fill: "url(#paint1_linear)"
  }), /* @__PURE__ */ o("path", {
    d: "M18.6827 30.7573H11.0498V39.9168H18.6827H20.2093V30.7573H18.6827Z",
    fill: "url(#paint2_linear)"
  }), /* @__PURE__ */ o("path", {
    d: "M32.4219 30.7573H24.7891V39.9168H32.4219H33.9485V30.7573H32.4219Z",
    fill: "url(#paint3_linear)"
  }), /* @__PURE__ */ o("path", {
    d: "M38.7078 30.8213C38.5672 30.6793 38.4883 30.4867 38.4883 30.2858V17.2581L21.9991 1.79064L5.50984 17.2581V20.443C5.50984 20.8612 5.17429 21.2002 4.76029 21.2002C4.34629 21.2002 4.01074 20.8613 4.01074 20.443V16.9279C4.011 16.7174 4.09769 16.5165 4.25009 16.373L21.4889 0.202439C21.7766 -0.0674795 22.2216 -0.0674795 22.5092 0.202439L39.748 16.373C39.9004 16.5165 39.9871 16.7174 39.9873 16.9279V30.2858C39.9874 30.4866 39.9084 30.6793 39.7678 30.8213C39.6273 30.9633 39.4367 31.0431 39.2378 31.043C39.0391 31.0431 38.8484 30.9633 38.7078 30.8213Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M39.2378 43.9143H4.76029C4.56153 43.9144 4.37083 43.8346 4.23022 43.6926C4.08962 43.5506 4.01074 43.358 4.01074 43.1571V26.5001C4.01074 26.082 4.34629 25.7429 4.76029 25.7429C5.17429 25.7429 5.50984 26.0819 5.50984 26.5001V42.4001H38.4884V36.3429C38.4884 35.9248 38.8239 35.5857 39.2379 35.5857C39.6519 35.5857 39.9875 35.9247 39.9875 36.3429V43.1571C39.9876 43.3579 39.9086 43.5506 39.768 43.6926C39.6273 43.8346 39.4367 43.9144 39.2378 43.9143Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M4.76029 24.2287C5.17425 24.2287 5.50984 23.8897 5.50984 23.4715C5.50984 23.0534 5.17425 22.7144 4.76029 22.7144C4.34633 22.7144 4.01074 23.0534 4.01074 23.4715C4.01074 23.8897 4.34633 24.2287 4.76029 24.2287Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M39.2378 34.0717C39.6518 34.0717 39.9874 33.7327 39.9874 33.3146C39.9874 32.8964 39.6518 32.5574 39.2378 32.5574C38.8239 32.5574 38.4883 32.8964 38.4883 33.3146C38.4883 33.7327 38.8239 34.0717 39.2378 34.0717Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2486 26.5002H33.2427C33.4415 26.5002 33.6322 26.4204 33.7728 26.2785C33.9134 26.1364 33.9923 25.9438 33.9923 25.743V16.6573C33.9923 16.4565 33.9134 16.2639 33.7728 16.1219C33.6322 15.9798 33.4415 15.9001 33.2427 15.9001H24.2486C24.0497 15.9001 23.8591 15.9798 23.7185 16.1219C23.5779 16.2639 23.4989 16.4565 23.499 16.6573V25.743C23.499 25.9439 23.5779 26.1364 23.7185 26.2785C23.8591 26.4205 24.0498 26.5003 24.2486 26.5002ZM32.4932 24.9859H24.998V17.4145H32.4932V24.9859Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7574 26.5002H19.7515C19.9503 26.5002 20.141 26.4204 20.2816 26.2785C20.4222 26.1364 20.5011 25.9438 20.501 25.743V16.6573C20.501 16.4565 20.4222 16.2639 20.2816 16.1219C20.141 15.9798 19.9503 15.9001 19.7515 15.9001H10.7574C10.5585 15.9001 10.3679 15.9798 10.2273 16.1219C10.0867 16.2639 10.0077 16.4565 10.0078 16.6573V25.743C10.0078 25.9439 10.0867 26.1364 10.2273 26.2785C10.3679 26.4205 10.5586 26.5003 10.7574 26.5002ZM19.002 24.9859H11.5069V17.4145H19.002V24.9859Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7574 40.1288H19.7515C19.9503 40.1289 20.141 40.0491 20.2816 39.9071C20.4222 39.7651 20.5011 39.5725 20.501 39.3717V30.286C20.501 30.0851 20.4222 29.8926 20.2816 29.7505C20.141 29.6085 19.9503 29.5287 19.7515 29.5288H10.7574C10.5585 29.5288 10.3679 29.6085 10.2273 29.7505C10.0867 29.8926 10.0077 30.0852 10.0078 30.286V39.3716C10.0078 39.5725 10.0867 39.765 10.2273 39.9071C10.3679 40.0491 10.5586 40.1289 10.7574 40.1288ZM19.002 38.6145H11.5069V31.0431H19.002V38.6145Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2486 40.1288H33.2427C33.4415 40.1289 33.6322 40.0491 33.7728 39.9071C33.9134 39.7651 33.9923 39.5725 33.9923 39.3717V30.286C33.9923 30.0851 33.9134 29.8926 33.7728 29.7505C33.6322 29.6085 33.4415 29.5287 33.2427 29.5288H24.2486C24.0497 29.5288 23.8591 29.6085 23.7185 29.7505C23.5779 29.8926 23.4989 30.0852 23.499 30.286V39.3716C23.499 39.5725 23.5779 39.765 23.7185 39.9071C23.8591 40.0491 24.0498 40.1289 24.2486 40.1288ZM32.4932 38.6145H24.998V31.0431H32.4932V38.6145Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ d("defs", {
    children: [/* @__PURE__ */ d("linearGradient", {
      id: "paint0_linear",
      x1: "6.47032",
      y1: "21.5999",
      x2: "15.6298",
      y2: "30.7593",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    }), /* @__PURE__ */ d("linearGradient", {
      id: "paint1_linear",
      x1: "20.2095",
      y1: "21.5999",
      x2: "29.369",
      y2: "30.7593",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    }), /* @__PURE__ */ d("linearGradient", {
      id: "paint2_linear",
      x1: "6.47032",
      y1: "35.3392",
      x2: "15.6298",
      y2: "44.4987",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    }), /* @__PURE__ */ d("linearGradient", {
      id: "paint3_linear",
      x1: "20.2095",
      y1: "35.3392",
      x2: "29.369",
      y2: "44.4987",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    })]
  })]
}), te = (t) => /* @__PURE__ */ o(y, {
  width: "23",
  height: "17",
  viewBox: "0 0 23 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ o("path", {
    d: "M1 8.24182L7.72961 14.9714L21.701 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  })
}), ut = (t) => /* @__PURE__ */ d(y, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ...t,
  children: [/* @__PURE__ */ o("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "#1DCE93"
  }), /* @__PURE__ */ o("path", {
    d: "M8 9l3.5 4 10.5-11.5",
    stroke: "#1DCE93"
  })]
}), Ct = (t) => /* @__PURE__ */ d(y, {
  width: "27",
  height: "28",
  viewBox: "0 0 27 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("ellipse", {
    cx: "14.3144",
    cy: "15.2728",
    rx: "12.4091",
    ry: "12.0909",
    fill: "url(#paint0_linear_5562_2543)"
  }), /* @__PURE__ */ o("path", {
    d: "M13.6869 3.49023C13.4473 3.49023 13.2097 3.49862 12.9734 3.51197C19.5152 3.88546 24.6268 9.24487 24.6268 15.7303C24.6268 22.2158 19.5152 27.5752 12.9735 27.9487C13.2098 27.962 13.4474 27.9704 13.687 27.9704C20.517 27.9704 26.0538 22.4904 26.0538 15.7303C26.0538 8.9703 20.517 3.49023 13.6869 3.49023Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M19.395 11.0227L14.9414 17.1165C14.7317 17.4019 14.4062 17.5821 14.0507 17.6098C13.6952 17.6374 13.3453 17.5096 13.0931 17.26C12.841 17.0104 12.7119 16.6641 12.7398 16.3123C12.7676 15.9604 12.9498 15.6383 13.2382 15.4307L19.395 11.0227Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M12.7356 3.53007C13.05 3.50629 13.3665 3.49041 13.687 3.49041C14.0074 3.49041 14.3239 3.50624 14.6383 3.53007V2.07809H15.8274C16.2214 2.07809 16.5408 1.76192 16.5408 1.37193C16.5408 0.981943 16.2214 0.665771 15.8274 0.665771H11.5465C11.1525 0.665771 10.8331 0.981943 10.8331 1.37193C10.8331 1.76192 11.1525 2.07809 11.5465 2.07809H12.7356V3.53007Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M26.053 4.74536L24.7077 6.07688L23.3624 4.74536L24.7077 3.41384L26.053 4.74536Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4888 16.5845C12.7163 17.2693 13.3687 17.7331 14.1049 17.7335C14.1492 17.7335 14.1934 17.7317 14.2381 17.7284C14.7346 17.6907 15.1892 17.4418 15.4817 17.0476L19.9493 11.0069C20.0865 10.8212 20.0656 10.5655 19.8999 10.4035C19.7343 10.2415 19.4729 10.2211 19.283 10.3552L13.1054 14.7257C12.5101 15.1494 12.2612 15.8997 12.4888 16.5845ZM13.6661 15.481L17.4343 12.8149L14.7094 16.4991C14.5812 16.6721 14.3816 16.7813 14.1637 16.7976C13.9465 16.8134 13.733 16.7362 13.5785 16.5861C13.4244 16.4354 13.3454 16.2263 13.3623 16.0138C13.3791 15.8013 13.4901 15.6066 13.6661 15.481Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7547 3.77114C14.7669 3.77207 14.779 3.77251 14.7911 3.77251C15.0546 3.77251 15.2682 3.5636 15.2682 3.30586V2.3333H15.9839C16.6427 2.3333 17.1767 1.81098 17.1767 1.16665C17.1767 0.52232 16.6427 0 15.9839 0H11.6897C11.0309 0 10.4969 0.522375 10.4969 1.1667C10.4969 1.81103 11.0309 2.33335 11.6897 2.33335H12.4054V3.30586C12.4055 3.43574 12.4608 3.55977 12.5582 3.64809C12.6554 3.73696 12.7863 3.78159 12.9189 3.77114C13.5297 3.72012 14.1439 3.72012 14.7547 3.77114ZM14.3135 2.8103C14.1477 2.80347 13.9892 2.8003 13.8364 2.8003C13.6836 2.8003 13.5252 2.80347 13.3592 2.8103V1.86695C13.3592 1.74319 13.309 1.62446 13.2195 1.53691C13.13 1.44935 13.0086 1.40024 12.8821 1.4003H11.6892C11.5574 1.4003 11.4506 1.29584 11.4506 1.16695C11.4506 1.03805 11.5575 0.933594 11.6892 0.933594H15.9835C16.1153 0.933594 16.2221 1.03805 16.2221 1.16695C16.2221 1.29584 16.1152 1.4003 15.9835 1.4003H14.7907C14.6641 1.40024 14.5427 1.44941 14.4532 1.53691C14.3637 1.62441 14.3135 1.74313 14.3135 1.86695V2.8103Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M22.531 7.2871C22.338 7.28705 22.1641 7.17335 22.0903 6.99901C22.0165 6.82466 22.0572 6.62396 22.1937 6.49052L23.8809 4.84077C24.0672 4.65855 24.3693 4.65855 24.5556 4.84077C24.7419 5.02298 24.7419 5.31846 24.5556 5.50068L22.8684 7.15044C22.779 7.23805 22.6576 7.28727 22.531 7.2871Z",
    fill: "#428DFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.556 6.16049C24.6454 6.24805 24.7668 6.29721 24.8933 6.29721C25.0198 6.29721 25.1412 6.24805 25.2306 6.16049L26.58 4.84028C26.6695 4.75278 26.7198 4.63411 26.7198 4.51035C26.7198 4.3866 26.6695 4.26792 26.58 4.18042L25.2306 2.8606C25.1412 2.77304 25.0198 2.72388 24.8933 2.72388C24.7668 2.72388 24.6454 2.77304 24.556 2.8606L23.2061 4.18037C23.1166 4.26787 23.0663 4.38654 23.0663 4.5103C23.0663 4.63406 23.1166 4.75273 23.2061 4.84023L24.556 6.16049ZM24.8929 5.17104L24.2177 4.51069L24.8929 3.85083L25.5676 4.51069L24.8929 5.17104Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M13.837 5.13335C13.7105 5.1334 13.5891 5.08429 13.4996 4.99674C13.4101 4.90918 13.3599 4.79046 13.3599 4.6667V3.2667C13.3599 3.00896 13.5736 2.80005 13.837 2.80005C14.1006 2.80005 14.3142 3.00901 14.3142 3.2667V4.6667C14.3142 4.79051 14.264 4.90924 14.1745 4.99674C14.085 5.08424 13.9636 5.1334 13.837 5.13335Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M13.837 28C13.7105 28.0001 13.5891 27.951 13.4996 27.8634C13.4101 27.7759 13.3599 27.6572 13.3599 27.5334V26.1334C13.3599 25.8757 13.5736 25.6667 13.837 25.6667C14.1006 25.6667 14.3142 25.8757 14.3142 26.1334V27.5334C14.3142 27.6572 14.264 27.7759 14.1745 27.8634C14.085 27.951 13.9636 28.0001 13.837 28Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M26.1649 15.8666H24.7335C24.47 15.8666 24.2564 15.6577 24.2564 15.4C24.2564 15.1423 24.4701 14.9333 24.7335 14.9333H26.1649C26.4285 14.9333 26.6421 15.1423 26.6421 15.4C26.6421 15.6577 26.4285 15.8666 26.1649 15.8666Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M19.2458 6.57108C19.0754 6.57097 18.918 6.48199 18.8328 6.33762C18.7477 6.19324 18.7477 6.0154 18.8329 5.87108L19.5486 4.65882C19.6805 4.4357 19.9722 4.3593 20.2004 4.48814C20.4286 4.61699 20.5068 4.90229 20.3752 5.12553L19.6595 6.33778C19.5743 6.48238 19.4165 6.57135 19.2458 6.57108Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M24.5025 21.9331C24.4189 21.9332 24.3368 21.9116 24.2644 21.8707L23.0249 21.1707C22.8772 21.0874 22.7861 20.9333 22.7861 20.7664C22.786 20.5996 22.877 20.4455 23.0247 20.3621C23.1724 20.2787 23.3544 20.2787 23.5021 20.3622L24.7415 21.0622C24.9287 21.1678 25.02 21.3833 24.964 21.5874C24.9079 21.7916 24.7186 21.9334 24.5025 21.9331Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M19.9625 26.3744C19.7918 26.3747 19.634 26.2857 19.5487 26.141L18.833 24.9288C18.7477 24.7844 18.7476 24.6064 18.8329 24.4619C18.9182 24.3174 19.0758 24.2285 19.2463 24.2285C19.4169 24.2286 19.5744 24.3176 19.6597 24.4621L20.3754 25.6744C20.4606 25.8187 20.4606 25.9966 20.3755 26.1409C20.2903 26.2853 20.1329 26.3743 19.9625 26.3744Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M23.2639 10.4998C23.0478 10.5001 22.8585 10.3583 22.8024 10.1541C22.7464 9.94999 22.8377 9.73452 23.0249 9.62892L24.2643 8.92892C24.4926 8.80024 24.7843 8.87674 24.916 9.09992C25.0477 9.3231 24.9696 9.60841 24.7415 9.73736L23.502 10.4374C23.4296 10.4783 23.3475 10.4999 23.2639 10.4998Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M13.7591 28C12.7859 27.9991 11.8159 27.8909 10.8674 27.6773C10.6106 27.6197 10.4501 27.3693 10.5091 27.1181C10.568 26.867 10.824 26.7101 11.0808 26.7677C15.868 27.8486 20.8431 25.9481 23.6141 21.98C26.3851 18.0119 26.3851 12.7881 23.6141 8.81998C20.8431 4.85191 15.868 2.95141 11.0808 4.03225C10.824 4.0899 10.568 3.933 10.5091 3.68182C10.4501 3.43064 10.6106 3.18028 10.8674 3.12264C15.6926 2.03534 20.728 3.74925 23.8205 7.53154C26.913 11.3138 27.5153 16.495 25.3698 20.8598C23.2243 25.2245 18.7108 28.0001 13.7591 28Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54277 7.4665H7.15705C6.89353 7.4665 6.67993 7.25754 6.67993 6.99985C6.67993 6.74211 6.89353 6.5332 7.15705 6.5332H9.54277C9.8063 6.5332 10.0199 6.74216 10.0199 6.99985C10.0199 7.25759 9.8063 7.4665 9.54277 7.4665Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54269 10.7333H4.77131C4.50778 10.7333 4.29419 10.5244 4.29419 10.2667C4.29419 10.009 4.50784 9.80005 4.77131 9.80005H9.54269C9.80621 9.80005 10.0198 10.009 10.0198 10.2667C10.0199 10.5244 9.80621 10.7333 9.54269 10.7333Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54266 13.9999H2.38557C2.12204 13.9999 1.90845 13.791 1.90845 13.5333C1.90845 13.2756 2.1221 13.0667 2.38557 13.0667H9.54266C9.80619 13.0667 10.0198 13.2756 10.0198 13.5333C10.0198 13.791 9.80619 13.9999 9.54266 13.9999Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54275 17.2665H0.477121C0.213595 17.2665 0 17.0576 0 16.7999C0 16.5422 0.21365 16.3333 0.477121 16.3333H9.54275C9.80628 16.3333 10.0199 16.5422 10.0199 16.7999C10.0199 17.0576 9.80628 17.2665 9.54275 17.2665Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54295 20.5334H3.34016C3.07663 20.5334 2.86304 20.3245 2.86304 20.0667C2.86304 19.809 3.07669 19.6001 3.34016 19.6001H9.54295C9.80648 19.6001 10.0201 19.809 10.0201 20.0667C10.0201 20.3245 9.80648 20.5334 9.54295 20.5334Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M9.54248 23.8002H6.20252C5.939 23.8002 5.7254 23.5913 5.7254 23.3336C5.7254 23.0758 5.93905 22.8669 6.20252 22.8669H9.54248C9.80601 22.8669 10.0196 23.0758 10.0196 23.3336C10.0196 23.5913 9.80601 23.8002 9.54248 23.8002Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("defs", {
    children: /* @__PURE__ */ d("linearGradient", {
      id: "paint0_linear_5562_2543",
      x1: "-3.23478",
      y1: "15.2718",
      x2: "13.8584",
      y2: "32.8148",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    })
  })]
}), mt = (t) => /* @__PURE__ */ o("svg", {
  version: "1.1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 490 490",
  ...t,
  children: /* @__PURE__ */ o("polygon", {
    points: "512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512  512,452.922 315.076,256  "
  })
}), Je = (t) => /* @__PURE__ */ d("svg", {
  width: "44",
  height: "28",
  viewBox: "0 0 44 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    d: "M16 27L25 22L16 27Z",
    fill: "#EB7A0C"
  }), /* @__PURE__ */ o("path", {
    d: "M18.1626 18.7551L15.2432 27.9617L23.8906 22.3676L18.1626 18.7551Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M18.1628 18.7552L15.29 27.9618L13.0537 15.9224L42.9781 1.05029L18.1628 18.7552Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M42.2791 2.34748C42.0179 2.35575 41.7735 2.22252 41.6449 2.00171L18.1631 18.7551L32.7604 27.9617L42.5027 2.30343C42.4308 2.32883 42.3554 2.34368 42.2791 2.34748Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M38.5333 3.69701L18 18.3333L31.2 26L40 3L38.5333 3.69701Z",
    fill: "#E3E7F2"
  }), /* @__PURE__ */ o("path", {
    d: "M40.4641 1L1 8.80133L13.2868 15L41 1.42276C40.7553 1.38353 40.551 1.22237 40.4641 1Z",
    fill: "white"
  }), /* @__PURE__ */ o("path", {
    d: "M38.4614 2L3 9.94445L13.1318 15L39 2.44331C38.754 2.40209 38.5487 2.23318 38.4614 2Z",
    fill: "#E3E7F2"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9774 27.9951C32.8363 27.9952 32.6981 27.956 32.5797 27.8824L17.9824 18.7895C17.7813 18.6644 17.6571 18.4527 17.6502 18.2232C17.6432 17.9936 17.7543 17.7753 17.9474 17.6392L35.4591 5.29973L13.6038 16.0272C13.3922 16.1313 13.1408 16.1301 12.9303 16.0238L0.476277 9.72865C0.203755 9.59082 0.0508855 9.3039 0.0941898 9.01157C0.137494 8.71923 0.367668 8.4844 0.669407 8.42473L43.0344 0.0339835C43.3263 -0.0290165 43.6287 0.0849835 43.7978 0.321567C43.8131 0.342484 43.827 0.3644 43.8391 0.38715C43.9073 0.508817 43.9361 0.647234 43.9218 0.784734C43.9183 0.820984 43.9116 0.856817 43.9018 0.891984C43.8951 0.916984 43.8871 0.94165 43.8775 0.965734L33.6624 27.5374C33.5569 27.8126 33.2833 27.9954 32.9774 27.9951ZM19.6624 18.1672L32.6089 26.2315L41.6709 2.65907L19.6624 18.1672ZM13.276 14.6166L2.95602 9.40007L38.0722 2.44523L13.276 14.6166Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M15.4611 27.9951C15.1393 27.9953 14.8553 27.7937 14.762 27.4987C14.6686 27.2036 14.7878 26.8847 15.0555 26.7137L23.7027 21.1891C23.9197 21.0483 24.1987 21.0298 24.4339 21.1406C24.669 21.2513 24.8241 21.4743 24.8404 21.7249C24.8566 21.9755 24.7314 22.2152 24.5125 22.353L15.8653 27.8776C15.7456 27.9541 15.605 27.995 15.4611 27.9951Z",
    fill: "#428DFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.465 27.9937C15.4793 27.9944 15.4935 27.9951 15.5071 27.9951C15.8286 27.9953 16.1125 27.7935 16.2056 27.4985L19.0081 18.6283L43.6282 1.27987C43.9345 1.06378 44.0163 0.658534 43.8162 0.348617C43.6161 0.0387006 43.2013 -0.0720494 42.8627 0.0941173L12.9383 14.7826C12.6522 14.923 12.4956 15.2261 12.5526 15.5292L14.7886 27.42C14.8486 27.738 15.1282 27.9752 15.465 27.9937ZM15.6873 24.3114L14.0851 15.7909L35.4593 5.29978L17.9475 17.6393C17.8206 17.7288 17.7273 17.8554 17.6817 18L15.6873 24.3114Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8734 27.7112C15.011 27.8897 15.2288 27.995 15.4605 27.995C15.6046 27.9952 15.7455 27.9543 15.8654 27.8774L24.5126 22.3529C24.7169 22.2223 24.8391 22.002 24.8376 21.7667C24.8361 21.5314 24.7114 21.3124 24.5054 21.1842L18.7777 17.6159C18.5856 17.4963 18.3461 17.47 18.1308 17.5449C17.9155 17.6199 17.7494 17.7872 17.6821 17.997L14.7627 27.0899C14.6947 27.3021 14.7357 27.5327 14.8734 27.7112ZM16.7606 25.6241L18.7934 19.2942L22.7805 21.7785L16.7606 25.6241Z",
    fill: "#007AFF"
  })]
}), ft = (t) => /* @__PURE__ */ o("svg", {
  width: "12",
  height: "22",
  viewBox: "0 0 12 22",
  fill: "none",
  ...t,
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78897 22V11.9648H11.327L11.8567 8.05387H7.78897V5.5569C7.78897 4.42458 8.11918 3.65298 9.82473 3.65298L12 3.65201V0.154089C11.6237 0.106512 10.3325 0 8.8303 0C5.69405 0 3.54703 1.82256 3.54703 5.16969V8.05387H0V11.9648H3.54703V22H7.78897Z",
    fill: "currentColor"
  })
}), Ke = (t) => /* @__PURE__ */ d("svg", {
  fill: "#fff",
  viewBox: "0 0 512 512",
  ...t,
  children: [/* @__PURE__ */ o("rect", {
    width: "512",
    height: "512",
    fill: "currentColor",
    rx: "15%"
  }), /* @__PURE__ */ o("circle", {
    cx: "142",
    cy: "138",
    r: "37"
  }), /* @__PURE__ */ o("path", {
    stroke: "#fff",
    strokeWidth: "66",
    d: "M244 194v198M142 194v198"
  }), /* @__PURE__ */ o("path", {
    d: "M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32"
  })]
}), ht = (t) => /* @__PURE__ */ d(y, {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55881 27.8538C1.65237 27.9475 1.7794 28 1.91187 27.9998C2.04435 28 2.17138 27.9474 2.26494 27.8538L21.7034 8.45359C21.797 8.36016 21.8497 8.23338 21.8497 8.10122C21.8497 7.96906 21.797 7.84229 21.7034 7.74886L20.2912 6.33939C20.1975 6.2459 20.0705 6.19336 19.9381 6.19336C19.8057 6.19336 19.6786 6.2459 19.585 6.33939L0.146319 25.7397C0.0526458 25.8331 0 25.9599 0 26.092C0 26.2242 0.0526458 26.351 0.146319 26.4444L1.55881 27.8538ZM1.91198 26.7968L1.20563 26.092L19.9383 7.39648L20.6444 8.10122L1.91198 26.7968Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M16.9985 12.9367C16.866 12.9368 16.739 12.8842 16.6454 12.7906L15.2361 11.3841C15.11 11.2582 15.0607 11.0748 15.1069 10.9028C15.1531 10.7309 15.2876 10.5966 15.4599 10.5504C15.6322 10.5043 15.816 10.5536 15.9422 10.6794L17.3515 12.086C17.4943 12.2285 17.537 12.4428 17.4597 12.629C17.3825 12.8152 17.2005 12.9366 16.9985 12.9367Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M19.9739 4.48529C19.8415 4.48534 19.7144 4.4328 19.6208 4.33937C19.5271 4.24588 19.4746 4.1191 19.4746 3.98695V0.49834C19.4746 0.223094 19.6982 0 19.9739 0C20.2497 0 20.4733 0.223149 20.4733 0.49834V3.98695C20.4733 4.1191 20.4207 4.24594 20.3271 4.33937C20.2334 4.43286 20.1064 4.48534 19.9739 4.48529Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M19.9739 15.9476C19.8415 15.9477 19.7144 15.8951 19.6208 15.8017C19.5271 15.7082 19.4746 15.5815 19.4746 15.4493V11.9607C19.4746 11.6855 19.6982 11.4624 19.9739 11.4624C20.2497 11.4624 20.4733 11.6856 20.4733 11.9607V15.4493C20.4733 15.5815 20.4207 15.7083 20.3271 15.8017C20.2334 15.8951 20.1064 15.9476 19.9739 15.9476Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M27.4645 8.47227H23.9691C23.6933 8.47227 23.4697 8.24912 23.4697 7.97393C23.4697 7.69874 23.6933 7.47559 23.9691 7.47559H27.4645C27.7403 7.47559 27.9639 7.69874 27.9639 7.97393C27.9639 8.24912 27.7403 8.47227 27.4645 8.47227Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M15.9792 8.47227H12.4837C12.2079 8.47227 11.9844 8.24912 11.9844 7.97393C11.9844 7.69874 12.208 7.47559 12.4837 7.47559H15.9792C16.255 7.47559 16.4785 7.69874 16.4785 7.97393C16.4785 8.24912 16.255 8.47227 15.9792 8.47227Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M22.97 5.48196C22.7681 5.48191 22.586 5.36051 22.5087 5.17431C22.4315 4.98812 22.4741 4.77379 22.6169 4.63126L25.0886 2.16424C25.2836 1.96967 25.5997 1.96967 25.7947 2.16424C25.9897 2.35887 25.9897 2.67435 25.7947 2.86898L23.323 5.33593C23.2295 5.42959 23.1025 5.48213 22.97 5.48196Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M25.4419 13.9295C25.3095 13.9297 25.1824 13.8771 25.0889 13.7835L22.6172 11.3165C22.4252 11.1214 22.4266 10.8083 22.6203 10.615C22.8141 10.4216 23.1277 10.4202 23.3233 10.6118L25.7949 13.0788C25.9377 13.2213 25.9804 13.4357 25.9031 13.6219C25.8259 13.8081 25.6438 13.9295 25.4419 13.9295Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M16.9783 5.48206C16.8459 5.48223 16.7188 5.42968 16.6253 5.33603L14.1536 2.86902C13.9586 2.67444 13.9586 2.35892 14.1536 2.16428C14.3486 1.96965 14.6647 1.96965 14.8597 2.16428L17.3313 4.6313C17.4741 4.77383 17.5168 4.98816 17.4395 5.17436C17.3623 5.36061 17.1802 5.482 16.9783 5.48206Z",
    fill: "#007AFF"
  })]
}), gt = (t) => /* @__PURE__ */ o("svg", {
  version: "1.1",
  x: "0px",
  y: "0px",
  width: "24.75px",
  height: "24.75px",
  viewBox: "0 0 24.75 24.75",
  ...t,
  children: /* @__PURE__ */ o("g", {
    children: /* @__PURE__ */ o("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z M22.75,10.375H2 c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2C24.75,11.271,23.855,10.375,22.75,10.375z M22.75,18.875H2 c-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2S23.855,18.875,22.75,18.875z",
      fill: "currentColor"
    })
  })
}), e1 = (t) => /* @__PURE__ */ d("svg", {
  width: "26",
  height: "44",
  viewBox: "0 0 26 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    d: "M3.59006 0H12.4099C13.8404 0 15 1.13023 15 2.5244V40.4756C15 41.8698 13.8404 43 12.4099 43H3.59006C2.15962 43 1 41.8698 1 40.4756V2.5244C1 1.13023 2.15954 0 3.59006 0Z",
    fill: "white"
  }), /* @__PURE__ */ o("path", {
    d: "M14.5901 0H23.4099C24.8404 0 26 1.13023 26 2.5244V40.4756C26 41.8698 24.8404 43 23.4099 43H14.5901C13.1596 43 12 41.8698 12 40.4756V2.5244C12 1.13023 13.1596 0 14.5901 0Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("path", {
    d: "M5.61923 0H20.3808C21.8273 0 23 1.13023 23 2.5244V40.4756C23 41.8698 21.8273 43 20.3808 43H5.61923C4.17268 43 3 41.8698 3 40.4756V2.5244C3 1.13023 4.17259 0 5.61923 0Z",
    fill: "#E3E7F2"
  }), /* @__PURE__ */ o("rect", {
    x: "11",
    y: "5",
    width: "14",
    height: "29",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ o("rect", {
    x: "3",
    y: "5",
    width: "20",
    height: "29",
    fill: "url(#paint0_linear)"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43024 44H22.5696C24.4173 43.9979 25.9147 42.5528 25.9169 40.7695V3.23056C25.9147 1.44719 24.4173 0.0020625 22.5696 0H3.43024C1.58255 0.0020625 0.0852338 1.44719 0.0830078 3.23056V40.7694C0.0852338 42.5528 1.58255 43.9979 3.43024 44ZM1.60267 3.23056C1.60383 2.25689 2.42141 1.46781 3.43024 1.4667H22.5696C23.5785 1.46781 24.396 2.25689 24.3972 3.23056V40.7695C24.396 41.7432 23.5785 42.5323 22.5696 42.5334H3.43024C2.42141 42.5323 1.60383 41.7432 1.60267 40.7695V3.23056Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96094 38.8667C9.96094 40.4867 11.3217 41.8 13.0002 41.8C14.678 41.7982 16.0376 40.486 16.0394 38.8667C16.0394 37.2466 14.6787 35.9333 13.0002 35.9333C11.3217 35.9333 9.96094 37.2466 9.96094 38.8667ZM11.4805 38.8667C11.4805 38.0566 12.1609 37.4 13.0002 37.4C13.839 37.4009 14.5189 38.057 14.5198 38.8667C14.5198 39.6767 13.8395 40.3333 13.0002 40.3333C12.1609 40.3333 11.4805 39.6767 11.4805 38.8667Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M25.1569 35.2H0.842795C0.423145 35.2 0.0830078 34.8716 0.0830078 34.4667C0.0830078 34.0618 0.423234 33.7334 0.842795 33.7334H25.157C25.5766 33.7334 25.9168 34.0617 25.9168 34.4667C25.9168 34.8717 25.5765 35.2 25.1569 35.2Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M25.1569 5.86676H0.842795C0.423145 5.86676 0.0830078 5.53839 0.0830078 5.13345C0.0830078 4.72851 0.423234 4.40015 0.842795 4.40015H25.157C25.5766 4.40015 25.9168 4.72851 25.9168 5.13345C25.9168 5.53839 25.5765 5.86676 25.1569 5.86676Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M13.0002 3.6668H9.96096C9.54131 3.6668 9.20117 3.33844 9.20117 2.9335C9.20117 2.52856 9.5414 2.2002 9.96096 2.2002H13.0002C13.4198 2.2002 13.76 2.52856 13.76 2.9335C13.76 3.33844 13.4198 3.6668 13.0002 3.6668Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M16.0391 3.6668H15.2793C14.8597 3.6668 14.5195 3.33844 14.5195 2.9335C14.5195 2.52856 14.8597 2.2002 15.2793 2.2002H16.0391C16.4588 2.2002 16.7989 2.52856 16.7989 2.9335C16.7989 3.33844 16.4588 3.6668 16.0391 3.6668Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("defs", {
    children: /* @__PURE__ */ d("linearGradient", {
      id: "paint0_linear",
      x1: "-7.94061",
      y1: "25.9454",
      x2: "22.1254",
      y2: "39.422",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ o("stop", {
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.1717",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2001",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2007",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2014",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2023",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.205",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.2522",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.26",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.3974",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.42",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4201",
        stopColor: "#DAE4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4207",
        stopColor: "#EBEBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4214",
        stopColor: "#F6F1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4223",
        stopColor: "#FDF4F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.425",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.4894",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5",
        stopColor: "#F9F2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5001",
        stopColor: "#E8EBF4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5003",
        stopColor: "#DDE5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.5005",
        stopColor: "#D6E2F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.501",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.7062",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.74",
        stopColor: "#D4E1F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.741",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.8346",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.85",
        stopColor: "#FFF5F4"
      }), /* @__PURE__ */ o("stop", {
        offset: "0.851",
        stopColor: "#D4E1F4"
      })]
    })
  })]
}), oe = (t) => /* @__PURE__ */ o("svg", {
  width: "11",
  height: "18",
  viewBox: "0 0 11 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ o("path", {
    d: "M1 16.9975L8.9975 9L1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  })
}), t1 = (t) => /* @__PURE__ */ d("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.64L6.30004 16.7104L4.93 14.6834L2.48959 14.5104L2.31658 12.07L0.28963 10.7L1.36 8.5L0.28963 6.30004L2.31658 4.93L2.48959 2.48959L4.93 2.31658L6.30004 0.28963L8.5 1.36L10.7 0.28963L12.07 2.31658L14.5104 2.48959L14.6834 4.93L16.7104 6.30004L15.64 8.5L16.7104 10.7L14.6834 12.07L14.5104 14.5104L12.07 14.6834L10.7 16.7104L8.5 15.64Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M5 8.59165L7.2756 11L12 6",
    stroke: "currentColor",
    strokeWidth: "2"
  })]
}), kt = (t) => /* @__PURE__ */ o("svg", {
  width: "21",
  height: "18",
  viewBox: "0 0 21 18",
  fill: "none",
  ...t,
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4208 0.332767C19.5876 0.852969 18.6669 1.2313 17.6829 1.43373C16.899 0.551344 15.7787 0 14.5385 0C12.1611 0 10.2317 2.03467 10.2317 4.54397C10.2317 4.90039 10.2687 5.24584 10.3427 5.57861C6.76208 5.38887 3.58794 3.58201 1.46175 0.829323C1.09057 1.50293 0.878621 2.28439 0.878621 3.11659C0.878621 4.69219 1.63893 6.08324 2.79566 6.89814C2.0903 6.87623 1.42475 6.66976 0.842736 6.33181V6.38717C0.842736 8.58966 2.32804 10.4271 4.30059 10.8429C3.9395 10.9496 3.55822 11.0032 3.16517 11.0032C2.88762 11.0032 2.6168 10.9756 2.35439 10.9225C2.90276 12.7271 4.49291 14.0414 6.37855 14.0766C4.90447 15.2958 3.04574 16.0224 1.02777 16.0224C0.680132 16.0224 0.336422 16.0017 0 15.9601C1.90639 17.2474 4.17219 18 6.60452 18C14.5301 18 18.8626 11.0771 18.8626 5.07167C18.8626 4.87386 18.8592 4.67662 18.8519 4.48284C19.6936 3.84211 20.4247 3.0422 21 2.13098C20.2285 2.49201 19.3975 2.73654 18.5262 2.84611C19.416 2.28439 20.0989 1.39393 20.4208 0.332767Z",
    fill: "currentColor"
  })
}), Ee = (t) => /* @__PURE__ */ o("svg", {
  width: "11",
  height: "18",
  viewBox: "0 0 11 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ o("path", {
    d: "M9.99707 16.9975L1.99957 9L9.99707 1",
    stroke: "currentColor",
    strokeWidth: "2",
    vectorEffect: "non-scaling-stroke"
  })
}), Lt = (t) => /* @__PURE__ */ o(y, {
  width: "98",
  height: "31",
  viewBox: "0 0 98 31",
  fill: "none",
  className: "yta-logo",
  ...t,
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1378 17.933V8.74533H30.8172V5.68277H26.1378V0H22.3943V17.831C22.3943 19.7366 22.9569 21.2508 24.0822 22.3738C25.2075 23.4967 26.5667 24.0582 28.16 24.0582C29.7532 24.0582 31.2071 23.457 32.5218 22.2547L30.9843 19.5664C30.249 20.3604 29.4802 20.7574 28.678 20.7574C27.8758 20.7574 27.2519 20.5022 26.8063 19.9918C26.3606 19.4813 26.1378 18.7951 26.1378 17.933ZM13.3363 21.1317C13.3363 25.3967 11.6874 27.5291 8.38949 27.5291C5.91609 27.5291 4.24489 26.3608 3.37585 24.0241L0 25.4874C0.668489 27.2569 1.74363 28.618 3.22544 29.5708C4.70726 30.5236 6.42859 31 8.38949 31C10.952 31 13.041 30.1606 14.6565 28.4819C16.2721 26.8031 17.0798 24.3871 17.0798 21.2338V5.68277H13.3363V13.8496C13.2026 15.483 12.7792 16.7023 12.0662 17.5077C11.3531 18.313 10.2223 18.7157 8.6736 18.7157C7.12494 18.7157 6.03309 18.279 5.39802 17.4056C4.76296 16.5322 4.44543 15.0406 4.44543 12.9308V5.71679H0.70191V14.6323C0.70191 19.7819 3.00816 22.3568 7.62074 22.3568C9.93817 22.3568 11.8433 21.5741 13.3363 20.0088V21.1317ZM49.9025 23.7859H46.4932V21.3699C45.0225 23.1621 43.0505 24.0582 40.5771 24.0582C38.7276 24.0582 37.1957 23.5251 35.9812 22.4588C34.7668 21.3926 34.1596 19.9691 34.1596 18.1883C34.1596 16.4074 34.8058 15.0746 36.0982 14.1899C37.3906 13.3052 39.1398 12.8628 41.3458 12.8628H46.1924V12.1822C46.1924 9.77752 44.8777 8.57519 42.2483 8.57519C40.5994 8.57519 38.8836 9.1877 37.101 10.4127L35.4297 8.03074C37.5912 6.28393 40.0423 5.41054 42.7831 5.41054C44.8777 5.41054 46.5879 5.94932 47.9137 7.02689C49.2395 8.10447 49.9025 9.80021 49.9025 12.1142V23.7859ZM46.1589 15.517V17.0483C46.1589 18.2053 45.7133 19.124 44.822 19.8046C43.9306 20.4852 42.8889 20.8255 41.6968 20.8255C40.5047 20.8255 39.5744 20.5929 38.9059 20.1279C38.2374 19.6628 37.9031 18.9879 37.9031 18.1032C37.9031 16.3791 39.2512 15.517 41.9475 15.517H46.1589ZM54.6153 21.506C54.6153 20.8028 54.8548 20.2073 55.3339 19.7195C55.813 19.2318 56.3979 18.9879 57.0887 18.9879C57.7794 18.9879 58.3699 19.2318 58.8602 19.7195C59.3504 20.2073 59.5955 20.8028 59.5955 21.506C59.5955 22.2093 59.3504 22.8105 58.8602 23.3095C58.3699 23.8086 57.7794 24.0582 57.0887 24.0582C56.3979 24.0582 55.813 23.8086 55.3339 23.3095C54.8548 22.8105 54.6153 22.2093 54.6153 21.506ZM70.5921 24.0582C72.5084 24.0582 74.0793 23.5421 75.3049 22.5099C76.5305 21.4777 77.1432 20.0995 77.1432 18.3754C77.1432 16.6513 76.5416 15.3809 75.3383 14.5642C74.7367 14.1559 74.1741 13.8383 73.6504 13.6114C73.1268 13.3846 72.5864 13.1804 72.0293 12.9989C71.4723 12.8174 70.8316 12.6359 70.1074 12.4544C69.3832 12.273 68.8206 12.0801 68.4195 11.876C67.8401 11.6037 67.5505 11.1727 67.5505 10.5829C67.5505 9.92499 67.829 9.43158 68.3861 9.10263C68.9432 8.77369 69.6673 8.60922 70.5587 8.60922C72.2522 8.60922 73.8231 9.09696 75.2715 10.0724L76.6753 7.24808C74.8481 6.02305 72.9095 5.41054 70.8595 5.41054C68.8094 5.41054 67.1438 5.91529 65.8625 6.92481C64.5813 7.93433 63.9407 9.27844 63.9407 10.9572C63.9407 13.3392 65.7901 15.0406 69.4891 16.0615C69.5782 16.0842 69.7119 16.1295 69.8902 16.1976C72.2522 16.9235 73.4332 17.7402 73.4332 18.6476C73.4332 19.2602 73.188 19.7649 72.6978 20.1619C72.2076 20.5589 71.5391 20.7574 70.6924 20.7574C68.7537 20.7574 66.7483 19.9634 64.676 18.3754L62.8711 21.3359C63.9407 22.198 65.1718 22.8672 66.5645 23.3436C67.9571 23.82 69.2997 24.0582 70.5921 24.0582ZM89.4768 5.41054C91.9057 5.41054 93.9222 6.09677 95.5266 7.46926C97.131 8.84176 97.9443 10.6282 97.9666 12.8288L98 12.8968L85.0314 18.4435C86.1901 19.8954 87.7666 20.6213 89.7609 20.6213C91.7552 20.6213 93.3986 19.8273 94.691 18.2393L96.897 20.7234C94.7801 22.9466 92.2845 24.0582 89.41 24.0582C86.892 24.0582 84.7306 23.2075 82.9257 21.506C81.1207 19.8046 80.2183 17.5587 80.2183 14.7684C80.2183 12.8401 80.6862 11.1444 81.6221 9.68112C82.558 8.21789 83.7167 7.14033 85.0982 6.44841C86.4798 5.75649 87.9393 5.41054 89.4768 5.41054ZM83.8615 15.483C83.8392 15.3469 83.8281 15.1314 83.8281 14.8364C83.8281 12.9762 84.4353 11.5243 85.6497 10.4808C86.8642 9.43724 88.2067 8.91548 89.6774 8.91548C91.616 8.91548 92.9641 9.6641 93.7217 11.1614L83.8615 15.483Z",
    fill: "currentColor"
  })
}), o1 = function({
  icon: n,
  fill: r,
  size: l,
  stroke: s,
  width: a,
  height: c,
  className: p,
  spin: u,
  pulse: C,
  infinite: h,
  fast: k,
  easeInOut: g
}) {
  const m = F("Streamline_Icon", {
    Streamline_Icon_Spin: u,
    Streamline_Icon_Animated: u || C,
    Streamline_Icon_Pulse: C,
    Streamline_Animation_Infinite: h,
    Streamline_Animation_Fast: k,
    Streamline_Animation_EaseInOut: g
  }, p);
  return Pe(n, {
    stroke: s,
    fill: r,
    width: a || l,
    height: c || l,
    className: m
  });
};
o1.defaultProps = {
  size: 24,
  pulse: !1,
  spin: !1,
  fast: !1,
  easeInOut: !1,
  infinite: !1,
  className: null
};
function n1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M.5,6.5v-2a1,1,0,0,1,1-1h2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3.5,20.5h-2a1,1,0,0,1-1-1v-2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5,17.5v2a1,1,0,0,1-1,1h-2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M20.5,3.5h2a1,1,0,0,1,1,1v2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("line", {
    x1: 3.5,
    y1: 7.5,
    x2: 3.5,
    y2: 16.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 20.5,
    y1: 7.5,
    x2: 20.5,
    y2: 16.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 7.5,
    y1: 7.5,
    x2: 7.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 12.5,
    y1: 7.5,
    x2: 12.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 14.5,
    y1: 7.5,
    x2: 14.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 9.5,
    y1: 7.5,
    x2: 9.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 16.5,
    y1: 7.5,
    x2: 16.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 7.5,
    y1: 16.5,
    x2: 7.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 5.5,
    y1: 7.5,
    x2: 5.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 5.5,
    y1: 16.5,
    x2: 5.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 9.5,
    y1: 16.5,
    x2: 9.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 12.5,
    y1: 16.5,
    x2: 12.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 14.5,
    y1: 16.5,
    x2: 14.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 16.5,
    y1: 16.5,
    x2: 16.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 18.5,
    y1: 7.5,
    x2: 18.5,
    y2: 13.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 18.5,
    y1: 16.5,
    x2: 18.5,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}
function r1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M9,6.5V6A5.5,5.5,0,0,1,20,6V23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13,10.5a4,4,0,0,0-8,0V11a.5.5,0,0,0,.5.5h7A.5.5,0,0,0,13,11Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9 16.75L9 14.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9 22.75L9 20.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12.704 16.457L11.939 14.609",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15 22L14.235 20.152",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.296 16.457L6.061 14.609",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3 22L3.765 20.152",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function l1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("polyline", {
    points: "1.5 23.5 1.5 21.5 22.5 21.5 22.5 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 0.5,
    y2: 8.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M4,14.5v-1a1.36,1.36,0,0,1,1.49-1.35L8,12.4a1.11,1.11,0,0,1,1,1.1v1",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15,.5h7a.5.5,0,0,1,.5.5V9.5a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V1A.5.5,0,0,1,15,.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 14.5,
    y1: 6.5,
    x2: 22.5,
    y2: 6.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 18.5,
    y1: 0.5,
    x2: 18.5,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 22.5,
    y1: 3.5,
    x2: 14.5,
    y2: 3.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 13.5,
    y1: 9.5,
    x2: 23.5,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2.5,14.5h18a1,1,0,0,1,1,1v3a0,0,0,0,1,0,0H2.5a0,0,0,0,1,0,0v-4A0,0,0,0,1,2.5,14.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2,18.5H22a.5.5,0,0,1,.5.5v2.5a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V19A.5.5,0,0,1,2,18.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function s1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M5.33,14.62c-2.6-.8-2.64-4.12-4-4.12S0,16.44,3.12,19.91",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M8.92,15.39l-3-.92a.71.71,0,0,0-.84.43l-2,4.36a.9.9,0,0,0,.25,1.07A8.13,8.13,0,0,0,7,21.88",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.67,14.62c2.6-.8,2.64-4.12,4-4.12s1.37,5.94-1.76,9.41",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.08,15.39l3-.92a.71.71,0,0,1,.84.43l2,4.36a.9.9,0,0,1-.25,1.07A8.13,8.13,0,0,1,17,21.88",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17,21.56l-1.83-6a.74.74,0,0,0-.69-.58H9.55a.74.74,0,0,0-.69.58L7,21.56a.87.87,0,0,0,.44,1,11.61,11.61,0,0,0,9.06,0A.87.87,0,0,0,17,21.56Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7,13V7a.5.5,0,0,1,.5-.5h9V13",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.5,6.5H18a2,2,0,0,1,0,4H16.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9.93.5c-1.5,1.5,1.5,2.5,0,4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13.43.5c-1.5,1.5,1.5,2.5,0,4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function a1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M11.500 17.501 A6.000 6.000 0 1 0 23.500 17.501 A6.000 6.000 0 1 0 11.500 17.501 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M19.5 17.501L17.5 17.501 17.5 14.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9.5,18.5h-8a1,1,0,0,1-1-1V3.5a1,1,0,0,1,1-1h18a1,1,0,0,1,1,1V10",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5 0.501L5.5 5.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5 0.501L15.5 5.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 7.501L20.5 7.501",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function i1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "calendar-home"), /* @__PURE__ */ e.createElement("polyline", {
    className: "a",
    points: "12.5 16.308 12.5 23.501 21.5 23.501 21.5 16.308"
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "a",
    points: "10.5 18.001 17 12.501 23.5 18.001"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M18.5,23.5h-3v-3a1.5,1.5,0,0,1,3,0Z"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M8.5,18.5h-7a1,1,0,0,1-1-1V3.5a1,1,0,0,1,1-1h18a1,1,0,0,1,1,1v9"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 5.5,
    y1: 0.501,
    x2: 5.5,
    y2: 5.501
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: 0.501,
    x2: 15.5,
    y2: 5.501
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 0.5,
    y1: 7.501,
    x2: 20.5,
    y2: 7.501
  })));
}
function c1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(11.372549%,80.784314%,57.647059%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 19.877926 8.72876 C 19.985413 8.965232 20.143061 9.173041 20.329373 9.34502 C 20.52285 9.517 20.744991 9.645985 20.988629 9.731975 L 22.249814 10.183422 C 22.615271 10.312407 22.930567 10.548879 23.152707 10.864175 C 23.374848 11.186637 23.496667 11.55926 23.496667 11.95338 C 23.496667 12.340335 23.374848 12.712958 23.152707 13.03542 C 22.930567 13.350716 22.615271 13.587188 22.249814 13.723339 L 21.00296 14.217781 C 20.759322 14.303771 20.530016 14.432756 20.343704 14.604735 C 20.150227 14.776715 19.999745 14.984524 19.892257 15.220996 C 19.78477 15.457468 19.734609 15.715438 19.734609 15.980574 C 19.734609 16.238543 19.78477 16.503679 19.892257 16.740151 L 20.501352 18.001336 C 20.666166 18.352461 20.716327 18.739416 20.651835 19.119205 C 20.580177 19.506159 20.401031 19.850119 20.12873 20.129586 C 19.856428 20.401887 19.505303 20.581033 19.125514 20.652691 C 18.73856 20.717183 18.351605 20.667023 18.00048 20.502209 L 16.789456 19.921777 C 16.552983 19.81429 16.295014 19.764129 16.029878 19.764129 C 15.771909 19.764129 15.506773 19.81429 15.270301 19.921777 C 15.033829 20.029264 14.82602 20.179747 14.65404 20.373224 C 14.48206 20.559535 14.353075 20.788842 14.267085 21.03248 L 13.822804 22.286499 C 13.686654 22.651956 13.450182 22.967252 13.134885 23.196559 C 12.812423 23.418699 12.4398 23.533352 12.052846 23.533352 C 11.665891 23.533352 11.286103 23.418699 10.970806 23.196559 C 10.648344 22.967252 10.411872 22.651956 10.282887 22.286499 L 9.78128 20.99665 C 9.69529 20.753012 9.566305 20.530872 9.394325 20.34456 C 9.222345 20.151083 9.014536 19.993435 8.778064 19.893114 C 8.541592 19.785626 8.283622 19.735465 8.018487 19.735465 C 7.760517 19.735465 7.502547 19.785626 7.258909 19.893114 L 5.997724 20.502209 C 5.653765 20.667023 5.259644 20.717183 4.879856 20.652691 C 4.500067 20.581033 4.148942 20.401887 3.87664 20.129586 C 3.597173 19.850119 3.418028 19.506159 3.353535 19.119205 C 3.281877 18.739416 3.339204 18.352461 3.496852 18.001336 L 4.077283 16.790312 C 4.184771 16.546674 4.234932 16.288704 4.234932 16.030734 C 4.234932 15.765599 4.184771 15.507629 4.077283 15.271157 C 3.969796 15.034685 3.819314 14.826876 3.625837 14.654896 C 3.439525 14.482916 3.210219 14.353931 2.973747 14.267942 L 1.712562 13.816495 C 1.347104 13.68751 1.031808 13.451038 0.809668 13.135741 C 0.580361 12.813279 0.465708 12.440656 0.465708 12.046536 C 0.465708 11.659582 0.580361 11.286959 0.809668 10.964497 C 1.031808 10.6492 1.347104 10.412728 1.712562 10.276578 L 3.00241 9.782136 C 3.246048 9.696146 3.468188 9.567161 3.661666 9.395181 C 3.847977 9.223201 4.005625 9.015392 4.113113 8.77892 C 4.213434 8.542448 4.270761 8.284478 4.270761 8.019343 C 4.270761 7.761373 4.213434 7.503404 4.113113 7.259766 L 3.496852 5.99858 C 3.339204 5.647455 3.281877 5.260501 3.353535 4.880712 C 3.418028 4.493757 3.597173 4.149798 3.87664 3.870331 C 4.148942 3.598029 4.500067 3.418884 4.879856 3.347226 C 5.259644 3.282733 5.653765 3.332894 5.997724 3.497708 L 7.208749 4.07814 C 7.452387 4.185627 7.710356 4.235788 7.968326 4.235788 C 8.233462 4.235788 8.491431 4.185627 8.727903 4.07814 C 8.971541 3.984984 9.186516 3.834502 9.365662 3.64819 C 9.551973 3.461879 9.688124 3.239738 9.78128 3.003266 L 10.232726 1.742081 C 10.361711 1.376624 10.598183 1.061328 10.920646 0.839187 C 11.235942 0.609881 11.615731 0.495228 12.002685 0.495228 C 12.38964 0.495228 12.762262 0.609881 13.084724 0.839187 C 13.400021 1.061328 13.636493 1.376624 13.772644 1.742081 L 14.216925 3.003266 C 14.302915 3.246904 14.431899 3.469045 14.603879 3.655356 C 14.775859 3.848833 14.983668 4.006481 15.22014 4.106803 ",
    transform: "matrix(0.545122,0,0,0.545122,4.941445,4.882384)"
  }), /* @__PURE__ */ e.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(11.372549%,80.784314%,57.647059%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 16.502271 0.498247 L 5.739817 13.601428 C 5.654255 13.717548 5.544247 13.815333 5.415904 13.88256 C 5.287562 13.949787 5.146996 13.992568 5.000318 13.998679 C 4.853641 14.004791 4.713075 13.974233 4.578621 13.919229 C 4.444167 13.864225 4.328047 13.778663 4.230262 13.668655 L 0.997248 10.00172 ",
    transform: "matrix(0.639158,0,0,0.639158,8.245414,4.951073)"
  }));
}
function d1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 0.499L23.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5 0.499L0.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function p1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M8,6.157A2,2,0,0,1,8,3.328,2,2,0,0,0,8,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12,6.157a2,2,0,0,1,0-2.829A2,2,0,0,0,12,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16,6.157a2,2,0,0,1,0-2.829A2,2,0,0,0,16,.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.500 11.542 A6.5 3 0 1 0 18.500 11.542 A6.5 3 0 1 0 5.500 11.542 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.5,11.542A17.914,17.914,0,0,1,17.335,18.1a1.992,1.992,0,0,1-.53.763A7.121,7.121,0,0,1,12,20.542a7.121,7.121,0,0,1-4.8-1.679,1.981,1.981,0,0,1-.53-.763A17.9,17.9,0,0,1,5.5,11.542",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.219,14.886C19.933,15.8,21,17.079,21,18.5c0,2.761-4.029,5-9,5s-9-2.239-9-5c0-1.421,1.067-2.7,2.78-3.614",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7.526,13.718C7.24,12.516,9.353,11.5,12,11.5s4.76,1.016,4.474,2.218",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function u1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M10.16,12.93A4.29,4.29,0,0,1,6.5,17v2.54h.83a1,1,0,0,1,1,.77l.32,1.44H4.57L3.55,17l1.36-1.53L4.15,13.2l-.09-.78A3.56,3.56,0,0,1,7.62,8.86h5.09a3.19,3.19,0,0,0,3-2.31",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M4.4,10.9A3.88,3.88,0,0,1,.5,7.28,3.58,3.58,0,0,1,.81,5.81",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.56,4.43l.22,1a1.12,1.12,0,0,1-1,1.42H16.33a1.12,1.12,0,0,1-1-1.42l.51-2.29a1,1,0,0,1,1-.87H18.3a2.81,2.81,0,0,1,3.05,2h1.13a1,1,0,0,1,1,1.34l-.4,1.19a1,1,0,0,1-.72.66l-2.51.63c.18,3.65-.5,6.13-2.32,7.15L17,19.54h.51a1,1,0,0,1,1,.77l.32,1.44H14.5v-6H11.69",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function C1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("defs", null), /* @__PURE__ */ e.createElement("title", null, "download-bottom"), /* @__PURE__ */ e.createElement("path", {
    d: "M23,18.218v1.913A2.87,2.87,0,0,1,20.131,23H3.869A2.869,2.869,0,0,1,1,20.131V18.218",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 12,
    y1: 18.108,
    x2: 12,
    y2: 1,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("polyline", {
    points: "19 11.108 12 18.108 5 11.108",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function m1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M18.75,3a1.5,1.5,0,0,1,1.5,1.5v9a1.5,1.5,0,0,1-1.5,1.5H5.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,5.25,3",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21.75,21.75H2.25A1.5,1.5,0,0,1,.91,19.58l1.84-2.92A3,3,0,0,1,5.43,15H18.57a3,3,0,0,1,2.68,1.66l1.84,2.92A1.5,1.5,0,0,1,21.75,21.75Z",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 10.5,
    y1: 18.75,
    x2: 13.5,
    y2: 18.75,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  })), /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M15.92,5.75H8.25a1.5,1.5,0,0,0-1.4,2l1.3,3.73a.75.75,0,0,0,.71.49h6.46a.74.74,0,0,0,.7-.49l1.31-3.73A1.51,1.51,0,0,0,15.92,5.75Z",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 8.5,
    y1: 5.75,
    x2: 10,
    y2: 2.25,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 15.5,
    y1: 5.75,
    x2: 14,
    y2: 2.25,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }))));
}
function f1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "envelope"), /* @__PURE__ */ e.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 4.5,
    width: 23,
    height: 15,
    rx: 1.5,
    ry: 1.5
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "a",
    points: "20.5 8.5 12 14 3.5 8.5"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 3.5,
    y1: 16,
    x2: 7,
    y2: 14
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 20.5,
    y1: 16,
    x2: 17,
    y2: 14
  })));
}
function h1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M15.5 8.499L23.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 23.499L8.5 15.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5 23.499L0.5 23.499 0.5 18.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5 5.499L23.5 0.499 18.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5 15.499L23.5 23.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 0.499L8.5 8.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 5.499L0.5 0.499 5.5 0.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.5 23.499L23.5 23.499 23.5 18.499",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function g1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "expand-3"), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 8.5,
    y1: 15.499,
    x2: 0.5,
    y2: 23.499
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "a",
    points: "5.5 23.499 0.5 23.499 0.5 18.499"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: 8.499,
    x2: 23.5,
    y2: 0.499
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "a",
    points: "18.5 0.499 23.5 0.499 23.5 5.499"
  })));
}
function k1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M21.8,2.1A1,1,0,0,0,21,.5H2.981a1,1,0,0,0-.8,1.6L9.989,12.591V22.5a1,1,0,0,0,1.6.8l2-1.5a1,1,0,0,0,.4-.8v-8.41Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function L1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M13.767 8.111L8.112 13.768",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.889 10.232L10.233 15.889",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M10.232,20.132a1.5,1.5,0,1,1-2.12,2.121L1.747,15.889a1.5,1.5,0,0,1,2.121-2.121",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2.454,12.354a1.5,1.5,0,0,1,2.122-2.122l9.192,9.193a1.5,1.5,0,1,1-2.122,2.122Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M10.232,4.576a1.5,1.5,0,0,1,2.122-2.122l9.192,9.193a1.5,1.5,0,1,1-2.121,2.121Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.7,20.839a1.5,1.5,0,0,1-2.122,2.122L1.04,19.425A1.5,1.5,0,0,1,3.161,17.3",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13.769,3.868a1.5,1.5,0,1,1,2.122-2.121l6.362,6.364a1.5,1.5,0,1,1-2.121,2.122",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17.305,3.161a1.5,1.5,0,0,1,2.12-2.121l3.536,3.536A1.5,1.5,0,0,1,20.839,6.7",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function E1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0.25 5a1.5 1.5 0 1 1 -1.5 1.5 1.5 1.5 0 0 1 1.5 -1.5Zm2.25 13.5h-4a1 1 0 0 1 0 -2h0.75a0.25 0.25 0 0 0 0.25 -0.25v-4.5a0.25 0.25 0 0 0 -0.25 -0.25h-0.75a1 1 0 0 1 0 -2h1a2 2 0 0 1 2 2v4.75a0.25 0.25 0 0 0 0.25 0.25h0.75a1 1 0 0 1 0 2Z",
    fill: "#000000",
    strokeWidth: 1
  }));
}
function w1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 23.001C18.0751 23.001 23 18.0761 23 12.001C23 5.92584 18.0751 1.00098 12 1.00098C5.92487 1.00098 1 5.92584 1 12.001C1 18.0761 5.92487 23.001 12 23.001Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.5 17.005H13C12.7348 17.005 12.4804 16.8996 12.2929 16.7121C12.1054 16.5246 12 16.2702 12 16.005V9.505C12 9.3724 11.9473 9.24522 11.8536 9.15145C11.7598 9.05768 11.6326 9.005 11.5 9.005H10"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#000000",
    d: "M11.7414 7C11.6033 7 11.4914 6.88807 11.4914 6.75C11.4914 6.61193 11.6033 6.5 11.7414 6.5"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#000000",
    d: "M11.7414 7C11.8794 7 11.9914 6.88807 11.9914 6.75C11.9914 6.61193 11.8794 6.5 11.7414 6.5"
  }));
}
function x1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 23,
    height: 8,
    rx: 1,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 3.5,
    y1: 19.5,
    x2: 3.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 20.5,
    y1: 19.5,
    x2: 20.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M9.25,2.6a5.37,5.37,0,0,0,3.88,1.65,5.46,5.46,0,0,0,2.14-.44",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("circle", {
    cx: 12.05,
    cy: 4.25,
    r: 3.25,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.5,11.5a5.37,5.37,0,0,0-9,0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}
function F1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "lift-two-people"), /* @__PURE__ */ e.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 6.5,
    width: 18,
    height: 17,
    rx: 1,
    ry: 1
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "5 2.5 7 0.5 9 2.5"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: 0.5,
    x2: 7,
    y2: 4.5
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "15 2.5 17 4.5 19 2.5"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 4.5,
    x2: 17,
    y2: 0.5
  }), /* @__PURE__ */ e.createElement("circle", {
    className: "cls-1",
    cx: 8.502,
    cy: 10.5,
    r: 2
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M11,15.5a2.5,2.5,0,0,0-5,0v2H7l.5,4h2l.5-4h1Z"
  }), /* @__PURE__ */ e.createElement("circle", {
    className: "cls-1",
    cx: 15.502,
    cy: 10.5,
    r: 2
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M18,15.5a2.5,2.5,0,1,0-5,0v2h1l.5,4h2l.5-4h1Z"
  })));
}
function v1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "lift"), /* @__PURE__ */ e.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 0.5,
    width: 22,
    height: 23,
    rx: 1,
    ry: 1
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 23.5,
    x2: 12,
    y2: 7.5
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M19,23.5V8a.5.5,0,0,0-.5-.5H5.5A.5.5,0,0,0,5,8V23.5"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M7,5,8.146,3.854a.5.5,0,0,1,.708,0L10,5"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M14,3.5l1.146,1.146a.5.5,0,0,0,.708,0L17,3.5"
  })));
}
function y1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M12,.71a7.5,7.5,0,0,1,7.5,7.5c0,3.547-5.5,12.381-7.079,14.85a.5.5,0,0,1-.842,0C10,20.592,4.5,11.757,4.5,8.21A7.5,7.5,0,0,1,12,.71Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9.000 8.210 A3.000 3.000 0 1 0 15.000 8.210 A3.000 3.000 0 1 0 9.000 8.210 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function b1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M19,11.5A4.49,4.49,0,0,1,23.5,16c0,2-2.92,5.88-4,7.31a.58.58,0,0,1-.44.21.55.55,0,0,1-.44-.21c-1.13-1.43-4-5.31-4-7.31A4.49,4.49,0,0,1,19,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 1.75,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 7.5,
    y1: 5.39,
    x2: 7.5,
    y2: 21.39,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 14.5,
    y1: 10.5,
    x2: 14.5,
    y2: 0.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12.47,18,7.79,21.29a.48.48,0,0,1-.58,0L.71,16.65a.51.51,0,0,1-.21-.41V1A.48.48,0,0,1,.77.56a.49.49,0,0,1,.52,0L7.5,5.39,14.21.59a.51.51,0,0,1,.58,0l6.5,4.65a.49.49,0,0,1,.21.4V10",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function M1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M8.791,22.292a.5.5,0,0,1-.582,0l-6.5-4.642a.5.5,0,0,1-.209-.407V2.472a.5.5,0,0,1,.791-.407L8.5,6.5l6.709-4.792a.5.5,0,0,1,.582,0l6.5,4.642a.5.5,0,0,1,.209.407V21.528a.5.5,0,0,1-.791.407L15.5,17.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M8.5 6.5L8.5 22.386",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5 17.5L15.5 1.614",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function A1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M6.5,17.5a3,3,0,0,1-6,0v-6a3,3,0,0,1,6,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 12.5L2.5 12.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 14.5L2.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 16.5L2.5 16.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.5 12.5L4.5 12.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.5 14.5L4.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.5 16.5L4.5 16.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3.5 20.5L3.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M1.5 23.5L5.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.500 12.500 A4.000 4.000 0 1 0 23.500 12.500 A4.000 4.000 0 1 0 15.500 12.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M19.5 6.5L19.5 8.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21.5,4.5a2,2,0,0,1-4,0v-3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17.500 12.500 A2.000 2.000 0 1 0 21.500 12.500 A2.000 2.000 0 1 0 17.500 12.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17.5,3.676c-3.18.64-6.135,3-6.135,6.7,0,.7-1.96,3.093-1.86,4.49.032.442.043.789.606.814s1.324-.005,1.324-.005-.034,3.3.747,4.076c.611.611,1.579.736,3.318.728V23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5,4.642a8.348,8.348,0,0,0-2-.84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function S1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M21 7L3 7",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21 12L3 12",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21 17L3 17",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function j1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M12 21.5L12 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18,15.5a2.548,2.548,0,0,0,2.392-1.961L21,10.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6,15.5a2.548,2.548,0,0,1-2.392-1.961L3,10.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5,13.79S18,7,18,5.5C18,3,15.678.786,13.047.547,12.714.517,12.365.5,12,.5s-.714.017-1.047.047C8.322.786,6,3,6,5.5,6,7,8.5,13.79,8.5,13.79",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M11.000 22.500 A1.000 1.000 0 1 0 13.000 22.500 A1.000 1.000 0 1 0 11.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.000 22.500 A1.000 1.000 0 1 0 18.000 22.500 A1.000 1.000 0 1 0 16.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.000 22.500 A1.000 1.000 0 1 0 8.000 22.500 A1.000 1.000 0 1 0 6.000 22.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7,21.5a6.277,6.277,0,0,1,5-2,6.277,6.277,0,0,1,5,2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5,10a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,1,10a2,2,0,0,1,4,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23,10a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,19,10a2,2,0,0,1,4,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18,16.5a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V15.184a1,1,0,0,1,.686-.95A17.1,17.1,0,0,1,12,13.5a17.1,17.1,0,0,1,5.314.734,1,1,0,0,1,.686.95Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function B1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("polygon", {
    points: "8.6 15.5 8.1 12.5 6.1 12.5 5.6 15.5 8.6 15.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M1,16.22a.48.48,0,0,1,0-.48.5.5,0,0,1,.43-.24H22.79a.49.49,0,0,1,.42.24.48.48,0,0,1,0,.48L22.1,18.5H2.1Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 0.6,
    y1: 10,
    x2: 13.6,
    y2: 10,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("polyline", {
    points: "2.7 23.5 4.1 18.5 2.1 18.5 0.79 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("polyline", {
    points: "21.49 23.5 20.1 18.5 22.1 18.5 23.4 23.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("circle", {
    cx: 19.6,
    cy: 4,
    r: 3.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("polyline", {
    points: "19.6 2 19.6 4 21.22 4",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.1,11.5h3a.5.5,0,0,1,.5.5v3.5a0,0,0,0,1,0,0h-4a0,0,0,0,1,0,0V12A.5.5,0,0,1,18.1,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 20.1,
    y1: 11.5,
    x2: 20.1,
    y2: 9.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 18.1,
    y1: 9.5,
    x2: 19.1,
    y2: 11.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 0.6,
    y: 2.5,
    width: 13,
    height: 10,
    rx: 1,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function H1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M10.500 7.000 A6.500 6.500 0 1 0 23.500 7.000 A6.500 6.500 0 1 0 10.500 7.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5,10.5v-7h2a2,2,0,0,1,0,4h-2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M19.44,16.01a2.03,2.03,0,0,1,.06.49v3a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-3a2,2,0,0,1,2-2h8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3,14.5l.347-3.166A2,2,0,0,1,5.34,9.5H7.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2.500 17.500 A1.000 1.000 0 1 0 4.500 17.500 A1.000 1.000 0 1 0 2.500 17.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.500 17.500 A1.000 1.000 0 1 0 17.500 17.500 A1.000 1.000 0 1 0 15.500 17.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5,20.5V22a1.5,1.5,0,0,1-3,0V20.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17.5,20.5V22a1.5,1.5,0,0,1-3,0V20.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 12.5L3 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function R1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("defs", null), /* @__PURE__ */ e.createElement("title", null, "pencil-1"), /* @__PURE__ */ e.createElement("path", {
    d: "M6.966,21.983.5,23.5l1.517-6.465L17.964,1.086a2,2,0,0,1,2.829,0l2.122,2.121a2,2,0,0,1,0,2.829Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 22.21,
    y1: 6.745,
    x2: 17.257,
    y2: 1.793,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 20.783,
    y1: 8.172,
    x2: 15.842,
    y2: 3.207,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 7.218,
    y1: 21.733,
    x2: 2.268,
    y2: 16.783,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function Z1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M9.086,7.4a2.315,2.315,0,0,0,0-3.271L6.632,1.678a2.313,2.313,0,0,0-3.271,0L2.016,3.024a3.463,3.463,0,0,0-.439,4.365A53.778,53.778,0,0,0,16.611,22.423a3.469,3.469,0,0,0,4.366-.437l1.345-1.346a2.312,2.312,0,0,0,0-3.271l-2.453-2.453a2.312,2.312,0,0,0-3.271,0l-.818.818A54.879,54.879,0,0,1,8.268,8.22Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function N1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "real-estate-dimensions-block"), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 2.5,
    y1: 23.5,
    x2: 2.5,
    y2: 5.5
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "0.5 21.5 2.5 23.5 4.5 21.5"
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "4.5 7.5 2.5 5.5 0.5 7.5"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 5.5,
    y1: 2.5,
    x2: 23.5,
    y2: 2.5
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "7.5 0.5 5.5 2.5 7.5 4.5"
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "21.5 4.5 23.5 2.5 21.5 0.5"
  }), /* @__PURE__ */ e.createElement("rect", {
    className: "cls-1",
    x: 7.5,
    y: 7.5,
    width: 16,
    height: 16,
    rx: 1,
    ry: 1
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M19.5,23.5V19a.5.5,0,0,1,.5-.5h1"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 15.5,
    x2: 19.5,
    y2: 15.5
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 12.5,
    x2: 19.5,
    y2: 12.5
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M11.5,7.5V12a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5V7.5"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M10.5,19.5V16a.5.5,0,0,0-.5-.5H7.5"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 13.5,
    y1: 23.5,
    x2: 13.5,
    y2: 19.5
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M16.5,23.5V17a.5.5,0,0,0-.5-.5H13.5"
  })));
}
function D1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M15.5,15.5H18a.5.5,0,0,0,.5-.5C18.433,7.2,16.853.5,15.5.5v23",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5.5v5a3,3,0,0,0,6,0V.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M8.501 0.5L8.501 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function V1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm7.49 18.24a9.75 9.75 0 0 1 -15 0 0.23 0.23 0 0 1 0 -0.21 0.26 0.26 0 0 1 0.12 -0.17 33.79 33.79 0 0 1 4 -1.67l0.68 -0.25c0.21 -0.07 0.38 -0.34 0.47 -0.72a2.19 2.19 0 0 0 -0.24 -1.75c-0.84 -0.93 -1.66 -2.07 -1.66 -4.92A4 4 0 0 1 12 4.15a4 4 0 0 1 4.14 4.4c0 2.85 -0.82 4 -1.66 4.92a2.15 2.15 0 0 0 -0.25 1.75 1 1 0 0 0 0.48 0.72l0.67 0.25a33.11 33.11 0 0 1 4 1.67 0.26 0.26 0 0 1 0.12 0.17 0.23 0.23 0 0 1 -0.01 0.21Z",
    fill: "#000000",
    strokeWidth: 1
  }));
}
function _1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.5 9.5L23.5 9.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M14.5,5.5h8a1,1,0,0,1,1,1v15a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1V6.5a1,1,0,0,1,1-1h8",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15 14.5L21 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15 17.5L18.5 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12.963,20c-.408-.63-1.761-1.088-3.455-1.715-.478-.178-.4-1.426-.188-1.659a3.524,3.524,0,0,0,.918-2.734A2.188,2.188,0,0,0,8,11.5a2.188,2.188,0,0,0-2.238,2.392,3.524,3.524,0,0,0,.918,2.734c.212.233.29,1.481-.188,1.659C4.8,18.912,3.445,19.37,3.037,20",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M14.5,7a.5.5,0,0,1-.5.5H10A.5.5,0,0,1,9.5,7V4a2.5,2.5,0,0,1,5,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function I1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.714 10.353L3.501 14.503 6.706 10.665",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.286 14.655L20.501 10.503 17.294 14.342",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M20.464,10.54a8.622,8.622,0,0,1-6.51,9.729,8.493,8.493,0,0,1-7.931-2.224",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3.505,14.479A8.853,8.853,0,0,1,10.043,3.726a8.493,8.493,0,0,1,8.324,2.642",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function T1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M.5,11,2,18.5H6.5a1,1,0,0,1,1,1v4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2 18.5L1.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5,11,22,18.5H17.5a1,1,0,0,0-1,1v4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M22 18.5L22.5 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12 6.5L12 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5 14.5L18.5 14.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M22.182,5.534A88.607,88.607,0,0,1,12,.5,88.607,88.607,0,0,1,1.818,5.534.5.5,0,0,0,2,6.5H22a.5.5,0,0,0,.182-.966Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function $1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("defs", null), /* @__PURE__ */ e.createElement("title", null, "upload-bottom"), /* @__PURE__ */ e.createElement("path", {
    d: "M23,18.218v1.913A2.87,2.87,0,0,1,20.131,23H3.869A2.869,2.869,0,0,1,1,20.131V18.218",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 18.108,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("polyline", {
    points: "5 8 12 1 19 8",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function W1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M12,.5A16.58,16.58,0,0,0,.67,4.84a.5.5,0,0,0-.17.38V7a.5.5,0,0,0,.5.5H23a.5.5,0,0,0,.5-.5V5.22a.5.5,0,0,0-.17-.38A16.58,16.58,0,0,0,12,.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 1.5,
    y1: 7.5,
    x2: 1.5,
    y2: 22,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 22.5,
    y1: 7.5,
    x2: 22.5,
    y2: 22,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5,17.5H12a0,0,0,0,1,0,0v6a0,0,0,0,1,0,0H5.5A.5.5,0,0,1,5,23V18A.5.5,0,0,1,5.5,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12,17.5h6.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H12a0,0,0,0,1,0,0v-6A0,0,0,0,1,12,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9,11.5h6a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-7a0,0,0,0,1,0,0V12A.5.5,0,0,1,9,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M10.5,11.5h3a0,0,0,0,1,0,0V14a.5.5,0,0,1-.5.5H11a.5.5,0,0,1-.5-.5V11.5A0,0,0,0,1,10.5,11.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7,17.5h3a0,0,0,0,1,0,0V20a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,7,20V17.5A0,0,0,0,1,7,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M14,17.5h3a0,0,0,0,1,0,0V20a.5.5,0,0,1-.5.5h-2A.5.5,0,0,1,14,20V17.5A0,0,0,0,1,14,17.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 10.25,
    y1: 4.5,
    x2: 13.75,
    y2: 4.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function P1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M12 14.5L12 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M9 23.5L15 23.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.5,8,6.442.934A.5.5,0,0,1,6.938.5H17.062a.5.5,0,0,1,.5.434L18.5,8a6.5,6.5,0,0,1-13,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.7 6.5L18.206 6.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const z1 = ({
  width: t,
  height: n,
  outer: r,
  inner: l,
  _hover: s,
  _selected: a,
  ...c
}) => {
  const p = s !== void 0 ? {
    ".pin-outer-path": s.outer,
    ".pin-inner-path": s.inner
  } : {}, u = a !== void 0 ? {
    ".pin-outer-path": a.outer,
    ".pin-inner-path": a.inner
  } : {};
  return /* @__PURE__ */ o(i.svg, {
    width: t,
    height: n,
    viewBox: "0 0 24 24",
    ...c,
    sx: {
      _hover: p,
      _selected: u,
      ".pin-outer-path": r,
      ".pin-inner-path": l
    },
    children: /* @__PURE__ */ d("g", {
      transform: "matrix(1,0,0,1,0,0)",
      children: [/* @__PURE__ */ o("path", {
        d: "M12,.71a7.5,7.5,0,0,1,7.5,7.5c0,3.547-5.5,12.381-7.079,14.85a.5.5,0,0,1-.842,0C10,20.592,4.5,11.757,4.5,8.21A7.5,7.5,0,0,1,12,.71Z",
        className: "pin-outer-path",
        strokeWidth: "1px",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ o("path", {
        d: "M9.000 8.210 A3.000 3.000 0 1 0 15.000 8.210 A3.000 3.000 0 1 0 9.000 8.210 Z",
        className: "pin-inner-path",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  });
};
function O1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.500 15.000 A4.000 4.000 0 1 0 8.500 15.000 A4.000 4.000 0 1 0 0.500 15.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.500 15.000 A4.000 4.000 0 1 0 23.500 15.000 A4.000 4.000 0 1 0 15.500 15.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M11 15.001L17 9 8.5 9 4.5 15 11 15 6.937 5.313",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M19.5,15l-.947-.32L16.4,6.712a.5.5,0,0,1,.541-.627l2.419.282a1,1,0,0,1-.285,1.981",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6 5L9 6",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function G1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M2.250 12.750 A1.750 1.750 0 1 0 5.750 12.750 A1.750 1.750 0 1 0 2.250 12.750 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7.123,17.112A3.6,3.6,0,0,0,.5,18",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M18.250 12.750 A1.750 1.750 0 1 0 21.750 12.750 A1.750 1.750 0 1 0 18.250 12.750 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.877,17.112A3.6,3.6,0,0,1,23.5,18",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M10.250 3.250 A1.750 1.750 0 1 0 13.750 3.250 A1.750 1.750 0 1 0 10.250 3.250 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5,8.5a3.612,3.612,0,0,0-7,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M17.749,21.3a1,1,0,0,1-.979,1.2H7.23a1,1,0,0,1-.979-1.2l2.083-10a1,1,0,0,1,.979-.8h5.374a1,1,0,0,1,.979.8Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M14.418,19.929a.5.5,0,0,1-.495.571H10.077a.5.5,0,0,1-.495-.571l.357-2.5A.5.5,0,0,1,10.434,17h3.132a.5.5,0,0,1,.495.429Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function U1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 2.5,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15,23.5l-.22-2.63a1.5,1.5,0,0,0-1.49-1.37H10.35a3.52,3.52,0,0,1-3.48-3.14l-.34-3.09a1.49,1.49,0,0,1,1.2-1.75,1.51,1.51,0,0,1,1.75,1.2c.42,3.72.37,3.28.37,3.32a.52.52,0,0,0,.5.46h2.89a4.54,4.54,0,0,1,4.49,4.12L18,23.49",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M1.5,13.5H3.16a1,1,0,0,1,1,.83l.69,4A4,4,0,0,0,8.74,21.5H12.5l.25,2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 19,
    y1: 0.5,
    x2: 19,
    y2: 3,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.5,6.5a3.5,3.5,0,0,1,7,0V7a.5.5,0,0,1-.5.5H16a.5.5,0,0,1-.5-.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function q1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.24L8.15299 21.6252L6.38 19.0021L3.22183 18.7782L2.99793 15.62L0.374816 13.847L1.76 11L0.374816 8.15299L2.99793 6.38L3.22183 3.22183L6.38 2.99793L8.15299 0.374816L11 1.76L13.847 0.374816L15.62 2.99793L18.7782 3.22183L19.0021 6.38L21.6252 8.15299L20.24 11L21.6252 13.847L19.0021 15.62L18.7782 18.7782L15.62 19.0021L13.847 21.6252L11 20.24Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M6.47046 11.1184L9.41535 14.2351L15.5293 7.76452",
    stroke: "white",
    strokeWidth: 2
  }));
}
function Y1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M23.535,18.373,12.409,5.8a.5.5,0,0,0-.749,0L.535,18.373",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function Q1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M.541,5.627,11.666,18.2a.5.5,0,0,0,.749,0L23.541,5.627",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function X1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ...t
  }, /* @__PURE__ */ e.createElement("defs", null), /* @__PURE__ */ e.createElement("title", null, "arrow-left-1"), /* @__PURE__ */ e.createElement("path", {
    d: "M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function J1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.500 10.500 A10.000 10.000 0 1 0 20.500 10.500 A10.000 10.000 0 1 0 0.500 10.500 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M23.5 23.5L17.571 17.571",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function K1(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function e0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("line", {
    x1: 7.5,
    y1: 5.39,
    x2: 7.5,
    y2: 21.39,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 14.5,
    y1: 10.5,
    x2: 14.5,
    y2: 0.5,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M10.5,19.36,7.79,21.29a.48.48,0,0,1-.58,0L.71,16.65a.51.51,0,0,1-.21-.41V1A.48.48,0,0,1,.77.56a.49.49,0,0,1,.52,0L7.5,5.39,14.21.59a.51.51,0,0,1,.58,0l6.5,4.65a.49.49,0,0,1,.21.4V11.5",
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21.5,17A4.5,4.5,0,1,1,17,12.5,4.5,4.5,0,0,1,21.5,17Z",
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 20.18,
    y1: 20.18,
    x2: 23.5,
    y2: 23.5,
    style: {
      fill: "none",
      stroke: "#007AFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function t0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M13.2462 4.8999C9.12079 4.89891 5.60572 7.89499 4.95279 11.9687C4.29986 16.0424 6.70246 19.9872 10.6214 21.2758V26.4249H11.6713V27.9999H14.821V26.4249H15.871V21.2758C19.7899 19.9872 22.1925 16.0424 21.5396 11.9687C20.8866 7.89499 17.3715 4.89896 13.2462 4.8999Z",
    fill: "#A4C2F7"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12.0773 4.8999C12.0374 4.8999 11.9989 4.90505 11.9591 4.90555C11.935 4.96973 11.8997 5.02964 11.8547 5.08268C11.4954 5.44437 11.0095 5.66995 10.4877 5.71729C10.0149 5.73551 9.55217 5.85239 9.13257 6.05965C9.17887 6.23711 9.10405 6.42316 8.94481 6.52648C8.02301 7.21375 6.96968 7.90345 6.40581 8.90538C6.32684 9.06247 6.16614 9.1684 5.98323 9.18401C6.12171 9.3561 6.14246 9.58861 6.03642 9.7803C5.78132 10.4176 5.37394 10.9904 4.84619 11.4537C4.95708 12.0887 5.02542 12.7297 5.05079 13.3729C5.05593 13.4949 5.05243 13.6534 5.04553 13.8309C5.59367 15.0206 5.94056 16.2847 6.07337 17.5767C6.68026 18.2543 7.29377 18.9251 7.94725 19.5583C8.40222 19.8445 8.82012 20.1803 9.19249 20.5588C9.80757 20.7792 10.3184 21.2021 10.6312 21.75C10.8754 22.3903 10.9067 23.0861 10.7208 23.7437C10.9931 23.8445 11.1476 24.1179 11.0851 24.3884C10.9729 24.9067 10.8517 25.4244 10.788 25.9507C10.7728 26.077 10.7384 26.2916 10.7187 26.5241C10.745 26.5218 10.763 26.5136 10.7919 26.5128C11.6755 26.4882 12.2059 27.3253 12.5119 27.9999H13.7401V26.4249H14.8486V21.2758C18.9863 19.9872 21.523 16.0425 20.8336 11.9688C20.1443 7.89509 16.4329 4.89896 12.0773 4.8999Z",
    fill: "url(#paint0_linear_2684_182)"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13.1663 4.8999C13.4295 4.8999 13.6892 4.91552 13.9462 4.93966C10.0248 5.31087 6.89918 8.40888 6.45893 12.3607C6.01868 16.3126 8.38461 20.0343 12.1263 21.2758V26.4249H13.1663V27.9999H11.6064V26.4249H10.5665V21.2758C6.68481 19.9872 4.30506 16.0425 4.95178 11.9687C5.5985 7.89504 9.08013 4.89896 13.1663 4.8999Z",
    fill: "white"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 12.5459,
    y: 22.3999,
    width: 2.8,
    height: 4.9,
    fill: "#E3E7F2"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 13.9458,
    y: 22.3999,
    width: 1.4,
    height: 3.5,
    fill: "#A4C2F7"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 11.146,
    y: 22.3999,
    width: 1.4,
    height: 3.5,
    fill: "white"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13.2456 3.11112C13.1051 3.11117 12.9703 3.05659 12.8709 2.95936C12.7715 2.86212 12.7157 2.73016 12.7158 2.59262V0.518492C12.7158 0.232148 12.953 0 13.2456 0C13.5382 0 13.7755 0.232148 13.7755 0.518492V2.59257C13.7755 2.73011 13.7197 2.86207 13.6204 2.9593C13.521 3.05659 13.3862 3.11117 13.2456 3.11112Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M25.9622 13.4818H23.8428C23.5502 13.4818 23.313 13.2497 23.313 12.9633C23.313 12.677 23.5502 12.4448 23.8428 12.4448H25.9622C26.2548 12.4448 26.492 12.677 26.492 12.9633C26.492 13.2497 26.2548 13.4818 25.9622 13.4818Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M2.64921 13.4818H0.529821C0.237221 13.4818 0 13.2497 0 12.9633C0 12.677 0.237221 12.4448 0.529821 12.4448H2.64921C2.94181 12.4448 3.17904 12.677 3.17904 12.9633C3.17909 13.2497 2.94187 13.4818 2.64921 13.4818Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M20.7402 6.14842C20.5259 6.14837 20.3328 6.02204 20.2508 5.82834C20.1688 5.63463 20.2141 5.41162 20.3656 5.2633L21.864 3.79686C22.0709 3.59441 22.4064 3.59441 22.6133 3.79686C22.8201 3.99931 22.8201 4.3276 22.6133 4.53005L21.1148 5.9965C21.0156 6.0939 20.8807 6.14859 20.7402 6.14842Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M4.25436 22.2813C4.04011 22.2812 3.84692 22.1549 3.76494 21.9612C3.68296 21.7675 3.72828 21.5445 3.87972 21.3961L5.37821 19.9297C5.51205 19.7987 5.70713 19.7476 5.88992 19.7955C6.07277 19.8435 6.21555 19.9832 6.26456 20.1621C6.31357 20.3411 6.26126 20.5319 6.12742 20.6629L4.62894 22.1293C4.52975 22.2267 4.3949 22.2814 4.25436 22.2813Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M22.2387 22.2812C22.0981 22.2814 21.9633 22.2267 21.8641 22.1293L20.3656 20.6629C20.1587 20.4604 20.1587 20.1321 20.3656 19.9297C20.5725 19.7272 20.9079 19.7272 21.1148 19.9297L22.6133 21.3961C22.7648 21.5444 22.8101 21.7674 22.7281 21.9611C22.6462 22.1548 22.453 22.2812 22.2387 22.2812Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.75286 6.14847C5.61231 6.14863 5.47747 6.09395 5.37828 5.99655L3.87979 4.5301C3.74595 4.39913 3.6937 4.20821 3.74266 4.02933C3.79167 3.85039 3.93444 3.71066 4.11729 3.6627C4.30014 3.61474 4.49517 3.66593 4.62901 3.79691L6.12749 5.26335C6.27899 5.41166 6.32431 5.63463 6.24227 5.82838C6.16035 6.02203 5.96717 6.14841 5.75286 6.14847Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6569 28.0002H14.836C14.9766 28.0003 15.1114 27.9457 15.2109 27.8485C15.3103 27.7513 15.366 27.6193 15.366 27.4818V26.4447H15.8958C16.0363 26.4448 16.1712 26.3902 16.2705 26.293C16.3699 26.1957 16.4257 26.0638 16.4256 25.9262V21.2079C20.497 19.7049 22.8884 15.5685 22.1078 11.3791C21.3273 7.1898 17.598 4.14551 13.2465 4.14551C8.89507 4.14551 5.16576 7.1898 4.38525 11.3791C3.60469 15.5685 5.99606 19.7049 10.0675 21.2079V25.9262C10.0674 26.0638 10.1232 26.1957 10.2226 26.293C10.3219 26.3902 10.4568 26.4448 10.5973 26.4447H11.1271V27.4818C11.127 27.6193 11.1828 27.7513 11.2822 27.8485C11.3816 27.9457 11.5164 28.0003 11.6569 28.0002ZM14.3062 26.9629H12.1868V25.9258C12.1869 25.7882 12.1311 25.6563 12.0318 25.559C11.9324 25.4618 11.7976 25.4072 11.657 25.4073H11.1272V20.8404C11.1271 20.6164 10.9803 20.4177 10.7629 20.3477C7.05448 19.1538 4.78119 15.501 5.39897 11.7287C6.01675 7.95638 9.34264 5.18164 13.2465 5.18164C17.1504 5.18164 20.4763 7.95643 21.0941 11.7287C21.7119 15.501 19.4386 19.1539 15.7302 20.3477C15.5128 20.4178 15.3659 20.6165 15.3659 20.8404V25.4073H14.836C14.6955 25.4072 14.5607 25.4618 14.4613 25.5591C14.3619 25.6563 14.3062 25.7883 14.3062 25.9258V26.9629Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M15.8962 22.8148H10.5977C10.3051 22.8148 10.0679 22.5827 10.0679 22.2963C10.0679 22.01 10.3051 21.7778 10.5977 21.7778H15.8962C16.1888 21.7778 16.426 22.01 16.426 22.2963C16.426 22.5827 16.1888 22.8148 15.8962 22.8148Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7.418 13.4814C7.27746 13.4815 7.14262 13.4269 7.04326 13.3297C6.9439 13.2325 6.88807 13.1005 6.88818 12.963C6.89204 9.52809 9.7364 6.7445 13.2464 6.74072C13.539 6.74072 13.7762 6.97287 13.7762 7.25921C13.7762 7.54556 13.539 7.77771 13.2464 7.77771C10.3215 7.78104 7.95135 10.1006 7.94788 12.9629C7.94794 13.1004 7.89217 13.2324 7.79281 13.3296C7.69334 13.4269 7.55855 13.4815 7.418 13.4814Z",
    fill: "#007AFF"
  }), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("linearGradient", {
    id: "paint0_linear_2684_182",
    x1: 1.50527,
    y1: 18.9048,
    x2: 17.9585,
    y2: 26.4761,
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ e.createElement("stop", {
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.1717,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2001,
    stopColor: "#DAE4F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2007,
    stopColor: "#EBEBF4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2014,
    stopColor: "#F6F1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2023,
    stopColor: "#FDF4F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.205,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.2522,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.3974,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.42,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.4201,
    stopColor: "#DAE4F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.4207,
    stopColor: "#EBEBF4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.4214,
    stopColor: "#F6F1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.4223,
    stopColor: "#FDF4F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.425,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.4894,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F2F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.5001,
    stopColor: "#E8EBF4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.5003,
    stopColor: "#DDE5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.5005,
    stopColor: "#D6E2F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.501,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.7062,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.74,
    stopColor: "#D4E1F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.741,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.8346,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFF5F4"
  }), /* @__PURE__ */ e.createElement("stop", {
    offset: 0.851,
    stopColor: "#D4E1F4"
  }))));
}
function o0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "real-estate-dimensions-map"), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M23.045,23.294A.3.3,0,0,0,23.5,23V4.177a.845.845,0,0,0-.455-.706L16.985.727a1.437,1.437,0,0,0-.927-.041L8.049,3.491a1.463,1.463,0,0,1-.929-.037L.957.723a.3.3,0,0,0-.457.3L.519,19.844a.842.842,0,0,0,.458.7l6.128,2.728a1.463,1.463,0,0,0,.929.039l8.024-2.8a1.444,1.444,0,0,1,.927.041Z"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M2.963,4.135a.314.314,0,0,0-.464.312V18.505a.8.8,0,0,0,.465.684L7.1,20.826a1.6,1.6,0,0,0,.939.025l8.494-2.846,4.5,1.775a.317.317,0,0,0,.465-.317V5.916A.874.874,0,0,0,21.05,5.2L16.979,3.219a1.407,1.407,0,0,0-.923-.06l-8,2.682a1.572,1.572,0,0,1-.938-.028Z"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 14.499,
    y1: 8.979,
    x2: 14.499,
    y2: 3.681
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M2.5,14.349l5.157,1.887,3.371-1.157a.334.334,0,0,1,.472.337v4.275"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "cls-1",
    d: "M14.5,18.686V14.479a.871.871,0,0,1,.452-.716l1.014-.485a1.342,1.342,0,0,1,.918-.036L21.5,15.021"
  }), /* @__PURE__ */ e.createElement("polyline", {
    className: "cls-1",
    points: "2.499 7.946 7.499 9.947 11.468 8.947"
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 4.499,
    y1: 8.747,
    x2: 4.499,
    y2: 6.979
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 8.499,
    y1: 9.695,
    x2: 8.499,
    y2: 7.979
  }), /* @__PURE__ */ e.createElement("line", {
    className: "cls-1",
    x1: 6.499,
    y1: 9.547,
    x2: 6.499,
    y2: 7.979
  })));
}
function n0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M0.500 12.000 A11.500 11.500 0 1 0 23.500 12.000 A11.500 11.500 0 1 0 0.500 12.000 Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M3.868 3.868L20.132 20.132",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function r0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /* @__PURE__ */ e.createElement("title", null, "share"), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M8.074,10.212a4,4,0,1,0,0,3.574"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M19.5,8.5a4.01,4.01,0,1,0-3.575-2.213"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M15.925,17.712A4,4,0,1,0,19.5,15.5"
  }), /* @__PURE__ */ e.createElement("path", {
    className: "a",
    d: "M19.5,8.5a4,4,0,0,1-3.575-2.213L8.074,10.212a3.963,3.963,0,0,1,0,3.575l7.851,3.926A4,4,0,0,1,19.5,15.5"
  })));
}
function l0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    d: "M7.5.5h9.59a1,1,0,0,1,.7.29l2.42,2.42a1,1,0,0,1,.29.7V19.5a1,1,0,0,1-1,1H7.5a1,1,0,0,1-1-1V1.5A1,1,0,0,1,7.5.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.5,23.5H4.5a1,1,0,0,1-1-1V5.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
function s0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ...t
  }, /* @__PURE__ */ e.createElement("title", null, "MS-SymbolLockup"), /* @__PURE__ */ e.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#f25022"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 1,
    y: 11,
    width: 9,
    height: 9,
    fill: "#00a4ef"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 11,
    y: 1,
    width: 9,
    height: 9,
    fill: "#7fba00"
  }), /* @__PURE__ */ e.createElement("rect", {
    x: 11,
    y: 11,
    width: 9,
    height: 9,
    fill: "#ffb900"
  }));
}
function a0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    id: "svg54",
    "sodipodi:docname": "google_sign_in.svg",
    "inkscape:version": "1.1 (c68e22c387, 2021-05-23)",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns",
    ...t
  }, /* @__PURE__ */ e.createElement("sodipodi:namedview", {
    id: "namedview56",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageshadow": 2,
    "inkscape:pageopacity": 0,
    "inkscape:pagecheckerboard": 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    "inkscape:zoom": 16.369565,
    "inkscape:cx": 13.714475,
    "inkscape:cy": 0.94687915,
    "inkscape:window-width": 2560,
    "inkscape:window-height": 1376,
    "inkscape:window-x": 0,
    "inkscape:window-y": 27,
    "inkscape:window-maximized": 1,
    "inkscape:current-layer": "btn_google_light_normal"
  }), /* @__PURE__ */ e.createElement("title", {
    id: "title2"
  }, "btn_google_light_normal_ios"), /* @__PURE__ */ e.createElement("desc", {
    id: "desc4"
  }, "Created with Sketch."), /* @__PURE__ */ e.createElement("defs", {
    id: "defs28"
  }, /* @__PURE__ */ e.createElement("filter", {
    x: -0.059999999,
    y: -0.059999999,
    width: 1.12,
    height: 1.145,
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /* @__PURE__ */ e.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset6"
  }), /* @__PURE__ */ e.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    id: "feGaussianBlur8"
  }), /* @__PURE__ */ e.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0",
    in: "shadowBlurOuter1",
    type: "matrix",
    result: "shadowMatrixOuter1",
    id: "feColorMatrix10"
  }), /* @__PURE__ */ e.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2",
    id: "feOffset12"
  }), /* @__PURE__ */ e.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    id: "feGaussianBlur14"
  }), /* @__PURE__ */ e.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0",
    in: "shadowBlurOuter2",
    type: "matrix",
    result: "shadowMatrixOuter2",
    id: "feColorMatrix16"
  }), /* @__PURE__ */ e.createElement("feMerge", {
    id: "feMerge24"
  }, /* @__PURE__ */ e.createElement("feMergeNode", {
    in: "shadowMatrixOuter1",
    id: "feMergeNode18"
  }), /* @__PURE__ */ e.createElement("feMergeNode", {
    in: "shadowMatrixOuter2",
    id: "feMergeNode20"
  }), /* @__PURE__ */ e.createElement("feMergeNode", {
    in: "SourceGraphic",
    id: "feMergeNode22"
  }))), /* @__PURE__ */ e.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  })), /* @__PURE__ */ e.createElement("g", {
    id: "Google-Button",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    "sketch:type": "MSPage",
    transform: "translate(-14,-14)"
  }, /* @__PURE__ */ e.createElement("g", {
    id: "9-PATCH",
    "sketch:type": "MSArtboardGroup",
    transform: "translate(-608,-160)"
  }), /* @__PURE__ */ e.createElement("g", {
    id: "btn_google_light_normal",
    "sketch:type": "MSArtboardGroup",
    transform: "translate(-1,-1)"
  }, /* @__PURE__ */ e.createElement("g", {
    id: "logo_googleg_48dp",
    "sketch:type": "MSLayerGroup",
    transform: "translate(15,15)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "m 17.64,9.2045455 c 0,-0.6381819 -0.05727,-1.2518182 -0.163636,-1.8409091 H 9 V 10.845 h 4.843636 C 13.635,11.97 13.000909,12.923182 12.047727,13.561364 v 2.258182 h 2.908637 C 16.658182,14.252727 17.64,11.945455 17.64,9.2045455 Z",
    id: "Shape",
    fill: "#4285f4",
    "sketch:type": "MSShapeGroup"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "m 9,18 c 2.43,0 4.467273,-0.805909 5.956364,-2.180454 L 12.047727,13.561364 C 11.241818,14.101364 10.210909,14.420455 9,14.420455 6.6559091,14.420455 4.6718182,12.837273 3.9640909,10.71 H 0.95727273 v 2.331818 C 2.4381818,15.983182 5.4818182,18 9,18 Z",
    id: "path42",
    fill: "#34a853",
    "sketch:type": "MSShapeGroup"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M 3.9640909,10.71 C 3.7840909,10.17 3.6818182,9.5931818 3.6818182,9 c 0,-0.5931818 0.1022727,-1.17 0.2822727,-1.71 V 4.9581818 H 0.95727273 C 0.34772727,6.1731818 0,7.5477273 0,9 c 0,1.452273 0.34772727,2.826818 0.95727273,4.041818 z",
    id: "path44",
    fill: "#fbbc05",
    "sketch:type": "MSShapeGroup"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "m 9,3.5795455 c 1.321364,0 2.507727,0.4540909 3.440455,1.3459091 L 15.021818,2.3440909 C 13.463182,0.89181818 11.425909,0 9,0 5.4818182,0 2.4381818,2.0168182 0.95727273,4.9581818 L 3.9640909,7.29 C 4.6718182,5.1627273 6.6559091,3.5795455 9,3.5795455 Z",
    id: "path46",
    fill: "#ea4335",
    "sketch:type": "MSShapeGroup"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M 0,0 H 18 V 18 H 0 Z",
    id: "path48",
    "sketch:type": "MSShapeGroup"
  })), /* @__PURE__ */ e.createElement("g", {
    id: "handles_square",
    "sketch:type": "MSLayerGroup"
  }))), /* @__PURE__ */ e.createElement("metadata", {
    id: "metadata138"
  }, /* @__PURE__ */ e.createElement("rdf:RDF", null, /* @__PURE__ */ e.createElement("cc:Work", {
    "rdf:about": ""
  }, /* @__PURE__ */ e.createElement("dc:title", null, "btn_google_light_normal_ios")))));
}
function i0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.5 3.00391H2.5C1.39543 3.00391 0.5 3.89934 0.5 5.00391V19.0039C0.5 20.1085 1.39543 21.0039 2.5 21.0039H21.5C22.6046 21.0039 23.5 20.1085 23.5 19.0039V5.00391C23.5 3.89934 22.6046 3.00391 21.5 3.00391Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 8.00391H23.5"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 15.0139C13 15.4117 12.842 15.7933 12.5607 16.0746C12.2794 16.3559 11.8978 16.5139 11.5 16.5139C11.1022 16.5139 10.7206 16.3559 10.4393 16.0746C10.158 15.7933 10 15.4117 10 15.0139V13.0139C10 12.6161 10.158 12.2346 10.4393 11.9533C10.7206 11.672 11.1022 11.5139 11.5 11.5139C11.8978 11.5139 12.2794 11.672 12.5607 11.9533C12.842 12.2346 13 12.6161 13 13.0139V15.0139Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.987 16.5039V15.5039"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.987 15.5V11.51C7.21012 11.8929 6.53465 12.4539 6.01559 13.1472C5.49653 13.8406 5.14855 14.6467 5 15.5H7.987Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 16.5039V15.5039"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 15.5V11.51C17.2231 11.8929 16.5476 12.4539 16.0286 13.1472C15.5095 13.8406 15.1616 14.6467 15.013 15.5H18Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M4 5.75391C3.86193 5.75391 3.75 5.64198 3.75 5.50391C3.75 5.36584 3.86193 5.25391 4 5.25391"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M4 5.75391C4.13807 5.75391 4.25 5.64198 4.25 5.50391C4.25 5.36584 4.13807 5.25391 4 5.25391"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M7 5.75391C6.86193 5.75391 6.75 5.64198 6.75 5.50391C6.75 5.36584 6.86193 5.25391 7 5.25391"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M7 5.75391C7.13807 5.75391 7.25 5.64198 7.25 5.50391C7.25 5.36584 7.13807 5.25391 7 5.25391"
  }), /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M10 5.75391C9.86193 5.75391 9.75 5.64198 9.75 5.50391C9.75 5.36584 9.86193 5.25391 10 5.25391"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "#e53e3e",
    d: "M10 5.75391C10.1381 5.75391 10.25 5.64198 10.25 5.50391C10.25 5.36584 10.1381 5.25391 10 5.25391"
  }))));
}
function c0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M11.5,9.5a.25.25,0,1,0,.25.25.25.25,0,0,0-.25-.25h0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M11.5 7.5L11.5 4.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M12.338,1.5a.95.95,0,0,0-1.676,0L5.606,11.137a.923.923,0,0,0,.031.914.947.947,0,0,0,.807.449H16.556a.948.948,0,0,0,.807-.448.923.923,0,0,0,.031-.914Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M7.5,15.5h-5v3a1,1,0,0,0,1,1h2a2,2,0,0,1,0,4h-3",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M14.5,21a2.5,2.5,0,0,1-5,0V18a2.5,2.5,0,0,1,5,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M21.5,21a2.5,2.5,0,0,1-5,0V18a2.5,2.5,0,0,1,5,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function d0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    width: 94,
    height: 36,
    viewBox: "0 0 94 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    clipPath: "url(#clip0_3214_82)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M8.53845 35.5639C7.55238 36.0495 6.42169 36.0738 5.02899 35.4987L0.0803333 33.457C0.0646695 33.4506 0.0504141 33.4411 0.0383869 33.429C0.0263596 33.417 0.0167981 33.4027 0.0102523 33.3869C0.00370639 33.3711 0.000305413 33.3541 0.000244961 33.337C0.000184509 33.3199 0.0034656 33.3029 0.00989983 33.2871L0.426396 31.659C0.432737 31.6431 0.442112 31.6287 0.453983 31.6165C0.465853 31.6043 0.479984 31.5946 0.495563 31.588C0.511142 31.5813 0.527862 31.5779 0.544761 31.5778C0.561659 31.5777 0.578402 31.5811 0.594028 31.5876L5.87372 33.7698C6.17037 33.9265 6.49703 34.0162 6.83117 34.0326C7.16531 34.0491 7.499 33.9919 7.80923 33.865C8.36139 33.5874 8.79451 33.1149 9.02712 32.5363C9.25973 31.9577 9.27581 31.3129 9.07234 30.7231C8.93867 30.4121 8.74 30.1343 8.49006 29.9088C8.24012 29.6832 7.94486 29.5154 7.62469 29.4168L2.17784 27.1319C2.16218 27.1254 2.14792 27.1159 2.13589 27.1039C2.12387 27.0919 2.11431 27.0775 2.10776 27.0617C2.10121 27.0459 2.09781 27.029 2.09775 27.0119C2.09769 26.9947 2.10097 26.9778 2.10741 26.9619L2.81174 25.4814C2.81808 25.4656 2.82746 25.4511 2.83933 25.4389C2.8512 25.4267 2.86533 25.417 2.88091 25.4104C2.89649 25.4038 2.91321 25.4003 2.93011 25.4002C2.947 25.4002 2.96375 25.4035 2.97937 25.41L8.21164 27.5808C9.60387 28.1563 10.3974 28.977 10.766 30.0209C11.0546 31.0644 10.9921 32.1755 10.5886 33.179C10.1851 34.1824 9.4634 35.021 8.53751 35.5625L8.53845 35.5639Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M5.96059 19.8532L6.55881 18.9407C6.5703 18.9265 6.5846 18.9149 6.60077 18.9067C6.61695 18.8985 6.63465 18.8939 6.65272 18.8931L15.1986 18.6869L10.2101 14.6406C10.1835 14.6189 10.1665 14.5875 10.1628 14.5531C10.1591 14.5187 10.169 14.4843 10.1904 14.4573L11.3225 13.2129C11.3438 13.186 11.3749 13.1688 11.4088 13.165C11.4427 13.1613 11.4766 13.1713 11.5032 13.193L19.1002 19.3539C19.1268 19.3755 19.1438 19.407 19.1475 19.4414C19.1512 19.4757 19.1412 19.5102 19.1199 19.5371L18.1573 20.5173C18.1458 20.5315 18.1315 20.543 18.1153 20.5512C18.0992 20.5594 18.0815 20.5641 18.0634 20.5649L9.79405 20.6701L14.6803 24.6688C14.7068 24.6905 14.7238 24.722 14.7275 24.7563C14.7312 24.7907 14.7213 24.8252 14.7 24.8521L13.7637 26.2222C13.7423 26.2491 13.7113 26.2663 13.6774 26.2701C13.6435 26.2738 13.6095 26.2638 13.5829 26.2421L5.98031 20.036C5.96712 20.0254 5.95613 20.0122 5.94799 19.9972C5.93985 19.9822 5.93472 19.9658 5.93289 19.9488C5.93105 19.9318 5.93256 19.9146 5.93731 19.8982C5.94207 19.8818 5.94998 19.8665 5.96059 19.8532Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M16.5984 8.68061L17.9324 7.71377C17.9601 7.69371 17.9946 7.68566 18.0283 7.69137C18.0619 7.69708 18.0919 7.7161 18.1117 7.74424L23.6821 15.6465C23.7019 15.6746 23.7098 15.7096 23.7042 15.7437C23.6986 15.7778 23.6798 15.8082 23.652 15.8283L22.318 16.7951C22.2902 16.8152 22.2558 16.8233 22.2221 16.8175C22.1885 16.8118 22.1585 16.7928 22.1386 16.7647L16.5683 8.86245C16.5485 8.83429 16.5406 8.79932 16.5462 8.76522C16.5518 8.73113 16.5706 8.70069 16.5984 8.68061Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M48.4004 0.338003C49.9499 0.515566 50.9313 0.971136 51.661 1.65711C52.2189 2.19689 52.6444 2.86164 52.9034 3.5981C53.1623 4.33456 53.2476 5.12228 53.1523 5.89815C53.0745 6.67631 52.818 7.42518 52.4033 8.08477C51.9887 8.74436 51.4275 9.29633 50.7646 9.69647C49.9025 10.1996 48.8455 10.4234 47.296 10.2458L44.3519 9.90926C44.3183 9.9053 44.2876 9.8881 44.2664 9.86137C44.2452 9.83464 44.2353 9.80055 44.2387 9.76644L45.3126 0.115217C45.3165 0.0811638 45.3334 0.0500352 45.3598 0.0285652C45.3862 0.00709519 45.4198 -0.00298987 45.4534 0.000491664L48.4004 0.338003ZM50.7951 3.44988C50.5363 3.04358 50.1857 2.70559 49.7725 2.46387C49.3593 2.22216 48.8952 2.08366 48.4187 2.05984L47.025 1.89942L46.3005 8.41068L47.697 8.57063C48.1667 8.65501 48.6495 8.6248 49.1054 8.4825C49.5614 8.34021 49.9774 8.08992 50.319 7.75232C50.8568 7.1904 51.192 6.46099 51.2703 5.68203C51.365 4.90517 51.1982 4.11865 50.797 3.44988H50.7951Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M39.6465 0.00528326C37.4818 0.265677 35.4787 0.581291 33.3441 0.95165C33.3268 0.953915 33.3102 0.959662 33.2952 0.968552C33.2802 0.977442 33.2671 0.989294 33.2566 1.00341C33.2462 1.01752 33.2387 1.03361 33.2345 1.05072C33.2303 1.06784 33.2296 1.08562 33.2323 1.10303C33.8449 4.30456 34.4193 7.50989 34.9556 10.719C34.9584 10.7358 34.9644 10.752 34.9734 10.7665C34.9823 10.7809 34.994 10.7935 35.0077 10.8034C35.0215 10.8133 35.037 10.8204 35.0534 10.8242C35.0699 10.828 35.0869 10.8285 35.1035 10.8256C37.0061 10.481 38.7595 10.2168 40.6912 9.96879C40.7079 9.96695 40.724 9.9618 40.7388 9.95363C40.7535 9.94545 40.7665 9.93442 40.777 9.92116C40.7875 9.90789 40.7953 9.89266 40.8 9.87633C40.8047 9.86 40.8062 9.84289 40.8044 9.82598C40.7474 9.34645 40.6898 8.86692 40.6316 8.38739C40.6293 8.37018 40.6237 8.3536 40.6152 8.33859C40.6066 8.32358 40.5951 8.31043 40.5815 8.2999C40.5679 8.28938 40.5524 8.28168 40.5358 8.27725C40.5193 8.27282 40.502 8.27175 40.4851 8.27409C39.1266 8.4369 37.9391 8.58923 36.5934 8.79773C36.4502 7.88279 36.3215 7.06733 36.1708 6.15334C37.1612 5.99878 38.1548 5.85597 39.1515 5.7249C39.1686 5.72307 39.1851 5.71782 39.2002 5.70946C39.2152 5.7011 39.2285 5.68979 39.2392 5.6762C39.2499 5.6626 39.2578 5.64699 39.2625 5.63026C39.2672 5.61354 39.2686 5.59603 39.2666 5.57876C39.2005 5.09986 39.1332 4.62128 39.0647 4.14302C39.0586 4.10783 39.0392 4.07644 39.0106 4.05555C38.982 4.03465 38.9465 4.0259 38.9116 4.03115C37.9011 4.16286 36.8942 4.30725 35.8909 4.46435C35.7768 3.78456 35.6439 3.00576 35.5266 2.32693C36.9667 2.09796 38.2669 1.89326 39.7216 1.71427C39.7512 1.71159 39.7791 1.69886 39.8008 1.67813C39.8224 1.6574 39.8365 1.62988 39.8409 1.60002C39.828 1.11668 39.8147 0.633021 39.8009 0.149047C39.8024 0.128657 39.7993 0.108198 39.7918 0.0891979C39.7844 0.0701981 39.7728 0.0531491 39.758 0.0393248C39.7431 0.0255004 39.7253 0.0152583 39.706 0.00936358C39.6867 0.00346886 39.6664 0.00207399 39.6465 0.00528326Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M29.5087 3.66122L29.1026 2.26833C29.0984 2.24972 29.0903 2.23225 29.0787 2.21716C29.0672 2.20206 29.0526 2.18971 29.0359 2.18095C29.0191 2.1722 29.0007 2.16726 28.9819 2.16649C28.9631 2.16571 28.9443 2.16911 28.9269 2.17646L22.4217 4.96033C22.3902 4.97387 22.3653 4.99952 22.3525 5.03165C22.3396 5.06378 22.3399 5.09976 22.3532 5.13171L22.9134 6.46462C22.92 6.48038 22.9296 6.49466 22.9417 6.50663C22.9538 6.51861 22.9682 6.52805 22.9839 6.53442C22.9996 6.54078 23.0163 6.54395 23.0332 6.54374C23.0501 6.54352 23.0668 6.53993 23.0824 6.53317L25.2372 5.60204C25.2686 5.58851 25.304 5.58812 25.3356 5.60097C25.3673 5.61381 25.3927 5.63884 25.4062 5.67058L28.5001 13.032C28.5068 13.0478 28.5164 13.0621 28.5285 13.0741C28.5406 13.086 28.5549 13.0955 28.5706 13.1018C28.5863 13.1082 28.6031 13.1114 28.62 13.1112C28.6369 13.111 28.6536 13.1074 28.6692 13.1006L30.1774 12.4489C30.2086 12.4351 30.2332 12.4093 30.2457 12.3772C30.2582 12.3451 30.2576 12.3092 30.2441 12.2775L27.1501 4.91749C27.1435 4.90165 27.14 4.88464 27.1399 4.86743C27.1398 4.85023 27.1431 4.83317 27.1495 4.81724C27.1559 4.80131 27.1654 4.78682 27.1773 4.77462C27.1893 4.76241 27.2035 4.75273 27.2192 4.74612L29.4313 3.80975C29.4594 3.79822 29.4826 3.77699 29.4967 3.74982C29.5109 3.72264 29.5152 3.69127 29.5087 3.66122Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M41.0547 31.7913C41.0687 31.7813 41.0846 31.7743 41.1014 31.7706C41.1181 31.767 41.1355 31.7669 41.1523 31.7702C41.1692 31.7735 41.1852 31.7803 41.1994 31.7901C41.2136 31.7998 41.2257 31.8124 41.235 31.827C41.6939 32.5441 42.4122 33.0497 43.2353 33.2352C44.0636 33.3975 44.8688 32.9933 45.005 32.2798C45.2445 31.0206 43.3517 30.5184 42.2008 29.494C41.8377 29.2048 41.5625 28.8175 41.4071 28.3766C41.2517 27.9358 41.2223 27.4594 41.3223 27.0024C41.6548 25.2539 43.3691 24.5565 44.9689 24.8697C45.9387 25.0377 46.8285 25.5203 47.5045 26.245C47.528 26.2702 47.5408 26.3037 47.5401 26.3384C47.5394 26.373 47.5252 26.406 47.5007 26.4302L46.4654 27.447C46.4528 27.4593 46.4378 27.469 46.4215 27.4754C46.4051 27.4817 46.3877 27.4847 46.3702 27.4842C46.3526 27.4836 46.3354 27.4794 46.3195 27.472C46.3036 27.4646 46.2893 27.454 46.2775 27.4408C45.895 27.001 45.3821 26.6988 44.8158 26.5797C44.1115 26.4426 43.3315 26.5963 43.1878 27.3513C42.8873 28.9322 47.5012 29.3136 46.8739 32.6139C46.5452 34.3486 44.6552 35.2512 42.9169 34.9118C41.6611 34.6452 40.5465 33.9179 39.7869 32.8696C39.7763 32.8555 39.7687 32.8395 39.7643 32.8224C39.76 32.8053 39.7591 32.7875 39.7617 32.7701C39.7643 32.7526 39.7703 32.7359 39.7794 32.7209C39.7885 32.7058 39.8004 32.6928 39.8146 32.6825L41.0547 31.7913Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M90.1707 12.8907C90.1644 12.8743 90.1614 12.8568 90.1619 12.8392C90.1623 12.8216 90.1663 12.8043 90.1736 12.7883C90.1808 12.7723 90.1912 12.7579 90.204 12.7461C90.2168 12.7342 90.2319 12.7251 90.2482 12.7193C91.0517 12.4335 91.7124 11.8395 92.0884 11.0651C92.4429 10.2796 92.2762 9.44227 91.6189 9.13713C90.4572 8.59826 89.4843 10.301 88.2198 11.2012C87.8501 11.4935 87.4067 11.6746 86.9404 11.7238C86.474 11.7729 86.0034 11.6882 85.5823 11.4792C83.9689 10.7309 83.7195 8.86103 84.4041 7.34389C84.7983 6.4188 85.4778 5.64826 86.3406 5.14793C86.3706 5.1305 86.4062 5.12572 86.4396 5.13463C86.4731 5.14353 86.5018 5.1654 86.5195 5.19553L87.2567 6.46846C87.266 6.48401 87.2721 6.50132 87.2745 6.51933C87.277 6.53735 87.2758 6.55569 87.271 6.57321C87.2662 6.59074 87.2579 6.60708 87.2466 6.62124C87.2354 6.6354 87.2214 6.64707 87.2055 6.65554C86.6881 6.93063 86.2733 7.36914 86.0237 7.90467C85.7227 8.57112 85.6692 9.38372 86.366 9.70695C87.824 10.3829 89.3444 5.94624 92.3899 7.35865C93.9902 8.1008 94.3813 10.1349 93.637 11.7824C93.0792 12.9681 92.1095 13.9035 90.9136 14.4092C90.8974 14.4164 90.8799 14.4202 90.8622 14.4204C90.8446 14.4206 90.827 14.4172 90.8107 14.4104C90.7943 14.4035 90.7795 14.3934 90.7671 14.3806C90.7547 14.3678 90.7449 14.3526 90.7384 14.3359L90.1707 12.8907Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M87.7426 17.7358C86.8476 18.7717 85.9499 19.8009 85.0248 20.8234C84.3041 20.2136 83.704 19.6838 82.9968 19.0659C83.6652 18.3359 84.3254 17.6039 84.9774 16.8699C84.9888 16.8572 84.9975 16.8423 85.0031 16.8261C85.0086 16.8099 85.0109 16.7927 85.0097 16.7756C85.0086 16.7585 85.0041 16.7418 84.9964 16.7265C84.9888 16.7112 84.9782 16.6977 84.9652 16.6866C84.5974 16.3693 84.2318 16.05 83.8683 15.7288C83.842 15.7052 83.8075 15.693 83.7723 15.695C83.7372 15.6969 83.7041 15.7128 83.6805 15.7393C83.0272 16.4692 82.366 17.1964 81.6971 17.921C81.1773 17.4583 80.5481 16.9094 80.0363 16.4419C81.019 15.3999 81.6868 14.6296 82.6362 13.5724C82.6561 13.5503 82.6679 13.5219 82.6694 13.492C82.671 13.4621 82.6622 13.4327 82.6447 13.4086C82.2909 13.0373 81.9393 12.6646 81.5896 12.2904C81.5784 12.2746 81.5639 12.2616 81.5471 12.2523C81.5304 12.2429 81.5118 12.2374 81.4927 12.2362C81.4736 12.2351 81.4545 12.2382 81.4367 12.2454C81.419 12.2526 81.403 12.2638 81.39 12.278C80.0396 13.8209 78.953 15.07 77.5345 16.5809C77.5225 16.5931 77.513 16.6077 77.5067 16.6237C77.5004 16.6397 77.4974 16.6568 77.4978 16.6741C77.4983 16.6913 77.5021 16.7083 77.5093 16.7239C77.5164 16.7396 77.5265 16.7536 77.5392 16.7652C79.9461 19.0097 82.3615 21.12 84.9413 23.2636C84.9692 23.2863 85.0044 23.2977 85.0401 23.2954C85.0759 23.2931 85.1094 23.2773 85.1343 23.2512C86.4556 21.7645 87.8131 20.3502 89.0729 18.8364C89.0841 18.8235 89.0926 18.8083 89.0978 18.792C89.1031 18.7756 89.105 18.7583 89.1034 18.7412C89.1019 18.7241 89.0969 18.7074 89.0889 18.6923C89.0808 18.6771 89.0698 18.6638 89.0565 18.6531C88.678 18.3434 88.3011 18.0325 87.9258 17.7206C87.899 17.699 87.8653 17.6886 87.8312 17.6915C87.7972 17.6943 87.7655 17.7101 87.7426 17.7358Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M63.9282 24.4027C63.525 24.5322 63.1181 24.6546 62.7074 24.7698C62.6828 24.7763 62.6607 24.7902 62.6439 24.8097C62.6272 24.8291 62.6166 24.8532 62.6135 24.8788L61.3513 35.3959C61.3492 35.4157 61.3516 35.4358 61.3584 35.4545C61.3651 35.4732 61.376 35.4901 61.3902 35.5039C61.4044 35.5177 61.4215 35.528 61.4402 35.534C61.459 35.5401 61.4788 35.5417 61.4983 35.5387L63.114 35.2845C63.1415 35.2802 63.1668 35.267 63.1862 35.2468C63.2056 35.2266 63.218 35.2006 63.2215 35.1726L63.5352 32.602L67.3344 31.5114L68.8989 33.5522C68.9157 33.5739 68.9388 33.5897 68.965 33.5972C68.9911 33.6048 69.019 33.6037 69.0445 33.5941L70.5325 32.9424C70.5516 32.9353 70.5687 32.9236 70.5824 32.9084C70.5962 32.8933 70.6062 32.875 70.6116 32.8552C70.617 32.8353 70.6177 32.8144 70.6136 32.7943C70.6094 32.7741 70.6007 32.7552 70.5879 32.7391L64.0611 24.4451C64.0456 24.4255 64.0247 24.411 64.001 24.4035C63.9774 24.3959 63.952 24.3957 63.9282 24.4027ZM63.769 30.7593L64.1799 27.577L66.1755 30.0681L63.769 30.7593Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M75.5559 19.4505C75.5498 19.4202 75.5336 19.393 75.5101 19.3734C75.4867 19.3537 75.4572 19.3428 75.4268 19.3424C74.3146 19.3526 73.2336 19.7171 72.3371 20.3845C71.7591 20.7701 71.2648 21.2714 70.8846 21.8575C70.5044 22.4436 70.2462 23.1022 70.126 23.793C70.0057 24.4839 70.0258 25.1923 70.1851 25.875C70.3444 26.5576 70.6395 27.2001 71.0524 27.7631C72.7329 30.1357 75.8419 30.7145 78.3817 28.8661C78.9646 28.4599 79.4626 27.941 79.8472 27.3392C80.2318 26.7373 80.4954 26.0644 80.6229 25.3591C80.6278 25.3283 80.6219 25.2968 80.6063 25.2699C80.5907 25.2431 80.5663 25.2226 80.5374 25.212L79.071 24.6622C79.0518 24.6551 79.0313 24.6526 79.0111 24.655C78.9908 24.6574 78.9714 24.6645 78.9544 24.6759C78.9373 24.6872 78.9231 24.7024 78.9129 24.7203C78.9026 24.7381 78.8966 24.7582 78.8954 24.7788C78.8573 25.3037 78.7045 25.8135 78.448 26.2711C78.1915 26.7287 77.8378 27.1228 77.4125 27.4246C77.0507 27.6968 76.6387 27.8927 76.201 28.0009C75.7633 28.1091 75.3086 28.1272 74.8638 28.0544C74.419 27.9815 73.9932 27.8191 73.6113 27.5767C73.2294 27.3343 72.8993 27.0168 72.6404 26.643C72.2345 26.1104 71.9936 25.4676 71.9483 24.7961C71.903 24.1246 72.0553 23.4546 72.3859 22.871C72.7166 22.2873 73.2106 21.8163 73.8055 21.5175C74.4004 21.2188 75.0694 21.1058 75.7278 21.1928C75.7483 21.1955 75.7692 21.1933 75.7887 21.1862C75.8082 21.1791 75.8257 21.1675 75.8399 21.1522C75.8541 21.1369 75.8644 21.1184 75.8702 21.0982C75.8759 21.078 75.8768 21.0568 75.8729 21.0362L75.5559 19.4505Z",
    fill: "black"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M54.2099 31.838L54.9856 31.8466C56.2501 31.8604 57.0122 31.5552 57.5512 30.9897C58.055 30.4255 58.3375 29.6939 58.3456 28.933C58.3536 28.1721 58.0866 27.4345 57.5949 26.8596C57.0526 26.2697 56.3116 25.9484 55.0476 25.9346L51.4789 25.8965C51.4621 25.8963 51.4453 25.8994 51.4296 25.9057C51.414 25.9121 51.3996 25.9215 51.3876 25.9334C51.3755 25.9454 51.3659 25.9596 51.3592 25.9753C51.3526 25.9911 51.3491 26.008 51.3489 26.0251L51.2258 35.8453C51.2255 35.8798 51.2386 35.913 51.2624 35.9378C51.2861 35.9625 51.3186 35.9766 51.3526 35.9771L53.0012 36C53.0181 36.0002 53.0349 35.9971 53.0506 35.9908C53.0662 35.9845 53.0805 35.9751 53.0926 35.9631C53.1047 35.9512 53.1143 35.9369 53.121 35.9212C53.1276 35.9055 53.1311 35.8886 53.1313 35.8715L53.1783 32.4368V31.8384L54.2099 31.838ZM56.1167 29.7501C55.957 29.8993 55.7669 30.0113 55.5599 30.078C55.3528 30.1447 55.1339 30.1645 54.9184 30.1361L53.2041 30.1181L53.2294 27.625L54.9466 27.6441C55.1626 27.6202 55.3811 27.6447 55.5867 27.7158C55.7923 27.787 55.98 27.9031 56.1365 28.0558C56.3459 28.2899 56.4586 28.5967 56.4511 28.9127C56.4524 29.2254 56.3325 29.5261 56.1172 29.7501H56.1167Z",
    fill: "black"
  })), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", {
    id: "clip0_3214_82"
  }, /* @__PURE__ */ e.createElement("rect", {
    width: 94,
    height: 36,
    fill: "white"
  }))));
}
function p0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.40381 17.1923V10.2692"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.5962 17.1923V10.2692"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M0.75 5.07692H23.25"
  }), /* @__PURE__ */ e.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z"
  }));
}
function u0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ...t
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M23.25,23.23a.75.75,0,0,0,.66-1.1l-11.25-21a.78.78,0,0,0-1.32,0L.09,22.13a.73.73,0,0,0,0,.74.73.73,0,0,0,.64.36ZM12,20.48A1.5,1.5,0,1,1,13.5,19,1.5,1.5,0,0,1,12,20.48ZM12,8.23a1,1,0,0,1,1,1V14.7a1,1,0,0,1-2,0V9.23A1,1,0,0,1,12,8.23Z",
    fill: "currentColor"
  }));
}
function C0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ...t
  }, /* @__PURE__ */ e.createElement("g", {
    transform: "translate(0,0)"
  }, /* @__PURE__ */ e.createElement("path", {
    d: "M8.9046125 11.92c0 0.696375 -0.75384375 1.13160625 -1.35691875 0.78341875 -0.60308125 -0.3481875 -0.60308125 -1.21865 0 -1.5668375 0.13751875 -0.0794 0.2935125 -0.1212 0.45230625 -0.1212 0.49960625 0 0.9046125 0.4050125 0.9046125 0.90461875ZM8 3.7784625c-1.6629875 0 -3.0153875 1.2174625 -3.0153875 2.71384375v0.3015375c0 0.46425 0.50256875 0.75440625 0.90461875 0.52228125 0.18659375 -0.107725 0.3015375 -0.30681875 0.3015375 -0.52228125v-0.3015375c0 -0.82923125 0.81189375 -1.50769375 1.80923125 -1.50769375s1.80923125 0.6784625 1.80923125 1.50769375S8.9973375 8 8 8c-0.33308125 -0.0000125 -0.603075 0.26999375 -0.603075 0.603075v0.60308125c0 0.46424375 0.5025625 0.7544 0.9046125 0.522275 0.18659375 -0.107725 0.3015375 -0.30681875 0.3015375 -0.522275v-0.05428125c1.37501875 -0.2525375 2.41230625 -1.34938125 2.41230625 -2.65956875 0 -1.49638125 -1.3524 -2.71384375 -3.01538125 -2.71384375ZM15.84 8c0 6.0352375 -6.53333125 9.80725625 -11.76 6.7896375 -5.22666875 -3.01761875 -5.22666875 -10.5616625 0 -13.579275C5.27183125 0.52225625 6.62379375 0.16 8 0.16c4.32801875 0.004575 7.83543125 3.51198125 7.84 7.84Zm-1.20615625 0c0 -5.1067375 -5.5282 -8.29845 -9.95076875 -5.74508125 -4.4225625 2.55336875 -4.4225625 8.93679375 0 11.4901625 1.008475 0.5822375 2.15244375 0.8887625 3.316925 0.8887625 3.66205 -0.00415 6.62969375 -2.97179375 6.63384375 -6.63384375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.0625
  })));
}
const Et = i(J1), wt = i(i0), xt = i(Y1), m0 = i(Q1), Ft = i(X1), vt = i(n1), yt = i(r1), bt = i(l1), Mt = i(s1), At = i(a1), St = i(i1), jt = i(c1), f0 = i(d1), Bt = i(p1), Ht = i(u1), Rt = i(C1), Zt = i(m1), Nt = i(f1), Dt = i(h1), Vt = i(g1), _t = i(k1), It = i(L1), Tt = i(E1), $t = i(w1), Wt = i(x1), Pt = i(v1), zt = i(F1), Ot = i(y1), Gt = i(b1), Ut = i(M1), qt = i(A1), Yt = i(S1), Qt = i(j1), Xt = i(B1), Jt = i(H1), h0 = i(R1), Kt = i(Z1), eo = z1, to = i(N1), oo = i(D1), no = i(V1), ro = i(_1), lo = i(I1), so = i(T1), ao = i($1), io = i(W1), co = i(c0), po = i(P1), uo = i(O1), Co = i(G1), mo = i(U1), ne = i(q1), fo = i(K1), ho = i(e0), go = i(t0), ko = i(o0), Lo = i(n0), Eo = i(r0), wo = i(l0), g0 = i(s0), k0 = i(a0), xo = i(d0), Fo = i(p0), vo = i(u0), yo = i(C0), bo = ({
  filled: t = !1,
  ...n
}) => /* @__PURE__ */ o(i.svg, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...n,
  children: /* @__PURE__ */ o("g", {
    transform: "matrix(1,0,0,1,0,0)",
    children: /* @__PURE__ */ o("path", {
      d: "M12,21.932,2.2,11.84A5.667,5.667,0,0,1,1.113,5.233h0A5.839,5.839,0,0,1,10.4,3.746L12,5.205l1.6-1.459a5.84,5.84,0,0,1,9.287,1.487h0A5.669,5.669,0,0,1,21.8,11.84Z",
      fill: t ? "currentColor" : "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
});
function L0(t) {
  return /* @__PURE__ */ e.createElement("svg", {
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  }, /* @__PURE__ */ e.createElement("ellipse", {
    cx: 16.2038,
    cy: 13.5,
    rx: 9.7963,
    ry: 11.5,
    fill: "#7FACFA"
  }), /* @__PURE__ */ e.createElement("ellipse", {
    cx: 12.7963,
    cy: 13.5,
    rx: 9.7963,
    ry: 11.5,
    fill: "white"
  }), /* @__PURE__ */ e.createElement("ellipse", {
    cx: 14.5,
    cy: 13.5,
    rx: 9.5,
    ry: 11.5,
    fill: "#D5E1F5"
  }), /* @__PURE__ */ e.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 12.5,
    stroke: "#007AFF",
    strokeWidth: 2
  }), /* @__PURE__ */ e.createElement("line", {
    x1: 27.5858,
    y1: 26.8159,
    x2: 23.4922,
    y2: 22.7223,
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /* @__PURE__ */ e.createElement("path", {
    d: "M13.0066 16.162H14.9826V15.516C14.9826 13.179 18.3646 13.331 18.3646 10.196C18.3646 8.011 16.6546 6.7 14.2226 6.7C11.2016 6.7 9.89063 8.733 9.89063 10.88H11.8856C11.8856 9.55 12.5696 8.41 14.2226 8.41C15.4766 8.41 16.2746 9.227 16.2746 10.291C16.2746 12.419 13.0066 12.172 13.0066 15.668V16.162ZM12.8546 20H15.1156V17.72H12.8546V20Z",
    fill: "#007AFF"
  }));
}
const Mo = i(L0), Ao = (t) => /* @__PURE__ */ d(y, {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [/* @__PURE__ */ o("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    stroke: "#007AFF"
  }), /* @__PURE__ */ o("path", {
    d: "M14.2506 9.368V7.288H16.7466V9.368H14.2506ZM14.3146 19V11.192H16.6826V19H14.3146Z",
    fill: "#007AFF"
  })]
}), So = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(N, {
  variant: "outline",
  w: "full",
  color: "grey.800",
  leftIcon: /* @__PURE__ */ o(k0, {}),
  justifyContent: "start",
  fontFamily: "Roboto, FaktPro, sans-serif",
  ...n,
  children: "Continue with Google"
}), jo = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(N, {
  leftIcon: /* @__PURE__ */ o(g0, {}),
  variant: "outline",
  w: "full",
  color: "grey.800",
  justifyContent: "start",
  fontFamily: "Segoe UI, FaktPro, sans-serif",
  ...n,
  children: "Continue with Microsoft"
}), we = ({
  variant: t = "horizontal",
  center: n,
  spaceBetween: r,
  className: l,
  children: s,
  ...a
}) => /* @__PURE__ */ o("div", {
  ...a,
  className: f("grid-container", [{
    "space-between": r,
    center: n
  }, t, l]),
  children: s
}), A = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(we, {
  ...n,
  variant: "horizontal",
  children: t
}), Z = ({
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ o("div", {
  ...r,
  className: f("grid-item", t),
  children: n
});
function E0(t) {
  const {
    link: n = "#",
    variant: r = "rectangular-fill",
    className: l,
    color: s = "blue",
    component: a = "a",
    action: c,
    disabled: p,
    noFollow: u,
    isExternal: C,
    ...h
  } = t;
  return {
    Component: a,
    newProps: {
      ...h,
      onClick: (g) => {
        const m = g;
        (p || n === "#") && m.preventDefault(), !p && c && c(m);
      },
      className: f("button", l, {
        [r]: !0,
        [s]: !0,
        disabled: p
      }),
      to: t.component ? n : void 0,
      href: t.component ? void 0 : n,
      rel: u ? C ? "nofollow noopener" : "nofollow" : C ? "noopner" : void 0,
      target: C ? "_blank" : void 0
    }
  };
}
const b = (t) => {
  const {
    Component: n,
    newProps: r
  } = E0(t), {
    text: l,
    children: s,
    ...a
  } = r;
  return /* @__PURE__ */ o(n, {
    ...a,
    children: l || s
  });
}, re = (t) => /* @__PURE__ */ o(b, {
  ...t
}), xe = (t) => /* @__PURE__ */ o(b, {
  ...t,
  className: "bold-16"
}), Fe = (t) => /* @__PURE__ */ o(b, {
  variant: "rectangular-stroke",
  ...t
}), w0 = (t) => /* @__PURE__ */ o(Fe, {
  color: "blue",
  ...t
}), x0 = ({
  action: t,
  link: n,
  text: r,
  ...l
}) => /* @__PURE__ */ o(re, {
  action: t,
  link: n,
  ...l,
  children: r
}), F0 = ({
  action: t,
  link: n,
  text: r,
  ...l
}) => /* @__PURE__ */ o(Fe, {
  action: t,
  link: n,
  ...l,
  children: r
}), v0 = ({
  primaryButton: t,
  secondaryButton: n
}) => /* @__PURE__ */ d(A, {
  className: f("button-group", "actions"),
  children: [/* @__PURE__ */ o(x0, {
    ...t
  }), /* @__PURE__ */ o(F0, {
    ...n
  })]
}), ve = (t) => /* @__PURE__ */ o(b, {
  variant: "square-fill",
  ...t,
  children: /* @__PURE__ */ o(Ee, {})
}), ye = (t) => /* @__PURE__ */ o(b, {
  variant: "square-fill",
  ...t,
  children: /* @__PURE__ */ o(oe, {})
}), be = ({
  onLeftClick: t,
  onRightClick: n,
  color: r = "blue"
}) => /* @__PURE__ */ d(A, {
  className: f("button-group", "arrows"),
  children: [/* @__PURE__ */ o(ve, {
    color: r,
    action: t
  }), /* @__PURE__ */ o(ye, {
    color: r,
    action: n
  })]
}), y0 = (t) => /* @__PURE__ */ o(be, {
  ...t
}), b0 = (t) => /* @__PURE__ */ o(be, {
  color: "yellow",
  ...t
}), M0 = (t) => /* @__PURE__ */ o(b, {
  variant: "round-stroke",
  ...t,
  children: /* @__PURE__ */ o(oe, {})
}), A0 = (t) => /* @__PURE__ */ o(b, {
  variant: "flat",
  color: "grey",
  ...t
}), S0 = (t) => /* @__PURE__ */ o(b, {
  variant: "flat",
  color: "dark-grey",
  ...t
}), j0 = ({
  selected: t,
  ...n
}) => /* @__PURE__ */ o(b, {
  variant: "oval-fill",
  color: t ? "blue" : "dark-blue",
  ...n
}), Me = ({
  links: t,
  activeIndex: n,
  action: r,
  className: l
}) => /* @__PURE__ */ o(A, {
  className: f("button-group", ["links", l]),
  center: !0,
  children: t.map((s, a) => a !== n ? /* @__PURE__ */ o(A0, {
    action: () => r(a),
    children: s
  }, s) : /* @__PURE__ */ o(S0, {
    children: s
  }, s))
}), X = ({
  small: t,
  className: n,
  ...r
}) => /* @__PURE__ */ o(b, {
  variant: "flat-text",
  ...r,
  className: F({
    small: !!t
  }, n)
}), Bo = ({
  children: t,
  variant: n,
  size: r,
  ...l
}) => {
  const s = V("Banner", {
    variant: n,
    size: r
  });
  return /* @__PURE__ */ o(E, {
    as: "aside",
    __css: s.banner,
    ...l,
    children: /* @__PURE__ */ o(z, {
      value: s,
      children: t
    })
  });
}, Ho = ({
  children: t
}) => {
  const n = x();
  return /* @__PURE__ */ d(E, {
    __css: n.image,
    children: [t, /* @__PURE__ */ o(E, {
      __css: n.starIconWrapper,
      children: /* @__PURE__ */ o(ne, {
        __css: n.starIcon
      })
    })]
  });
}, Ro = ({
  children: t
}) => {
  const n = x();
  return /* @__PURE__ */ o(E, {
    __css: n.image,
    children: t
  });
}, Zo = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.h1, {
    __css: r.heading,
    ...n,
    children: t
  });
}, No = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.p, {
    __css: r.subHeading,
    ...n,
    children: t
  });
}, Do = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.p, {
    __css: r.imageText,
    ...n,
    children: t
  });
}, Vo = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.div, {
    __css: r.imageText,
    ...n,
    children: /* @__PURE__ */ d(j, {
      alignItems: "center",
      gap: 1,
      children: [/* @__PURE__ */ o(E, {
        __css: r.starIconWrapper,
        children: /* @__PURE__ */ o(ne, {
          __css: r.starIcon
        })
      }), t]
    })
  });
}, _o = ({
  ...t
}) => {
  const n = x();
  return /* @__PURE__ */ o(i.div, {
    __css: n.backgroundCircle,
    ...t
  });
}, Io = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.button, {
    __css: r.button,
    ...n,
    children: t
  });
}, To = ({
  children: t,
  variant: n,
  size: r,
  ...l
}) => {
  const s = V("SeoBanner", {
    variant: n,
    size: r
  });
  return /* @__PURE__ */ o(E, {
    as: "aside",
    __css: s.seoBanner,
    ...l,
    children: /* @__PURE__ */ o(z, {
      value: s,
      children: t
    })
  });
}, $o = ({
  ...t
}) => {
  const n = x();
  return /* @__PURE__ */ o(i.div, {
    __css: n.mainSection,
    ...t
  });
}, Wo = ({
  children: t
}) => {
  const n = x();
  return /* @__PURE__ */ d(E, {
    __css: n.image,
    children: [t, /* @__PURE__ */ o(E, {
      __css: n.starIconWrapper,
      children: /* @__PURE__ */ o(ne, {
        __css: n.starIcon
      })
    })]
  });
}, Po = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.p, {
    __css: r.imageText,
    ...n,
    children: t
  });
}, zo = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.h1, {
    __css: r.mainText,
    ...n,
    children: t
  });
}, Oo = ({
  children: t,
  ...n
}) => {
  const r = x();
  return /* @__PURE__ */ o(i.button, {
    __css: r.button,
    ...n,
    children: t
  });
}, Go = ({
  ...t
}) => {
  const n = x();
  return /* @__PURE__ */ o(i.div, {
    __css: n.footer,
    ...t
  });
}, Uo = ({
  height: t,
  ...n
}) => {
  const r = V("Chart");
  return /* @__PURE__ */ o(i.div, {
    __css: r.barWrapper,
    children: /* @__PURE__ */ o(i.div, {
      __css: {
        h: t
      },
      ...n
    })
  });
}, qo = ({
  children: t,
  ...n
}) => {
  const r = V("Chart");
  return /* @__PURE__ */ o(i.div, {
    __css: r.chartWrapper,
    ...n,
    children: t
  });
}, B0 = (t) => {
  const {
    color: n = "blue",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("h1", {
    className: f("hypertext", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, H0 = (t) => {
  const {
    color: n = "blue",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("h2", {
    className: f("headline", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, R0 = (t) => {
  const {
    color: n = "yellow",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("h3", {
    className: f("secondary-headline", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, Z0 = (t) => {
  const {
    color: n = "dark-blue",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("div", {
    className: f("headline-label", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, N0 = (t) => {
  const {
    color: n = "green",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("div", {
    className: f("title-label", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, D0 = (t) => {
  const {
    color: n = "black",
    className: r,
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o("div", {
    className: f("sub-headline", [`typography-${n}`, r]),
    ...s,
    children: l
  });
}, v = ({
  color: t = "dark-grey",
  size: n = "normal",
  italic: r,
  center: l,
  className: s,
  children: a,
  ...c
}) => /* @__PURE__ */ o("div", {
  className: f("body-text", [`typography-${t}`, {
    [n]: n,
    italic: r,
    center: l
  }, s]),
  ...c,
  children: a
}), Yo = ({
  children: t,
  className: n,
  ...r
}) => /* @__PURE__ */ o("span", {
  className: f("error-message", n),
  ...r,
  children: t
}), le = (t) => /* @__PURE__ */ d(A, {
  className: `${t.className || ""}`,
  children: [/* @__PURE__ */ o(Z, {}), /* @__PURE__ */ o(Z, {
    className: "section-maxwidth",
    children: t.children
  }), /* @__PURE__ */ o(Z, {})]
}), Qo = (t) => /* @__PURE__ */ o(y, {
  width: "226",
  height: "116",
  viewBox: "0 0 226 116",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0194 0C17.5483 0 -3.59827 26.2563 0.508684 52.9261C4.61564 79.5959 27.1264 101.47 60.8455 110.929C94.5646 120.387 156.769 117.615 192.656 94.0685C228.544 70.5226 238.404 29.439 207.645 10.5238C176.886 -8.39128 145.105 34.7053 118.456 26.6595C91.8071 18.6138 82.4905 0 50.0194 0Z",
    fill: t.color ? t.color : "#F2F8FF"
  })
}), V0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "169",
  height: "162",
  viewBox: "0 0 169 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.851 1.74237C163.487 13.6732 202.566 105.885 126.446 146.62C50.3265 187.355 -10.1061 137.321 1.41355 110.101C12.9332 82.8814 51.0429 101.154 71.5454 71.5779C92.0478 42.0013 58.2142 -10.1885 110.851 1.74237Z",
    fill: "currentColor"
  })
}), _0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "134",
  height: "157",
  viewBox: "0 0 134 157",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3938 22.0577C25.4762 39.1827 30.1033 50.9208 18.5207 73.7837C13.1732 84.3391 -2.11248 97.6726 0.245251 120.106C2.51782 141.729 13.4378 157 45.5874 157C77.737 157 128.612 136.518 133.163 106.313C137.715 76.1093 122.553 72.5696 115.092 40.1401C107.63 7.71069 78.2806 0 67.2643 0C56.2481 0 41.3115 4.93262 33.3938 22.0577Z",
    fill: "#ECC11D"
  })
}), I0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "208",
  height: "108",
  viewBox: "0 0 208 108",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.692 108C191.403 108 211.403 83.2183 207.519 58.0463C203.635 32.8743 182.344 12.2288 150.453 3.30132C118.562 -5.62618 69.3289 4.05479 35.3867 26.2784C1.4445 48.5021 -10.6365 76.2355 10.4527 90.6882C31.5418 105.141 70.761 75.2438 95.9654 82.8377C121.17 90.4316 129.981 108 160.692 108Z",
    fill: "currentColor"
  })
}), Xo = (t) => /* @__PURE__ */ o(y, {
  width: "226",
  height: "116",
  viewBox: "0 0 226 116",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.692 108C191.403 108 211.403 83.2183 207.519 58.0463C203.635 32.8743 182.344 12.2288 150.453 3.30132C118.562 -5.62618 69.3289 4.05479 35.3867 26.2784C1.4445 48.5021 -10.6365 76.2355 10.4527 90.6882C31.5418 105.141 70.761 75.2438 95.9654 82.8377C121.17 90.4316 129.981 108 160.692 108Z",
    fill: t.color ? t.color : "#F2F8FF"
  })
}), T0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "134",
  height: "157",
  viewBox: "0 0 134 157",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3938 22.0577C25.4762 39.1827 30.1033 50.9208 18.5207 73.7837C13.1732 84.3391 -2.11248 97.6726 0.245251 120.106C2.51782 141.729 13.4378 157 45.5874 157C77.737 157 128.612 136.518 133.163 106.313C137.715 76.1093 122.553 72.5696 115.092 40.1401C107.63 7.71069 78.2806 0 67.2643 0C56.2481 0 41.3115 4.93262 33.3938 22.0577Z",
    fill: "currentColor"
  })
}), $0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "165",
  height: "159",
  viewBox: "0 0 165 159",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15708 53.5595C-15.5202 95.0816 20.1837 168.618 72.3726 156.76C124.562 144.902 98.058 83.1712 140.871 56.5769C183.683 29.9826 164.356 0.0371704 118.038 0.0371704C71.7203 0.0371704 31.8344 12.0374 8.15708 53.5595Z",
    fill: "currentColor"
  })
}), W0 = ({
  className: t
}) => /* @__PURE__ */ o("svg", {
  width: "191",
  height: "120",
  viewBox: "0 0 191 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: F("shape", t),
  children: /* @__PURE__ */ o("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.745 80.3954C194.446 102.172 194.496 120 162.704 120C130.913 120 92.7133 85.7713 63.5904 97.2011C34.4675 108.631 11.3656 115.223 1.45484 85.7713C-8.45593 56.3194 33.4881 -5.99165 90.1581 0.465891C146.828 6.92343 179.043 58.6183 186.745 80.3954Z",
    fill: "currentColor"
  })
}), P0 = (t) => {
  if (!t)
    return "";
  if (t.indexOf(".") < 0 && t.indexOf("/") < 0)
    return t;
  const n = t.substring(t.lastIndexOf("/") + 1);
  return n.substring(0, n.indexOf("."));
}, Ae = ({
  variant: t = "horizontal",
  icon: n,
  label: r,
  className: l,
  children: s
}) => /* @__PURE__ */ d("header", {
  className: f("header", [t, l]),
  children: [/* @__PURE__ */ d(we, {
    variant: t,
    children: [/* @__PURE__ */ o("img", {
      src: n
    }), /* @__PURE__ */ o(Z0, {
      children: r
    })]
  }), s]
}), z0 = ({
  shape: t,
  shapeColor: n
}) => {
  const r = {
    shape2: V0,
    shape3: _0,
    shape4: I0,
    shape5: T0,
    shape6: $0,
    shape7: W0
  }, l = P0(t), s = l && Object.keys(r).includes(l) ? l : Object.keys(r)[Math.floor(Math.random() * Object.keys(r).length)], a = r[s];
  return /* @__PURE__ */ o(a, {
    className: `${s} ${n || ""}`
  });
}, O0 = ({
  shape: t,
  shapeColor: n,
  icon: r,
  label: l,
  headline: s,
  color: a = "blue",
  className: c
}) => /* @__PURE__ */ d(le, {
  className: f("section-header", c),
  children: [/* @__PURE__ */ o(z0, {
    shape: t,
    shapeColor: n
  }), /* @__PURE__ */ o(Ae, {
    variant: "vertical",
    icon: r,
    label: l,
    children: /* @__PURE__ */ o(H0, {
      color: a,
      children: s
    })
  })]
}), Se = ({
  className: t,
  backgroundColor: n = "white",
  children: r,
  ...l
}) => /* @__PURE__ */ o("section", {
  ...l,
  className: f("section", [n, t]),
  children: r
}), Jo = ({
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ o(Se, {
  className: f("page-section", t),
  ...r,
  children: n
}), Ko = ({
  backgroundColor: t = "white",
  shapeColor: n,
  children: r,
  shape: l,
  icon: s,
  label: a,
  headline: c,
  headlineColor: p = "blue",
  ...u
}) => /* @__PURE__ */ d(Se, {
  ...u,
  backgroundColor: t,
  children: [/* @__PURE__ */ o(O0, {
    shape: l,
    shapeColor: n || t == "white" ? "light-blue" : "white",
    icon: s,
    label: a,
    headline: c,
    color: p
  }), r]
}), G0 = ({
  variant: t,
  imgs: n,
  className: r
}) => /* @__PURE__ */ o("div", {
  className: f("image-group", [t, r]),
  children: n.map((l, s) => /* @__PURE__ */ o("img", {
    src: l
  }, `image-group-${l.slice(0, 12)}_${s}`))
}), en = (t) => t.imgs.length ? /* @__PURE__ */ o(le, {
  className: f("section-logos"),
  children: /* @__PURE__ */ o(G0, {
    variant: "logos",
    ...t
  })
}) : null, tn = ({
  color: t,
  icon: n,
  primaryButton: r,
  secondaryButton: l,
  children: s,
  className: a,
  ...c
}) => {
  const p = () => r ? l ? /* @__PURE__ */ o(re, {
    action: r.action,
    link: r.link,
    children: r.text
  }) : /* @__PURE__ */ o(xe, {
    action: r.action,
    link: r.link,
    children: r.text
  }) : null, u = () => l ? /* @__PURE__ */ o(w0, {
    action: l.action,
    link: l.link,
    children: l.text
  }) : null, C = p(), h = u();
  return /* @__PURE__ */ d("div", {
    ...c,
    className: f("section-footer", a),
    children: [/* @__PURE__ */ d(A, {
      className: "footer-text",
      children: [n ? /* @__PURE__ */ o("img", {
        src: n
      }) : null, /* @__PURE__ */ o(v, {
        color: t,
        center: !0,
        children: s
      })]
    }), r || l ? /* @__PURE__ */ d(A, {
      center: !0,
      className: "footer-buttons",
      children: [C, h]
    }) : null]
  });
}, G = ({
  variant: t = "width-auto",
  edgeColor: n,
  border: r = "light",
  withShadow: l,
  className: s,
  children: a,
  ...c
}) => /* @__PURE__ */ o("div", {
  className: f("card", [t, `${r}-grey-border`, n ? n + "-left-edge" : "", {
    shadow: l
  }, s]),
  ...c,
  children: a
}), je = (t) => /* @__PURE__ */ o(G, {
  edgeColor: "yellow",
  ...t
}), U0 = (t) => /* @__PURE__ */ o(G, {
  edgeColor: "green",
  ...t
}), se = ({
  bg: t,
  className: n,
  children: r,
  ...l
}) => /* @__PURE__ */ o("div", {
  className: f("card-block", n, {
    [t]: !0
  }),
  ...l,
  children: r
}), ae = ({
  color: t,
  size: n,
  withIcon: r,
  className: l,
  children: s,
  ...a
}) => /* @__PURE__ */ o(A, {
  className: f("tag", [t, n, {
    "with-icon": r
  }, l]),
  ...a,
  children: s
}), q0 = ({
  testimonial: t,
  children: n,
  className: r,
  ...l
}) => {
  const {
    logo: s,
    size: a,
    quote: c,
    person: p
  } = t, {
    photo: u,
    name: C,
    title: h
  } = p;
  return /* @__PURE__ */ d(U0, {
    variant: "width-md",
    className: F(r, "testimonial-card", {
      centered: !u
    }),
    ...l,
    children: [u ? /* @__PURE__ */ o("img", {
      src: u,
      height: 100,
      width: 100,
      className: "face-photo"
    }) : null, /* @__PURE__ */ o(v, {
      size: "small",
      italic: !0,
      center: !0,
      className: "quote",
      children: `"${c}"`
    }), /* @__PURE__ */ o(N0, {
      className: "person-name",
      children: C
    }), /* @__PURE__ */ o(v, {
      size: "x-small",
      center: !0,
      className: "person-title",
      children: h
    }), /* @__PURE__ */ o("img", {
      src: s,
      className: "ts-logo"
    }), /* @__PURE__ */ o(ae, {
      color: "middle-grey",
      children: a
    }), n]
  });
}, Y0 = ({
  proposition: t,
  className: n,
  children: r,
  ...l
}) => /* @__PURE__ */ d(je, {
  variant: "width-xlg",
  className: F(n, "info-card"),
  ...l,
  children: [/* @__PURE__ */ o(Ae, {
    variant: "horizontal",
    icon: t.icon,
    label: t.label,
    children: /* @__PURE__ */ o(R0, {
      color: "yellow",
      children: t.headline
    })
  }), /* @__PURE__ */ o(v, {
    children: t.description
  }), r]
}), Q0 = ({
  img: t,
  className: n,
  ...r
}) => /* @__PURE__ */ o(je, {
  variant: "width-lg",
  className: F(n, "img-card"),
  ...r,
  children: /* @__PURE__ */ o("img", {
    src: t,
    height: 535,
    width: 450
  })
}), X0 = ({
  expert: t
}) => {
  const {
    img: n,
    fullName: r,
    positionTitle: l
  } = t;
  return /* @__PURE__ */ d(se, {
    bg: "green",
    className: "header",
    children: [/* @__PURE__ */ o("img", {
      src: n,
      width: 160,
      height: 160,
      className: "face-photo"
    }), /* @__PURE__ */ o(D0, {
      color: "white",
      className: "person-name",
      children: r
    }), /* @__PURE__ */ d(ae, {
      color: "white",
      withIcon: !0,
      children: [l, /* @__PURE__ */ o(t1, {})]
    })]
  });
}, J0 = ({
  expert: t
}) => {
  const {
    fullName: n,
    mail: r,
    phone: l,
    linkedin: s
  } = t;
  return /* @__PURE__ */ d(se, {
    bg: "middle-blue",
    className: "contacts",
    children: [l && /* @__PURE__ */ d("div", {
      className: "phone",
      children: [/* @__PURE__ */ o(e1, {}), /* @__PURE__ */ o(X, {
        link: `tel:${l}`,
        text: l.slice(0, 3) + " (0) " + l.slice(3),
        small: !0
      })]
    }), r && /* @__PURE__ */ d("div", {
      className: "email",
      children: [/* @__PURE__ */ o(Je, {}), /* @__PURE__ */ o(X, {
        link: `mailto:${r}`,
        text: r,
        small: !0
      })]
    }), s && /* @__PURE__ */ d("div", {
      className: "linkedin",
      children: [/* @__PURE__ */ o(Ke, {}), /* @__PURE__ */ o(X, {
        link: s,
        text: n,
        small: !0
      })]
    })]
  });
}, K0 = (t) => t.map((n) => /* @__PURE__ */ o(ae, {
  color: "dark-blue",
  children: n
}, `tag_${n.replace(" ", "_")}`)), e2 = ({
  variant: t,
  expert: n
}) => /* @__PURE__ */ d(se, {
  bg: "white",
  className: "main",
  children: [/* @__PURE__ */ o(v, {
    size: "small",
    className: "description",
    children: n.description
  }), t === "normal" && /* @__PURE__ */ d(P, {
    children: [/* @__PURE__ */ o(v, {
      size: "small",
      className: "separator",
      children: ". . ."
    }), K0(n.tags)]
  })]
}), t2 = ({
  variant: t,
  expert: n,
  className: r,
  ...l
}) => /* @__PURE__ */ d(G, {
  variant: t === "small" ? "width-xsm" : "width-sm",
  className: F(r, `expert-card ${t}`),
  withShadow: !0,
  ...l,
  children: [/* @__PURE__ */ o(X0, {
    expert: n
  }), /* @__PURE__ */ o(e2, {
    expert: n,
    variant: t
  }), t === "small" && /* @__PURE__ */ o(J0, {
    expert: n
  })]
}), o2 = (t) => /* @__PURE__ */ o(t2, {
  variant: "normal",
  ...t
});
function ie(t) {
  const [n, r] = B(0), l = n === t.length - 1 ? 0 : n + 1, s = n === 0 ? t.length - 1 : n - 1;
  function a() {
    r(l);
  }
  function c() {
    r(s);
  }
  function p(u) {
    if (u < 0)
      throw "cannot go lower than 0";
    if (u >= t.length)
      throw "Attempted to go out of the items array";
    r(u);
  }
  return {
    active: n,
    next: l,
    previous: s,
    goToNext: a,
    goToPrevious: c,
    goToN: p
  };
}
const n2 = [[-1, "previous"], [0, "first"], [1, "second"], [2, "third"], [3, "next"]], r2 = [[0, "first"], [1, "second"], [2, "third"]];
function l2(t) {
  return t > 3 ? n2 : r2;
}
const on = ({
  experts: t = [],
  className: n,
  ...r
}) => {
  const {
    active: l,
    goToNext: s,
    goToPrevious: a
  } = ie(t);
  function c(C) {
    const h = t.length;
    let g = l + C;
    for (; g < 0 || g >= h; )
      g < 0 ? g = h + g : g = g - h;
    return g;
  }
  function p(C) {
    for (const [h, k] of l2(t.length))
      if (c(h) === C)
        return k;
    return "hidden";
  }
  const u = t.map((C, h) => /* @__PURE__ */ o(o2, {
    expert: C,
    className: p(h)
  }, h));
  return /* @__PURE__ */ d("div", {
    className: f("exp-main-content", n),
    ...r,
    children: [u, /* @__PURE__ */ o(ve, {
      action: a,
      className: "navigation nav-previous"
    }), /* @__PURE__ */ o(ye, {
      action: s,
      className: "navigation nav-next"
    })]
  });
}, nn = ({
  elements: t,
  illustration: n,
  legend: r,
  legendIcon: l,
  className: s,
  ...a
}) => {
  const c = t.map((p, u) => /* @__PURE__ */ d("li", {
    children: [/* @__PURE__ */ o(te, {}), /* @__PURE__ */ o("h3", {
      children: p.heading
    }), /* @__PURE__ */ o(v, {
      children: p.description
    })]
  }, `${p.heading.replace(" ", "").slice(0, 12)}_${u}`));
  return /* @__PURE__ */ o(le, {
    ...a,
    children: /* @__PURE__ */ d("div", {
      className: f("ol-section", s),
      children: [/* @__PURE__ */ d("div", {
        className: "left-side",
        children: [/* @__PURE__ */ o(Q0, {
          img: n
        }), /* @__PURE__ */ d("div", {
          className: "legend",
          children: [/* @__PURE__ */ o("img", {
            src: l,
            className: "legend-icon"
          }), /* @__PURE__ */ o(v, {
            className: "legend-text",
            children: r
          })]
        })]
      }), /* @__PURE__ */ o("ol", {
        className: "right-side",
        children: c
      })]
    })
  });
}, rn = ({
  testimonials: t,
  className: n,
  ...r
}) => {
  const {
    active: l,
    previous: s,
    next: a,
    goToN: c,
    goToNext: p,
    goToPrevious: u
  } = ie(t), C = t.length > 1, h = t.map((m, L) => /* @__PURE__ */ o(q0, {
    testimonial: m,
    className: L === l ? "active" : "inactive",
    children: C && /* @__PURE__ */ o(y0, {
      onRightClick: p,
      onLeftClick: u
    })
  }, `tscard_${m.name}_${L}`)), g = (C ? [s, l, a] : [l]).map((m) => {
    var L, w;
    return /* @__PURE__ */ o("img", {
      src: (L = t[m]) == null ? void 0 : L.illustration,
      width: 1080,
      height: 600,
      className: F("bg-illustration", {
        inactive: m !== l
      })
    }, `tscard_image_${((w = t[m]) == null ? void 0 : w.name) || ""}_${m}`);
  });
  return /* @__PURE__ */ d("div", {
    className: f("content-carousel testimonials", n),
    ...r,
    children: [/* @__PURE__ */ d("div", {
      className: "box",
      children: [g, h]
    }), C && /* @__PURE__ */ o(Me, {
      links: t.map((m) => m.name),
      activeIndex: l,
      action: c
    })]
  });
}, ln = ({
  propositions: t,
  className: n,
  ...r
}) => {
  const {
    active: l,
    next: s,
    previous: a,
    goToN: c,
    goToNext: p,
    goToPrevious: u
  } = ie(t), C = t.length > 1, h = t.map((m, L) => /* @__PURE__ */ o(Y0, {
    proposition: m,
    className: L === l ? "active" : "inactive",
    children: C && /* @__PURE__ */ o(b0, {
      onRightClick: p,
      onLeftClick: u
    })
  }, `${m.label.replace(" ", "")}_${L}`)), g = (C ? [a, l, s] : [l]).map((m) => {
    const L = t[m];
    return /* @__PURE__ */ o("img", {
      src: L.illustration,
      width: 1080,
      height: 600,
      className: F("bg-illustration", {
        inactive: m !== l
      })
    }, `vp_img_${L.label.replace(" ", "")}_${m}`);
  });
  return /* @__PURE__ */ d("div", {
    className: f("content-carousel solutions", n),
    ...r,
    children: [/* @__PURE__ */ d("div", {
      className: "box",
      children: [g, h]
    }), C && /* @__PURE__ */ o(Me, {
      links: t.map((m) => m.name),
      activeIndex: l,
      action: c
    })]
  });
}, sn = ({
  variant: t,
  icon: n,
  primaryButton: r,
  className: l,
  children: s,
  ...a
}) => /* @__PURE__ */ d(A, {
  className: f("tooltip", [t, `${n.pos}-icon`, l]),
  ...a,
  children: [/* @__PURE__ */ o(Z, {}), /* @__PURE__ */ d(Z, {
    className: "box",
    children: [/* @__PURE__ */ o("img", {
      src: n.url,
      alt: "tooltip icon",
      className: "icon"
    }), r ? /* @__PURE__ */ d(A, {
      spaceBetween: !0,
      children: [/* @__PURE__ */ o(v, {
        children: s
      }), /* @__PURE__ */ o(re, {
        ...r,
        children: r.text
      })]
    }) : /* @__PURE__ */ o(v, {
      center: !0,
      children: s
    })]
  }), /* @__PURE__ */ o(Z, {})]
});
function an(t, n) {
  return {
    errors: n.getErrors(t),
    value: n.getValue(t),
    isPristine: n.isPristine(t),
    name: t,
    onValueChange: (r) => n.setValue(t, r)
  };
}
const cn = (t) => {
  const {
    children: n,
    ...r
  } = t, l = x();
  return /* @__PURE__ */ o(i.label, {
    __css: l.formlabel,
    ...r,
    children: n
  });
}, dn = () => {
  const t = x();
  return /* @__PURE__ */ o(i.hr, {
    __css: t.divider
  });
}, pn = (t) => {
  const {
    children: n,
    variant: r,
    ...l
  } = t, s = V("BorderedForm", {
    variant: r
  });
  return /* @__PURE__ */ o(E, {
    as: "form",
    __css: s.box,
    ...l,
    children: /* @__PURE__ */ o(z, {
      value: s,
      children: n
    })
  });
}, ce = (t) => {
  const {
    variant: n,
    size: r,
    children: l,
    selected: s,
    ...a
  } = t, c = H("TagButton", {
    variant: n,
    size: r,
    selected: s
  });
  return /* @__PURE__ */ o(E, {
    __css: c,
    as: "button",
    ...a,
    children: l
  });
}, s2 = ({
  options: t,
  multiple: n,
  selected: r,
  onChange: l,
  wrapperStyle: s,
  tagStyle: a,
  children: c,
  ...p
}) => /* @__PURE__ */ d(j, {
  direction: "column",
  children: [/* @__PURE__ */ d(E, {
    display: "flex",
    gap: "0.5rem",
    flexWrap: "wrap",
    p: 4,
    ...s,
    children: [t.map((u) => {
      const {
        value: C,
        display: h
      } = u, k = n ? Array.isArray(C) ? C.every((g) => r.includes(g)) : r.includes(C) : r === C;
      return /* @__PURE__ */ o(ce, {
        type: "button",
        size: "sm",
        selected: k,
        onClick: (g) => {
          if (g.preventDefault(), g.stopPropagation(), !n)
            l(C.toString());
          else {
            const m = k ? r.filter((L) => Array.isArray(C) ? !C.includes(L) : L != C) : Array.isArray(C) ? [.../* @__PURE__ */ new Set([...r, ...C])] : [...r, C];
            l(m);
          }
        },
        ...a,
        children: h
      }, C.toString());
    }), c]
  }), p.onClear !== void 0 && /* @__PURE__ */ o(N, {
    onClick: p.onClear,
    size: "sm",
    maxW: "fit-content",
    ml: 4,
    children: "Rensa"
  })]
}), un = ({
  placeholder: t,
  variant: n = "outline",
  ...r
}) => {
  var a;
  let l = t, s = !0;
  return r.selected.length > 0 && (s = !1, Array.isArray(r.selected) ? l = r.options.filter((c) => Array.isArray(c.value) ? c.value.every((p) => r.selected.includes(p)) : r.selected.indexOf(c.value) > -1).map((c) => c.display).join(", ") : l = ((a = r.options.find((c) => c.value === r.selected)) == null ? void 0 : a.display) || ""), /* @__PURE__ */ o(Ze, {
    children: () => /* @__PURE__ */ d(P, {
      children: [/* @__PURE__ */ o(Ne, {
        children: /* @__PURE__ */ d(N, {
          variant: n,
          color: {
            base: "grey.800",
            md: s ? "grey.300" : "blue.500"
          },
          fontWeight: s ? "normal" : "semibold",
          justifyContent: "start",
          maxW: 44,
          h: 10,
          borderColor: {
            base: "grey.300",
            md: s ? "grey.300" : "blue.500"
          },
          children: [/* @__PURE__ */ o(J, {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            mr: "0.5rem",
            children: l
          }), /* @__PURE__ */ o(y, {
            as: m0,
            h: "10px",
            w: "10px",
            strokeWidth: "3.5",
            color: "black",
            ml: "auto"
          })]
        })
      }), /* @__PURE__ */ d(De, {
        children: [/* @__PURE__ */ o(Ve, {}), /* @__PURE__ */ o(_e, {
          children: /* @__PURE__ */ o(s2, {
            ...r
          })
        })]
      })]
    })
  });
}, Cn = ({
  onValueChange: t,
  value: n,
  options: r,
  className: l
}) => {
  const s = n, a = (p) => {
    const u = s.slice(), C = s.indexOf(p);
    C > -1 ? u.splice(C, 1) : u.push(p), t(u);
  }, c = r.map(({
    value: p,
    display: u
  }) => /* @__PURE__ */ o("li", {
    children: /* @__PURE__ */ o(j0, {
      action: () => a(p),
      selected: s.indexOf(p) > -1,
      children: u
    })
  }, p));
  return /* @__PURE__ */ o("ul", {
    className: f("inline-multi-choice", {
      className: l
    }),
    children: c
  });
}, mn = ({
  placeholder: t,
  options: n,
  name: r,
  value: l,
  onValueChange: s,
  className: a,
  isPristine: c,
  ...p
}) => {
  const u = n.filter((k) => l.indexOf(k.value) > -1).map((k) => k.display).join(", "), C = n.map(({
    value: k,
    display: g
  }) => /* @__PURE__ */ o("option", {
    value: k,
    children: g
  }, k));
  function h(k) {
    const g = Array.from(k.target.options).filter((m) => m.selected).map((m) => m.value);
    s(g);
  }
  return /* @__PURE__ */ d("span", {
    className: f("input", {
      filled: l.length > 0
    }, "multi-choice-value"),
    children: [u || t, /* @__PURE__ */ o("select", {
      id: r,
      name: r,
      value: l,
      multiple: !0,
      onChange: h,
      className: f("native-only-select", a),
      ...p,
      children: C
    })]
  });
}, a2 = ({
  variation: t = "rounded",
  onValueChange: n,
  label: r,
  value: l,
  errors: s,
  filled: a,
  isPristine: c,
  className: p,
  placeholder: u,
  adornment: C,
  ...h
}) => {
  const [k, g] = B(!1);
  return /* @__PURE__ */ d("div", {
    className: f("input-wrapper", p, t, {
      pristine: c,
      focused: k
    }),
    children: [r ? /* @__PURE__ */ o("label", {
      htmlFor: h.name,
      children: r
    }) : null, /* @__PURE__ */ d("div", {
      className: "positioning-wrapper",
      children: [/* @__PURE__ */ o("input", {
        className: f("input", t, {
          invalid: !c && s && s.length,
          filled: a
        }),
        onChange: (m) => {
          m.preventDefault(), n(m.target.value);
        },
        value: l,
        placeholder: u || r,
        onFocus: () => g(!0),
        onBlur: () => g(!1),
        ...h
      }), C ? /* @__PURE__ */ o("span", {
        className: "adornment",
        children: C
      }) : null]
    }), !c && s && s.length ? /* @__PURE__ */ o("div", {
      className: f("input-error-message"),
      children: s[0]
    }) : null]
  });
}, fn = (t) => /* @__PURE__ */ o(a2, {
  variation: "rounded",
  ...t
});
function i2() {
  return window.matchMedia("(max-width: 39rem)").matches;
}
const c2 = ({
  option: t,
  className: n,
  ...r
}) => /* @__PURE__ */ o("li", {
  onClick: (l) => t.onClick && t.onClick(l),
  className: F("option", n),
  ...r,
  children: t.display
}), d2 = ({
  variation: t,
  options: n,
  className: r,
  ...l
}) => /* @__PURE__ */ o(G, {
  withShadow: !0,
  border: "medium",
  className: f("options-list", r, t),
  ...l,
  children: /* @__PURE__ */ o("ul", {
    children: n.map((s, a) => /* @__PURE__ */ o(c2, {
      option: s
    }, `menuitem_${a}`))
  })
});
function p2(t) {
  const [n, r] = B(t), l = (s) => {
    s.preventDefault(), r(!n);
  };
  return T(() => {
    if (!n)
      return;
    const s = () => {
      r(!1);
    };
    return setTimeout(() => window.addEventListener("click", s), 50), () => {
      window.removeEventListener("click", s);
    };
  }, [n]), {
    toggled: n,
    onClickToggle: l
  };
}
const u2 = ({
  control: t,
  withArrow: n = !1,
  dropdownContent: r,
  value: l,
  disabled: s = !1,
  position: a = "left",
  className: c,
  onOpen: p,
  onClose: u,
  callback: C
}) => {
  const {
    toggled: h,
    onClickToggle: k
  } = p2(!1);
  function g(w) {
    C ? C(w, k) : k(w);
  }
  T(() => {
    h ? p && p() : u && u();
  }, [u, p, h]);
  const m = Ce(r, {
    className: f("dropdown-content", `align-${a}`, r.props.className),
    key: "dropdown-content"
  }), L = Ce(t, {
    className: f("dropdown-control", t.props.className, {
      focused: h
    }),
    onClick: g,
    children: [t.props.children, /* @__PURE__ */ o("span", {
      className: "dropdown-display-value",
      children: l
    }, "dropdown-value"), n ? /* @__PURE__ */ o("span", {
      className: "adornment",
      children: /* @__PURE__ */ o(ee, {
        arrowDirection: h ? "up" : "down",
        size: 4
      })
    }, "control-adornment") : null]
  });
  return /* @__PURE__ */ d("div", {
    className: f("dropdown-wrapper", c, {
      toggled: h,
      disabled: s
    }),
    children: [L, m]
  });
}, hn = ({
  onValueChange: t,
  variation: n = " rounded",
  name: r,
  value: l,
  options: s,
  className: a,
  placeholder: c,
  id: p,
  isPristine: u,
  ...C
}) => {
  const h = s.find((w) => w.value === l), k = h ? h.display : c, g = s.map(({
    value: w,
    display: M
  }) => /* @__PURE__ */ o("option", {
    value: w,
    children: M
  }, w)), m = s.map(({
    value: w,
    display: M
  }) => /* @__PURE__ */ o("li", {
    children: /* @__PURE__ */ o("a", {
      href: "#",
      onClick: (q) => {
        q.preventDefault(), t(w);
      },
      children: M
    })
  }, w));
  function L(w, M) {
    i2() ? w.preventDefault() : M(w);
  }
  return /* @__PURE__ */ o(u2, {
    className: f("single-select", n, a),
    callback: L,
    control: /* @__PURE__ */ d("div", {
      className: f("input", n, {
        "current-value": !0,
        filled: !!l
      }),
      children: [/* @__PURE__ */ o("select", {
        id: p || r,
        name: r,
        className: f("native-only-select", a),
        onChange: (w) => t(w.target.value),
        value: l,
        ...C,
        children: g
      }), /* @__PURE__ */ o("ul", {
        children: m
      })]
    }),
    withArrow: !0,
    dropdownContent: /* @__PURE__ */ o(d2, {
      variation: "monolith",
      options: s,
      className: "dropdown-content"
    }),
    value: k,
    ...C
  });
}, C2 = ({
  className: t,
  ...n
}) => /* @__PURE__ */ o("span", {
  className: f("verified-sign", t),
  ...n,
  children: /* @__PURE__ */ o(te, {})
}), gn = ({
  children: t,
  className: n,
  ...r
}) => /* @__PURE__ */ o("div", {
  className: f("conv-form", n),
  ...r,
  children: t
}), kn = ({
  messages: t,
  photo: n,
  className: r,
  number: l,
  isValid: s,
  isVisible: a,
  isSubmitted: c,
  onValidate: p,
  afterAnswer: u,
  input: C,
  answerPreText: h,
  answerPostText: k,
  scrollToTop: g = !1,
  ...m
}) => {
  const [L, w] = B(0);
  T(() => {
    if (!a || L >= t.length)
      return;
    const R = L === 0 ? 0 : 750, $ = window.setTimeout(() => {
      w(L + 1);
    }, R);
    return () => {
      window.clearTimeout($);
    };
  }, [a, L, t]);
  const M = ze(null);
  T(() => {
    if (!a || !g || !M.current)
      return;
    const R = M.current.getBoundingClientRect().top + document.documentElement.scrollTop - 60;
    window.scrollTo({
      top: R,
      left: 0,
      behavior: "smooth"
    });
  }, [a, g]);
  const q = t.map((R, $) => /* @__PURE__ */ o("p", {
    className: F({
      visible: $ < L
    }),
    children: R
  }, `${R.slice(0, 12)}_${$}`)), Re = c && s ? /* @__PURE__ */ o(C2, {
    className: "button-slot"
  }) : /* @__PURE__ */ o(M0, {
    action: p,
    disabled: !s,
    className: "button-slot"
  });
  return a ? /* @__PURE__ */ d("div", {
    ref: M,
    className: f("conv-form-question", r),
    ...m,
    children: [/* @__PURE__ */ o("img", {
      src: n,
      className: f("conv-profile-photo"),
      height: 50,
      width: 50
    }), /* @__PURE__ */ o("div", {
      className: f("conv-form-messages"),
      children: q
    }), /* @__PURE__ */ o("div", {
      className: f("conv-answer-nb"),
      children: l
    }), /* @__PURE__ */ d("div", {
      className: f("conv-answer", {
        visible: L >= t.length
      }),
      children: [/* @__PURE__ */ d("div", {
        className: f("conv-answer-text"),
        children: [/* @__PURE__ */ o("span", {
          className: "pre-text",
          children: h
        }), /* @__PURE__ */ o("span", {
          className: "input-slot",
          children: C
        }), /* @__PURE__ */ o("span", {
          className: "post-text",
          children: k
        }), Re]
      }), /* @__PURE__ */ o("div", {
        children: u
      })]
    })]
  }) : null;
}, Ln = ({
  label: t,
  header: n,
  color: r = "white",
  primaryButton: l,
  secondaryButton: s,
  className: a,
  ...c
}) => /* @__PURE__ */ d("div", {
  className: f("top-content", [a]),
  ...c,
  children: [/* @__PURE__ */ o(v, {
    size: "normal",
    color: r,
    children: t
  }), /* @__PURE__ */ o(B0, {
    color: r,
    children: n
  }), s ? /* @__PURE__ */ o(v0, {
    primaryButton: l,
    secondaryButton: {
      ...s,
      color: r
    }
  }) : /* @__PURE__ */ o(xe, {
    ...l
  })]
}), En = ({
  backgroundImage: t,
  className: n,
  children: r,
  ...l
}) => /* @__PURE__ */ d("div", {
  className: f("top-hero-section", [n]),
  ...l,
  children: [/* @__PURE__ */ o("img", {
    className: "bg-illustration",
    src: t,
    height: 1e3,
    width: 2e3
  }), r]
});
function m2(t, n, r, l) {
  const s = t + n, a = 4, c = new Uint8Array(s * s * a);
  for (let p = 0; p < s; p++)
    for (let u = 0; u < s; u++) {
      const C = (u * s + p) * a, h = p + u < t || p + u >= s && p + u < s + t ? r : l;
      c[C + 0] = h[0], c[C + 1] = h[1], c[C + 2] = h[2], c[C + 3] = h[3];
    }
  return c;
}
const wn = ({
  id: t,
  stripeSize: n,
  spacing: r,
  stripeColor: l,
  bgColor: s,
  children: a
}) => {
  const {
    current: c
  } = qe(), p = Le(() => m2(n, r, l, s), [n, r, l, s]), u = n + r;
  return T(() => {
    if (!c)
      return;
    const C = {
      width: u,
      height: u,
      data: p
    };
    return c.hasImage(t) ? c.updateImage(t, C) : c.addImage(t, C), () => {
      c.removeImage(t);
    };
  }, [p, t, u, c]), /* @__PURE__ */ o(P, {
    children: a
  });
};
function D(t) {
  return typeof t == "string" && t.includes(".") ? `var(--chakra-colors-${t.replace(".", "-")})` : t;
}
const xn = (t) => {
  const {
    bg: n,
    bgColor: r,
    backgroundColor: l,
    size: s,
    shadowColor: a,
    ...c
  } = t, {
    getArrowProps: p,
    getArrowInnerProps: u
  } = Ie({
    arrowPadding: 30
  }), C = p({
    size: s || "16px",
    shadowColor: a || "var(--chakra-colors-blackAlpha-100)"
  }), h = n || r || l;
  return /* @__PURE__ */ o(i.div, {
    ...C,
    zIndex: "3 !important",
    ...c,
    children: /* @__PURE__ */ o(i.div, {
      ...u(),
      __css: {
        "--popper-arrow-bg": h ? D(h) : "white"
      }
    })
  });
}, f2 = ["30em", "48em", "62em", "80em"], I = f2.map(
  (t) => `@media (min-width: ${t})`
), U = {
  self: S({
    height: "600px",
    position: "relative",
    display: "grid",
    paddingTop: "1.5rem",
    paddingBottom: "2rem",
    border: "1px solid",
    borderColor: "transparent",
    borderTopColor: D("grey.100"),
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto",
    gridTemplateAreas: "'header' 'illustration' 'actions'",
    gridRowGap: "0.75rem",
    gridColumnGap: 0,
    "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
      position: "relative",
      zIndex: 1
    },
    contentVisibility: "auto",
    [I[1]]: {
      height: "max-content",
      gridTemplateColumns: "25rem 1fr",
      gridTemplateRows: "min-content min-content",
      gridTemplateAreas: "'illustration header' 'illustration actions'",
      gridRowGap: 0,
      gridColumnGap: "2.5rem"
    },
    [I[2]]: {
      height: "316px"
    }
  }),
  header: S({
    gridArea: "header",
    borderStyle: "dashed",
    borderColor: D("grey.100"),
    borderBottomWidth: "none",
    paddingBottom: 0,
    marginBottom: 0,
    [I[1]]: {
      borderBottomWidth: "thin",
      paddingBottom: "1.25rem",
      marginBottom: "1.25rem"
    }
  }),
  illustration: S({
    gridArea: "illustration"
  }),
  actions: S({
    gridArea: "actions"
  })
}, h2 = {
  self: S({
    height: "723px",
    position: "relative",
    display: "grid",
    paddingTop: "1.5rem",
    paddingBottom: "2rem",
    border: "1px solid",
    borderColor: "transparent",
    borderTopColor: D("grey.100"),
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto",
    gridTemplateAreas: "'header' 'illustration' 'actions'",
    gridRowGap: "0.75rem",
    gridColumnGap: 0,
    "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
      position: "relative",
      zIndex: 1
    },
    contentVisibility: "auto",
    [I[1]]: {
      height: "max-content",
      gridTemplateColumns: "25rem 1fr",
      gridTemplateRows: "min-content min-content",
      gridTemplateAreas: "'illustration header' 'illustration actions'",
      gridRowGap: 0,
      gridColumnGap: "2.5rem"
    },
    [I[2]]: {
      height: "390px"
    }
  })
}, Fn = ({
  isPremium: t = !1,
  children: n,
  ...r
}) => /* @__PURE__ */ O("article", {
  css: t ? h2.self : U.self,
  ...r,
  children: n
}), vn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ O("div", {
  css: U.header,
  ...n,
  children: t
}), yn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ O("div", {
  css: U.illustration,
  ...n,
  children: t
}), bn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ O("div", {
  css: U.actions,
  ...n,
  children: t
});
function* g2(t) {
  const n = t.toPlainDate({
    day: 1
  }), r = t.toPlainDate({
    day: t.daysInMonth
  }), l = n.dayOfWeek === 1 ? n : n.subtract({
    days: n.dayOfWeek - 1
  }), s = r.dayOfWeek === r.daysInWeek ? r : r.add({
    days: r.daysInWeek - r.dayOfWeek
  });
  let a = l;
  for (; W.PlainDate.compare(a, s) < 1; )
    yield a, a = a.add({
      days: 1
    });
}
const k2 = ({
  day: t,
  selectable: n,
  active: r,
  onClick: l
}) => /* @__PURE__ */ o(ce, {
  h: 9,
  w: 9,
  px: 0,
  type: "button",
  variant: "calendar",
  disabled: !n,
  selected: r,
  className: "day-select",
  onClick: n ? l : void 0,
  children: t.day
}), L2 = () => {
  const t = W.PlainDate.from("2021-09-06"), n = [1, 2, 3, 4, 5, 6, 7].map((r) => /* @__PURE__ */ o("div", {
    children: t.add({
      days: r - 1
    }).toLocaleString("sv-SE", {
      weekday: "short",
      calendar: "iso8601"
    })
  }, r));
  return /* @__PURE__ */ o(K, {
    color: "grey.600",
    textTransform: "uppercase",
    fontSize: "xs",
    fontWeight: "semibold",
    mb: 2.5,
    justifyItems: "center",
    gap: 2.5,
    templateColumns: "repeat(7, 1fr)",
    children: n
  });
}, me = ({
  children: t
}) => /* @__PURE__ */ o(he, {
  as: "h3",
  fontSize: "sm",
  fontWeight: "normal",
  color: "grey.700",
  children: t
}), Mn = ({
  times: t,
  isDaySelectable: n,
  onChange: r,
  onChangeDate: l,
  onChangeTime: s
}) => {
  const [a, c] = B({
    activeMonth: W.PlainYearMonth.from(W.Now.plainDate("iso8601", "Europe/Stockholm")),
    activeDay: null,
    activeTime: null
  }), p = (m) => {
    c({
      activeMonth: m,
      activeDay: null,
      activeTime: null
    }), r && r(null);
  }, u = (m) => {
    m !== a.activeDay && (c({
      activeMonth: m.toPlainYearMonth(),
      activeDay: m,
      activeTime: null
    }), l && l(m), r && r(null));
  }, C = (m) => {
    c({
      ...a,
      activeTime: m
    });
    const L = m.toZonedDateTime({
      plainDate: a.activeDay,
      timeZone: "Europe/Stockholm"
    });
    s && s(L), r && r(L);
  }, k = Le(() => Array.from(g2(a.activeMonth)), [a.activeMonth]).map((m) => /* @__PURE__ */ o(k2, {
    day: m,
    selectable: n ? n(m) : !0,
    active: a.activeDay ? m.equals(a.activeDay) : !1,
    onClick: (L) => {
      L.preventDefault(), u(m);
    }
  }, m.toJSON())), g = t(a.activeDay).map((m) => /* @__PURE__ */ o(ce, {
    type: "button",
    variant: "calendar",
    selected: a.activeTime !== null && m.equals(a.activeTime),
    className: "time-select",
    onClick: () => C(m),
    children: m.toLocaleString("sv-SE", {
      hour: "2-digit",
      minute: "2-digit",
      calendar: "iso8601"
    })
  }, m.toJSON()));
  return /* @__PURE__ */ d(E, {
    maxW: "30rem",
    children: [/* @__PURE__ */ d(j, {
      align: "center",
      justify: "space-between",
      mb: 7,
      children: [/* @__PURE__ */ o(me, {
        children: "Tillg\xE4ngliga datum:"
      }), /* @__PURE__ */ d(j, {
        alignItems: "center",
        children: [/* @__PURE__ */ o(E, {
          mr: 2.5,
          fontWeight: "semibold",
          textTransform: "capitalize",
          color: "grey.800",
          fontSize: "sm",
          children: a.activeMonth.toLocaleString("sv-SE", {
            month: "long",
            year: "numeric",
            calendar: "iso8601"
          })
        }), /* @__PURE__ */ o(N, {
          variant: "outline",
          size: "round-sm",
          mr: 1.5,
          onClick: () => p(a.activeMonth.subtract({
            months: 1
          })),
          children: /* @__PURE__ */ o(Ee, {
            width: "1em",
            height: "1em"
          })
        }), /* @__PURE__ */ o(N, {
          variant: "outline",
          size: "round-sm",
          onClick: () => p(a.activeMonth.add({
            months: 1
          })),
          children: /* @__PURE__ */ o(oe, {
            width: "1em",
            height: "1em"
          })
        })]
      })]
    }), /* @__PURE__ */ o(L2, {}), /* @__PURE__ */ o(K, {
      pb: 7,
      mb: 2.5,
      borderBottom: "thin solid",
      borderColor: "grey.100",
      justifyItems: "center",
      gap: 2.5,
      templateColumns: "repeat(7, 1fr)",
      children: k
    }), a.activeDay && /* @__PURE__ */ d(P, {
      children: [/* @__PURE__ */ o(me, {
        children: "Tillg\xE4ngliga tider (kan \xE4ndras senare):"
      }), /* @__PURE__ */ o(j, {
        gap: "10px",
        mb: 7,
        mt: 4,
        wrap: "wrap",
        children: g
      })]
    })]
  });
}, An = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(Te, {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "1rem",
  ...n,
  children: t
}), Sn = ({
  value: t,
  ...n
}) => {
  const {
    getPreviewProps: r
  } = $e(), {
    isEditing: l
  } = ge(), s = r();
  return /* @__PURE__ */ o(i.span, {
    ...s,
    hidden: !!l,
    __css: {
      cursor: "text",
      display: l ? "none" : "inline-block",
      whiteSpace: "pre-wrap"
    },
    ...n,
    children: t
  });
}, jn = () => {
  const {
    isEditing: t,
    getSubmitButtonProps: n,
    getCancelButtonProps: r,
    getEditButtonProps: l
  } = ge();
  return t ? /* @__PURE__ */ d(We, {
    justifyContent: "center",
    size: "sm",
    children: [/* @__PURE__ */ o(Y, {
      ...n(),
      "aria-label": "Confirm input change",
      colorScheme: "blue",
      icon: /* @__PURE__ */ o(te, {})
    }), /* @__PURE__ */ o(Y, {
      ...r(),
      "aria-label": "Cancel input change",
      colorScheme: "gray",
      icon: /* @__PURE__ */ o(f0, {
        w: "70%",
        h: "70%"
      })
    })]
  }) : /* @__PURE__ */ o(j, {
    justifyContent: "center",
    children: /* @__PURE__ */ o(Y, {
      ...l(),
      "aria-label": "Edit input",
      size: "xs",
      bgColor: "transparent",
      _hover: {
        bgColor: "transparent"
      },
      icon: /* @__PURE__ */ o(h0, {
        w: "80%",
        color: "teal.300",
        _hover: {
          color: "teal.600"
        },
        strokeWidth: 1.3
      })
    })
  });
}, [
  E2,
  Bn,
  w2,
  x2
] = Ye(), Be = Oe(
  void 0
), F2 = Be.Provider, de = () => {
  const t = Ge(Be);
  if (!t)
    throw new Error("ContextError");
  return t;
}, v2 = () => {
  const t = w2(), [n, r] = B(0), [l, s] = B(!1), a = Q(() => {
    var u;
    r((u = t.nextEnabled(n, !0)) == null ? void 0 : u.index);
  }, [t, n]), c = Q(() => {
    var u;
    r((u = t.prevEnabled(n, !0)) == null ? void 0 : u.index);
  }, [t, n]), p = Q(() => {
    l || s(!0);
  }, [l]);
  return {
    currentSlide: n,
    goBackward: c,
    goForward: a,
    onHover: p,
    descendants: t
  };
}, y2 = () => {
  const { currentSlide: t } = de(), { index: n, register: r } = x2();
  return {
    ref: r,
    display: n === t ? "block" : "none",
    inDom: n === t
  };
}, fe = {
  color: D("blue.500"),
  background: "white",
  display: "inline-flex",
  alignItems: "center",
  position: "relative",
  ":hover": {
    background: D("blue.500"),
    color: "white"
  }
}, pe = {
  self: S({
    gridTemplateRows: "1fr 30px 1fr",
    gridTemplateColumns: "20px 1fr 20px"
  }),
  controlArrow: {
    forward: S({
      ...fe,
      paddingRight: "0.25rem",
      justifyContent: "end",
      gridArea: "2 / 3 / 3 / 4",
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4
    }),
    back: S({
      ...fe,
      gridArea: "2 / 1 / 2 / 1",
      paddingLeft: "0.25rem",
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4
    })
  }
}, Hn = (t) => {
  const {
    descendants: n,
    ...r
  } = v2(), {
    children: l,
    ...s
  } = t;
  return /* @__PURE__ */ o(E2, {
    value: n,
    children: /* @__PURE__ */ o(F2, {
      value: r,
      children: /* @__PURE__ */ o(K, {
        css: pe.self,
        ...s,
        children: l
      })
    })
  });
}, He = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "button",
  ...n,
  children: t
}), Rn = ({
  onClick: t,
  arrowStyle: n,
  ...r
}) => {
  const {
    goForward: l
  } = de();
  return /* @__PURE__ */ o(He, {
    onClick: (s) => {
      l(), t && t(s);
    },
    css: pe.controlArrow.forward,
    "aria-label": "Go forward",
    ...r,
    children: /* @__PURE__ */ o(ee, {
      arrowDirection: "right",
      size: 3,
      ...n
    })
  });
}, Zn = ({
  onClick: t,
  arrowStyle: n,
  ...r
}) => {
  const {
    goBackward: l
  } = de();
  return /* @__PURE__ */ o(He, {
    onClick: (s) => {
      l(), t && t(s);
    },
    css: pe.controlArrow.back,
    ...r,
    "aria-label": "Go back",
    children: /* @__PURE__ */ o(ee, {
      arrowDirection: "left",
      size: 3,
      ...n
    })
  });
}, Nn = (t) => {
  const {
    children: n,
    ...r
  } = t, {
    inDom: l,
    ...s
  } = y2();
  return /* @__PURE__ */ o(E, {
    ...s,
    ...r,
    gridArea: "1 / 1 / 4 / 4",
    children: l && n
  });
}, b2 = {
  parts: ["tab", "tablist", "tabpanel"],
  sizes: {
    "round-md": {
      tab: {
        boxSize: {
          base: 26,
          md: 30
        }
      }
    }
  },
  variants: {
    round: {
      tab: {
        position: "relative",
        borderRadius: "50%",
        background: "white",
        color: "grey.800",
        fontWeight: "semibold",
        _hover: {
          borderColor: "blue.500",
          borderWidth: "thin",
          borderStyle: "solid"
        },
        _selected: {
          background: "blue.500",
          color: "white"
        }
      },
      tablist: {
        gap: 8
      },
      tabpanel: {
        padding: 0,
        paddingTop: 2
      }
    },
    "soft-rounded": {
      tab: {
        backgroundColor: "white",
        border: "1px",
        borderColor: "blue.500",
        color: "blue.500",
        fontSize: 14,
        height: "2.25em",
        width: "3.94em",
        px: 0,
        _selected: {
          backgroundColor: "blue.500",
          color: "white"
        },
        _disabled: {
          backgroundColor: "white",
          color: "grey.100",
          borderColor: "grey.100"
        }
      }
    }
  }
}, M2 = {
  sizes: {
    md: {
      h: "2.625rem",
      minW: "8.5rem"
    },
    "round-sm": {
      h: 6,
      w: 6,
      borderRadius: "full",
      fontSize: "0.5rem",
      flexShrink: 0
    },
    "round-md": {
      h: "2.625rem",
      w: "2.625rem",
      borderRadius: "full",
      flexShrink: 0
    }
  },
  variants: {
    solid: ({
      colorScheme: t
    }) => ({
      bg: `${t}.500`,
      color: "white",
      _hover: {
        bg: `${t}.600`
      }
    }),
    outline: ({
      colorScheme: t
    }) => ({
      borderColor: "grey.100",
      color: `${t}.500`,
      _hover: {
        borderColor: `${t}.500`,
        bg: "transparent"
      }
    }),
    link: {
      fontWeight: "normal",
      minW: 0
    }
  },
  defaultProps: {
    colorScheme: "blue"
  }
}, A2 = {
  parts: ["barWrapper", "chartWrapper"],
  baseStyle: {
    barWrapper: {
      display: "table-cell",
      verticalAlign: "bottom",
      height: "100%"
    },
    chartWrapper: {
      display: "table",
      tableLayout: "fixed",
      borderCollapse: "separate",
      borderSpacing: "1px 0",
      width: "100%",
      height: "70px",
      overflow: "hidden",
      marginBottom: "-1px"
    }
  }
}, S2 = {
  baseStyle: {
    lineHeight: "1.2",
    borderRadius: "full",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      _disabled: {
        bg: "initial"
      }
    }
  },
  sizes: {
    sm: {
      h: 7,
      fontSize: "xs",
      px: 3.5
    },
    md: {
      h: {
        base: 9,
        md: 10
      },
      px: {
        base: 3.5,
        md: 4
      }
    }
  },
  variants: {
    solid: ({
      selected: t
    }) => t ? {
      bg: "blue.500",
      color: "white",
      _active: {
        bg: "blue.700"
      }
    } : {
      bg: "blue.50",
      _hover: {
        bg: "blue.100"
      },
      _active: {
        bg: "blue.300"
      }
    },
    calendar: ({
      selected: t
    }) => t ? {
      bg: "blue.500",
      color: "white",
      _active: {
        bg: "blue.700"
      }
    } : {
      bg: "blue.100",
      _disabled: {
        opacity: 0.2
      },
      _hover: {
        bg: "blue.200"
      },
      _active: {
        bg: "blue.300"
      }
    }
  },
  defaultProps: {
    variant: "solid",
    size: "md"
  }
}, j2 = {
  parts: ["field", "element"],
  baseStyle: {
    field: {
      color: "grey.800",
      fontWeight: "semibold",
      _placeholder: {
        opacity: 1,
        color: "grey.400",
        fontWeight: "normal"
      }
    }
  },
  sizes: {
    "round-lg": {
      field: {
        px: 7,
        h: 12,
        borderRadius: "full"
      }
    }
  },
  variants: {
    outline: {
      field: {
        borderColor: "grey.100",
        _focus: {
          borderColor: "blue.500",
          _placeholder: {
            fontWeight: "semibold"
          }
        },
        _hover: {
          borderColor: "blue.400"
        }
      }
    }
  }
}, B2 = {
  baseStyle: {
    fontSize: "xs",
    color: "grey.500",
    fontWeight: "normal",
    mb: 0
  },
  variants: {
    "on-border": {
      position: "absolute",
      left: 1,
      top: -3,
      padding: 1,
      paddingTop: 0,
      zIndex: 2,
      bgColor: "white"
    }
  }
}, H2 = {
  parts: ["helperText"],
  baseStyle: {
    helperText: {
      fontSize: "xs",
      color: "grey.500",
      fontWeight: "normal"
    }
  }
}, R2 = {
  parts: ["list", "option", "button"],
  baseStyle: (t) => ({
    list: {
      ...ue.components.Menu.baseStyle(t).list
    },
    option: {
      ...ue.components.Menu.baseStyle(t).item,
      textDecoration: "none",
      color: "inherit",
      userSelect: "none",
      display: "flex",
      width: "100%",
      alignItems: "center",
      textAlign: "start",
      flex: "0 0 auto",
      outline: 0,
      fontSize: "sm",
      fontWeight: "medium",
      _hover: {
        bg: "blue.50"
      }
    }
  })
}, Z2 = {
  baseStyle: ({
    colorScheme: t
  }) => ({
    borderWidth: 1,
    borderLeftWidth: 4,
    borderStyle: "solid",
    borderColor: "grey.100",
    borderLeftColor: `${t}.500`,
    borderRadius: "base",
    px: 6,
    pt: 5,
    pb: {
      base: 5,
      md: 6
    }
  })
}, N2 = {
  parts: ["adBanner", "image", "heading", "button", "logoWrapper"],
  baseStyle: {
    adBanner: {
      bgColor: "#D3DDE7",
      display: "grid",
      borderRadius: "base",
      border: "1px",
      borderColor: "blue.500",
      color: "black",
      gridTemplate: {
        base: "min-content min-content / 30% 1fr",
        md: "min-content min-content / 40% 1fr min-content"
      },
      gridColumnGap: { base: 3, lg: 8 }
    },
    image: {
      gridColumn: "1 / 2",
      gridRow: "1 / 3",
      clipPath: "polygon(0% 0%, 100% 0%, 70% 100%, 0% 100%)",
      objectFit: "cover",
      borderTopLeftRadius: "base",
      borderBottomLeftRadius: "base",
      minW: "100%",
      minH: "150px"
    },
    heading: {
      gridColumn: { base: "2/3", md: "2 / 4" },
      gridRow: "1 / 2",
      alignSelf: "start",
      mt: 3
    },
    button: {
      gridColumn: "2 / 3",
      gridRow: "2 / 3",
      alignSelf: "end",
      mb: { base: 2, md: 3 },
      maxW: { base: "40%", md: "50%" },
      position: "relative",
      right: { base: 5, md: 10 },
      bgColor: "blue.500",
      borderRadius: "md",
      color: "white",
      px: { base: 2, md: 3, lg: 5 },
      py: 2,
      fontSize: { base: "xs", md: "sm", lg: "md" },
      fontWeight: { base: "normal", md: "semibold" },
      textAlign: "center",
      _hover: {
        bgColor: "blue.600"
      }
    },
    logoWrapper: {
      gridColumn: { base: "2/3", md: "3 / 4" },
      gridRow: "2 / 3",
      alignSelf: "end",
      justifySelf: { base: "end", md: "auto" },
      mb: { base: 1, md: 3 },
      mr: { base: 4, md: 6 },
      display: "flex",
      flexDirection: "row"
    }
  }
}, D2 = {
  parts: [
    "banner",
    "image",
    "starIconWrapper",
    "starIcon",
    "heading",
    "subHeading",
    "button",
    "imageText",
    "backgroundCircle"
  ],
  baseStyle: {
    banner: {
      bgColor: "green.500",
      display: "grid",
      borderRadius: "base",
      color: "white",
      _hover: {
        bg: "green.600"
      }
    },
    image: {
      borderRadius: "full",
      position: "relative",
      zIndex: 2
    },
    starIcon: {
      height: {
        base: "15px",
        md: "18px"
      },
      width: { base: "15px", md: "18px" }
    },
    starIconWrapper: {
      padding: 1,
      borderRadius: "full",
      bgColor: "white",
      position: "absolute",
      right: 0,
      bottom: 0
    },
    heading: {
      fontWeight: "semibold"
    },
    subHeading: {
      fontStyle: "italic"
    },
    imageText: {
      fontStyle: "italic",
      fontSize: "xs",
      visibility: { base: "hidden", md: "visible" }
    },
    backgroundCircle: {
      bgColor: "#6FDFBA",
      opacity: 0.4,
      height: "100%",
      width: "100%"
    },
    button: {
      borderRadius: "base",
      bgColor: "blue.500",
      maxH: "42px",
      py: 2,
      fontSize: { base: 12, md: 16 }
    }
  },
  variants: {
    horizontal: {
      banner: {
        gridTemplate: "min-content min-content / min-content 1fr ",
        gridColumnGap: { base: 5, lg: 8 },
        rowGap: { base: 1, md: 1.5 }
      },
      image: {
        gridColumn: "1 / 2",
        gridRow: "1 / 3",
        alignSelf: "center"
      },
      heading: {
        fontSize: { base: "lg", sm: "1.5rem" },
        gridColumn: "2 / 3",
        gridRow: "1 / 2",
        alignSelf: "end"
      },
      subHeading: {
        fontSize: { base: "xs", sm: "sm" },
        gridColumn: "2 / 3",
        gridRow: "2 / 3",
        alignSelf: "start"
      }
    },
    serpRightImage: {
      banner: {
        gridTemplate: {
          base: "min-content 1fr / 50% 50%",
          md: "min-content min-content 1fr / 65% 35%"
        },
        gridColumnGap: 0,
        rowGap: { base: 1, md: 1.5 }
      },
      image: {
        gridColumn: "2 / 3",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        alignSelf: "center",
        justifySelf: "center"
      },
      imageText: {
        gridColumn: "1 / 3",
        gridRow: { base: "1 / 3", md: "3 / 4" },
        alignSelf: "center",
        position: "relative"
      },
      starIconWrapper: {
        position: "relative"
      },
      backgroundCircle: {
        gridColumn: "2 / 3",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        borderRadius: {
          base: "0 0.25rem 0.25rem 0",
          md: "300px 0.25rem 0.25rem 0"
        },
        clipPath: {
          base: "polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%)",
          md: "none"
        }
      },
      heading: {
        fontSize: { base: "lg", sm: "1.5rem" },
        gridColumn: "1 / 2",
        gridRow: "1 / 2",
        alignSelf: "center",
        mt: { base: 3, md: 10 }
      },
      subHeading: {
        fontSize: { base: "xs", sm: "sm" },
        gridColumn: "1 / 2",
        alignSelf: "center",
        gridRow: "2 / 3",
        visibility: { base: "hidden", md: "visible" }
      },
      button: {
        gridColumn: "1 / 2",
        gridRow: { base: "2 / 3", md: "3 / 4" },
        alignSelf: "center",
        width: "50%",
        mb: 3
      }
    },
    serpLeftImage: {
      banner: {
        gridTemplate: {
          base: "min-content 1fr / 40% 60%",
          md: "min-content min-content 1fr / 3fr 6fr"
        },
        gridColumnGap: 0,
        rowGap: { base: 1, md: 1.5 }
      },
      image: {
        gridColumn: "1 / 2",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        alignSelf: "center",
        justifySelf: "center"
      },
      imageText: {
        gridColumn: "1 / 3",
        gridRow: { base: "1 / 3", md: "3 / 4" },
        alignSelf: "center",
        position: "relative"
      },
      starIconWrapper: {
        position: "relative"
      },
      backgroundCircle: {
        gridColumn: "1 / 2",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        borderRadius: {
          base: "0.25rem 0 0 0.25rem",
          md: "0.25rem 300px 0 0.25rem"
        },
        clipPath: {
          base: "polygon(0% 0%, 85% 0%, 100% 100%, 0% 100%)",
          md: "none"
        }
      },
      heading: {
        fontSize: { base: "lg", sm: "1.5rem" },
        gridColumn: "2 / 3",
        gridRow: "1 / 2",
        alignSelf: "center",
        textAlign: "end",
        mt: { base: 3, md: 10 }
      },
      subHeading: {
        fontSize: { base: "xs", sm: "sm" },
        gridColumn: "2 / 3",
        gridRow: "2 / 3",
        alignSelf: "center",
        textAlign: "end",
        visibility: { base: "hidden", md: "visible" }
      },
      button: {
        gridColumn: "2 / 3",
        gridRow: { base: "2 / 3", md: "3 / 4" },
        alignSelf: "center",
        justifySelf: "end",
        width: "50%",
        mb: 3
      }
    },
    serpExpert: {
      banner: {
        gridTemplate: {
          base: "min-content 1fr / 3fr 2fr",
          md: "min-content min-content 1fr / 70% 30%"
        },
        gridColumnGap: 0,
        rowGap: { base: 1, md: 1.5 }
      },
      image: {
        gridColumn: "2 / 3",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        alignSelf: "center",
        justifySelf: "center"
      },
      imageText: {
        gridColumn: "2 / 3",
        gridRow: { base: "1 / 3", md: "3 / 4" },
        alignSelf: "center",
        justifySelf: "center"
      },
      backgroundCircle: {
        gridColumn: "2 / 3",
        gridRow: { base: "1 / 3", md: "1 / 4" },
        borderRadius: {
          base: "0 0.25rem 0.25rem 0",
          md: "300px 0.25rem 0.25rem 0"
        },
        clipPath: {
          base: "polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%)",
          md: "none"
        }
      },
      heading: {
        fontSize: { base: "lg", sm: "1.5rem" },
        gridColumn: "1 / 2",
        gridRow: "1 / 2",
        mt: { base: 3, md: 10 }
      },
      subHeading: {
        fontSize: { base: "xs", sm: "sm" },
        gridColumn: "1 / 2",
        gridRow: "2 / 3",
        visibility: { base: "hidden", md: "visible" }
      },
      button: {
        gridColumn: "1 / 2",
        gridRow: { base: "2 / 3", md: "3 / 4" },
        width: "50%",
        alignSelf: "center",
        mb: 3
      }
    },
    float: {
      banner: {
        padding: 6,
        w: 44,
        gridTemplateRows: "auto auto auto",
        gridRowGap: 4
      },
      image: {
        gridRow: "1 / 2",
        justifySelf: "center"
      },
      heading: {
        gridRow: "2 / 3",
        fontSize: "1.5rem"
      },
      subHeading: {
        gridRow: "3 / 4",
        fontSize: "xs"
      }
    }
  },
  sizes: {
    md: {
      heading: {},
      subheading: {}
    },
    lg: {
      banner: { px: { base: 4, md: 5, lg: 7 }, py: { base: 4, md: 5, lg: 7 } },
      heading: { fontSize: { base: "lg", md: "xl", lg: "2xl" } },
      subheading: { fontSize: { base: "xs", lg: "sm" } }
    },
    xl: {
      banner: { px: { base: 4, md: 6, lg: 8 }, py: { base: 4, md: 6, lg: 10 } },
      heading: { fontSize: { base: "lg", md: "2xl", lg: "4xl" } },
      subheading: { fontSize: { base: "xs", lg: "sm" } }
    }
  },
  defaultProps: {
    variant: "horizontal"
  }
}, V2 = {
  parts: [
    "seoBanner",
    "mainSection",
    "image",
    "imageText",
    "starIconWrapper",
    "starIcon",
    "mainText",
    "button",
    "footer"
  ],
  baseStyle: {
    seoBanner: {
      bgColor: "blue.500",
      color: "white",
      borderRadius: "md"
    },
    mainSection: {
      p: 10,
      display: "grid",
      gap: 5
    },
    image: {
      borderRadius: "full",
      position: "relative",
      zIndex: 2
    },
    imageText: {
      textAlign: "center",
      alignSelf: "center",
      fontWeight: "semibold"
    },
    starIcon: {
      height: {
        base: "15px",
        md: "18px"
      },
      width: { base: "15px", md: "18px" }
    },
    starIconWrapper: {
      padding: 1,
      borderRadius: "full",
      bgColor: "white",
      position: "absolute",
      right: 0,
      bottom: 0
    },
    mainText: {
      fontWeight: "normal",
      fontSize: "small",
      textAlign: "center"
    },
    button: {
      borderRadius: "base",
      maxHeight: "42px",
      w: "100%",
      bgColor: "green.500",
      py: 2,
      fontSize: { base: 12, md: 16 }
    },
    footer: {
      bgColor: "gray.300",
      color: "black",
      px: 3,
      py: 5,
      borderBottomRadius: "base"
    }
  },
  variants: {
    vertical: {
      seoBanner: {
        display: "flex",
        flexDirection: "column"
      },
      mainSection: {
        flex: 1
      },
      image: {
        justifySelf: "center",
        gridColumn: "auto",
        height: "fit-content"
      },
      imageText: {
        gridColumn: "auto",
        fontSize: "large"
      },
      mainText: {
        gridColumn: "auto"
      },
      button: {
        gridColumn: "auto"
      }
    },
    horizontal: {
      image: {
        justifySelf: "center",
        gridColumn: "1 / 2"
      },
      imageText: {
        gridColumn: "2 / 3",
        textAlign: "left"
      },
      mainText: {
        gridColumn: "1 / 3"
      },
      button: {
        gridColumn: "1 / 3"
      },
      mainSection: {
        p: 5,
        display: "grid",
        gap: 5
      }
    }
  },
  defaultProps: {
    variant: "vertical"
  }
}, _2 = {
  variants: {
    black: {
      color: "gray.600",
      _hover: {
        color: "gray.800",
        textDecoration: "underline"
      }
    },
    blue: {
      color: "blue.500",
      _hover: {
        color: "blue.600",
        textDecoration: "none"
      }
    },
    white: {
      color: "white",
      _hover: {
        color: "gray.100",
        textDecoration: "none"
      }
    }
  }
}, I2 = {
  parts: ["box", "formlabel", "divider"],
  baseStyle: {
    box: {
      borderWidth: 1
    },
    formlabel: {
      color: "rgba(0,0,0,0.6)",
      fontSize: "xs"
    }
  },
  variants: {
    horizontal: {
      box: {
        padding: 1,
        paddingLeft: 5,
        gridGap: 4,
        borderRadius: "full",
        display: "inline-flex",
        alignItems: "center"
      },
      formlabel: {
        left: -1,
        top: -4,
        padding: 1,
        paddingTop: 0,
        bgColor: "white",
        position: "absolute"
      },
      divider: {
        borderLeftWidth: 1,
        borderLeftStyle: "solid",
        height: 10
      }
    },
    vertical: {
      box: {
        padding: 5,
        borderRadius: "md",
        alignItems: "center",
        gap: 2.5
      },
      divider: {
        alignSelf: "center",
        marginBottom: 4
      }
    }
  },
  defaultProps: {
    variant: "horizontal"
  }
}, T2 = {
  baseStyle: {
    mx: "auto",
    maxWidth: "container.lg",
    px: {
      base: "1rem",
      md: "3rem",
      lg: "unset"
    },
    py: {
      base: "3.75rem",
      md: "5rem"
    },
    mb: {
      base: "4rem",
      md: "6rem"
    }
  },
  variants: {
    solid: {
      backgroundColor: "green.50",
      boxShadow: "0 0 0 100vmax var(--chakra-colors-green-50)",
      clipPath: "inset(0 -100vmax)"
    },
    wire: {
      borderTop: "1px",
      borderColor: "grey.100"
    }
  }
}, $2 = {
  baseStyle: {
    color: "grey.800",
    fontWeight: "semibold",
    letterSpacing: "-0.75px",
    lineHeight: "109%"
  },
  sizes: {
    hero: {
      fontSize: {
        base: "4xl",
        lg: "6xl"
      },
      marginBottom: {
        base: "2.5rem",
        md: "2rem"
      }
    },
    "main-section": {
      fontSize: {
        base: "3xl",
        md: "4xl"
      },
      marginBottom: "1.9rem"
    },
    subsection: {
      fontSize: {
        base: "lg",
        md: "xl"
      },
      marginBottom: {
        base: "0.6rem",
        md: "1rem"
      }
    }
  }
}, W2 = {
  baseStyle: {
    color: "green.500",
    fontWeight: "semibold"
  },
  sizes: {
    hero: {
      fontSize: {
        base: "lg",
        md: "xl"
      },
      marginBottom: {
        base: "1.9rem",
        md: "1.6rem"
      }
    },
    section: {
      fontSize: {
        base: "md",
        md: "lg"
      },
      marginBottom: "0.5rem"
    }
  }
}, P2 = {
  baseStyle: {
    paddingLeft: 3,
    borderColor: "green.500"
  },
  variants: {
    thin: {
      borderLeftWidth: "2px"
    },
    thick: {
      borderLeftWidth: "4px"
    }
  },
  defaultProps: {
    variant: "thin"
  }
}, z2 = {
  variants: {
    hero: {
      margin: {
        lg: "0 0 45px 43px"
      },
      boxShadow: {
        lg: "-43px 45px #F4FDFA"
      },
      borderRadius: {
        base: 6,
        lg: "none"
      }
    },
    section: {
      boxShadow: {
        base: "0px 6px 10px rgba(0, 0, 0, 0.15)",
        md: "0px 15px 40px 10px rgba(0, 0, 0, 0.1)"
      },
      filter: {
        base: "drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.15))",
        md: "drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.15))"
      }
    }
  },
  defaultProps: {
    variant: "section"
  }
}, O2 = {
  name: "yta",
  components: {
    Tabs: b2,
    Button: M2,
    Chart: A2,
    TagButton: S2,
    Input: j2,
    FormLabel: B2,
    Form: H2,
    SelectDropdown: R2,
    Card: Z2,
    AdBanner: N2,
    Banner: D2,
    SeoBanner: V2,
    Link: _2,
    BorderedForm: I2,
    ContentPageSection: T2,
    ContentPageSectionHeading: $2,
    ContentPageSectionSubheading: W2,
    HighlightSection: P2,
    Illustration: z2
  },
  fonts: {
    body: "FaktPro, Roboto, sans-serif",
    heading: "FaktPro, Roboto, sans-serif"
  },
  colors: {
    black: "#000",
    white: "#fff",
    green: {
      50: "#F4FDFA",
      500: "#1DCE93",
      600: "#1AB984"
    },
    yellow: {
      500: "#ECC11D"
    },
    blue: {
      50: "#F2F8FF",
      100: "#CEE6FF",
      200: "#99caff",
      500: "#007aff",
      600: "#006EE6"
    },
    grey: {
      100: "rgba(0, 0, 0, 0.15)",
      300: "rgba(51, 62, 72, 0.4)",
      400: "rgba(0, 0, 0, 0.4)",
      500: "rgba(0, 0, 0, 0.6)",
      600: "#999999",
      700: "#333e48",
      800: "rgba(0, 0, 0, 0.8)"
    }
  }
}, Dn = ke(O2), G2 = {
  parts: ["preview"],
  baseStyle: {
    preview: {
      fontWeight: "bold"
    }
  }
}, U2 = {
  parts: ["label", "container", "control"],
  variants: {
    solid: ({ color: t }) => {
      const n = t || "blue.500";
      return {
        label: {
          _checked: {
            textShadow: "0 0 .5px black, 0 0 .5px black"
          }
        },
        control: {
          borderColor: n,
          borderWidth: "2px",
          backgroundColor: "transparent",
          _checked: {
            borderColor: n,
            backgroundColor: n,
            _before: {
              backgroundColor: n
            }
          }
        }
      };
    }
  }
}, q2 = {
  name: "occu",
  config: { initialColorMode: "dark", useSystemColorMode: !1 },
  components: {
    Editable: G2,
    Radio: U2,
    FormLabel: {
      sizes: {
        sm: {
          fontSize: "sm",
          mb: 0
        }
      }
    }
  },
  fonts: {
    body: '"Inter", "system-ui", sans-serif',
    heading: '"Inter", "system-ui", sans-serif'
  }
}, Vn = ke(q2), _ = {
  blue: "#007aff",
  green: "#1dce93",
  middleGrey: "#eaedf0",
  grey: "#999999",
  darkBlue: "#3e5062"
}, _n = Ue({
  palette: {
    primary: {
      main: _.blue
    },
    action: { disabledBackground: _.middleGrey },
    text: { primary: _.darkBlue, secondary: _.grey }
  },
  typography: {
    fontFamily: ["FaktPro", "Roboto", "sans-serif"].join(","),
    h1: {
      fontSize: "34px",
      fontWeight: 500,
      lineHeight: "52px",
      textAlign: "left"
    },
    h4: {
      fontSize: "20px",
      lineHeight: "27px"
    },
    h5: {
      fontSize: "20px",
      textTransform: "uppercase"
    }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: "white",
        "&:hover": {
          color: "white"
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: _.grey
      }
    },
    MuiScopedCssBaseline: {
      root: {
        backgroundColor: "transparent"
      }
    },
    MuiOutlinedInput: {
      root: {
        background: "white"
      },
      notchedOutline: {
        "&>legend": {
          maxWidth: "1000px"
        }
      }
    }
  }
}), In = ({
  value: t,
  name: n,
  ...r
}) => /* @__PURE__ */ d(j, {
  gap: "4px",
  ...r,
  children: [/* @__PURE__ */ d(J, {
    as: "dt",
    color: "grey.500",
    children: [n, ":"]
  }), /* @__PURE__ */ o(J, {
    as: "dd",
    fontWeight: "semibold",
    color: "grey.800",
    children: t
  })]
}), Tn = ({
  children: t,
  colorScheme: n,
  ...r
}) => {
  const l = H("Card", {
    colorScheme: n
  });
  return /* @__PURE__ */ o(E, {
    __css: l,
    ...r,
    children: t
  });
}, $n = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  bg: "green.50",
  p: 6,
  color: "grey.500",
  ...n,
  children: t
}), Wn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "section",
  py: 7,
  borderTop: "1px",
  borderColor: "grey.100",
  gridColumnStart: "1",
  ...n,
  children: t
}), Pn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(he, {
  as: "h1",
  fontSize: {
    base: "lg",
    md: "xl",
    lg: "2xl"
  },
  color: "grey.800",
  fontWeight: "semibold",
  mb: 3,
  ...n,
  children: t
}), zn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "article",
  display: "grid",
  gridTemplateColumns: {
    base: "1fr",
    lg: "1fr 20rem"
  },
  gridColumnGap: {
    base: 0,
    lg: 4
  },
  gridTemplateRows: "min-content 5.5rem min-content 5.5rem 1fr",
  ...n,
  children: t
}), On = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  gridArea: "2 / 1 / 5 / 3",
  mb: 7,
  ...n,
  children: t
}), Gn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "aside",
  gridArea: {
    base: "auto / 1 / auto / 2",
    lg: "3 / 2 / 4 / 3"
  },
  order: {
    base: 10,
    lg: "unset"
  },
  position: "sticky",
  top: {
    base: "auto",
    lg: 10
  },
  bottom: {
    base: 0,
    lg: "auto"
  },
  py: 7,
  px: 6,
  mx: {
    base: "-1rem",
    lg: 0
  },
  bg: "white",
  borderRadius: "base",
  height: "min-content",
  transform: {
    base: "none",
    lg: "translateX(24px)"
  },
  border: "1px",
  borderColor: "grey.100",
  shadow: {
    base: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    lg: "xl"
  },
  ...n,
  children: t
}), Un = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "main",
  gridArea: "5 / 1 / 6 / 2",
  ...n,
  children: t
}), qn = ({
  children: t,
  ...n
}) => /* @__PURE__ */ o(E, {
  as: "header",
  gridArea: "1 / 1 / 2 / -1",
  mb: 4,
  ...n,
  children: t
}), Yn = ({
  children: t,
  variant: n,
  ...r
}) => {
  const l = H("ContentPageSection", {
    variant: n
  });
  return /* @__PURE__ */ o(E, {
    as: "section",
    __css: l,
    ...r,
    children: t
  });
}, Qn = ({
  children: t,
  size: n,
  ...r
}) => {
  const l = H("ContentPageSectionHeading", {
    size: n
  });
  return /* @__PURE__ */ o(E, {
    as: "h1",
    __css: l,
    ...r,
    children: t
  });
}, Xn = ({
  children: t,
  size: n,
  ...r
}) => {
  const l = H("ContentPageSectionSubheading", {
    size: n
  });
  return /* @__PURE__ */ o(E, {
    as: "h2",
    __css: l,
    ...r,
    children: t
  });
}, Jn = ({
  children: t,
  variant: n,
  ...r
}) => {
  const l = H("HighlightSection", {
    variant: n
  });
  return /* @__PURE__ */ o(E, {
    __css: l,
    ...r,
    children: t
  });
}, Kn = ({
  src: t,
  variant: n,
  ...r
}) => {
  const l = H("Illustration", {
    variant: n
  });
  return /* @__PURE__ */ o(i.img, {
    src: t,
    __css: l,
    ...r
  });
};
export {
  st as AdBanner,
  ct as AdBannerButton,
  it as AdBannerHeading,
  at as AdBannerImage,
  dt as AdBannerLogoWrapper,
  wt as AppWindowError404Icn,
  m0 as ArrowDownIcn,
  Ft as ArrowLeftIcn,
  xt as ArrowUpIcn,
  Bo as Banner,
  Ho as BannerAvatar,
  _o as BannerBackgroundCircle,
  Io as BannerButton,
  Zo as BannerHeading,
  Do as BannerImageText,
  Vo as BannerImageTextWithStarIcon,
  Ro as BannerSimpleImage,
  No as BannerSubHeading,
  vt as BarcodeScanIcn,
  yt as BathroomShowerIcn,
  bt as BedWindowIcn,
  uo as BicycleSportsIcn,
  Fo as BinIcn,
  v as BodyText,
  pn as BorderedForm,
  Mt as BreakfastCroissantIcn,
  At as CalendarClockIcn,
  St as CalendarHomeIcn,
  Tn as Card,
  Hn as Carousel,
  Zn as CarouselBackArrow,
  Rn as CarouselForwardArrow,
  Nn as CarouselSlide,
  Uo as ChartBar,
  jt as CheckmarkInWavyStarIcn,
  f0 as CloseIcn,
  Bt as CoffeeCupHotIcn,
  wo as CommonFileDouble1Icn,
  Yn as ContentPageSection,
  Qn as ContentPageSectionHeading,
  Xn as ContentPageSectionSubheading,
  Wn as ContentSection,
  Pn as ContentSectionHeading,
  gn as Conversation,
  kn as ConversationQuestion,
  Sn as CustomEditablePreview,
  Mn as DateTimePicker,
  Ht as DogIcn,
  Rt as DownloadIcn,
  Zt as ECommerceBasketLaptopIcn,
  jn as EditableControls,
  Nt as EnvelopeIcn,
  Yo as ErrorText,
  Dt as Expand1Icn,
  Vt as Expand3Icn,
  on as ExpertMainContent,
  In as Feature,
  bo as FillableHeartIcn,
  _t as FilterIcn,
  It as FitnessDumbbellIcn,
  le as FixedWidthContent,
  So as GoogleSignInButton,
  k0 as GoogleSignInIcn,
  U0 as GreenEdgeCard,
  Z0 as HeadlineLabel,
  Jn as HighlightSection,
  ee as IcnArrow,
  pt as IcnBuilding,
  te as IcnCheckmark,
  ut as IcnCheckmarkInCircle,
  Ct as IcnClock,
  mt as IcnCross,
  Je as IcnEmail,
  ft as IcnFacebook,
  ht as IcnLightStick,
  Ke as IcnLinkedIn,
  gt as IcnNavMenu,
  e1 as IcnPhone,
  oe as IcnRightArrow,
  t1 as IcnStar,
  kt as IcnTwitter,
  Ee as IcnWhiteLeftArrow,
  Lt as IcnYtaLogo,
  Kn as Illustration,
  $n as Info,
  Ao as InfoCircle,
  Tt as InformationCircleBoldIcn,
  $t as InformationCircleIcn,
  Wt as InformationDeskManIcn,
  An as InlineEditable,
  Cn as InlineMultiChoice,
  dn as InputDivider,
  cn as InputLabel,
  Pt as LiftIcn,
  zt as LiftTwoPeopleIcn,
  Fn as ListResult,
  bn as ListResultActions,
  vn as ListResultHeader,
  yn as ListResultIllustration,
  _n as MUITheme,
  Ot as MapPinIcn,
  Ut as MapsIcn,
  Gt as MapsPinIcn,
  ho as MapsSearchIcn,
  xn as MenuArrow,
  qt as MicrophonePodcastPersonIcn,
  jo as MicrosoftSignInButton,
  g0 as MicrosoftSignInIcn,
  mn as MultiChoiceDisplayValue,
  s2 as MultiInputBox,
  un as MultiSelectDropdown,
  Yt as NavigationMenuIcn,
  Qt as OfficeChairIcn,
  Xt as OfficeDeskIcn,
  d2 as OptionsList,
  nn as OrderedListContent,
  Jo as PageSection,
  lt as Paragraph,
  Jt as ParkingIcn,
  h0 as PencilIcn,
  Kt as PhoneIcn,
  eo as PinIcn,
  Co as PresentationIcn,
  re as PrimaryButton,
  yo as QuestionmarkCircleIcn,
  to as RealEstateDimensionsBlockIcn,
  ko as RealEstateDimensionsMapIcn,
  oo as RestaurantForkKnifeIcn,
  fo as RightArrowIcn,
  Lo as RoadSignBannedIcn,
  vo as RoadSignWarningIcn,
  fn as RoundedTextInput,
  Et as SearchIcn,
  Mo as SearchQuestionmarkIcn,
  Ko as Section,
  tn as SectionFooter,
  en as SectionLogoGroup,
  hn as SelectDropdown,
  To as SeoBanner,
  Wo as SeoBannerAvatar,
  Oo as SeoBannerButton,
  Go as SeoBannerFooter,
  Po as SeoBannerImageText,
  $o as SeoBannerMainSection,
  zo as SeoBannerMainText,
  Qo as Shape1,
  V0 as Shape2,
  _0 as Shape3,
  I0 as Shape4,
  Xo as Shape4Icn,
  T0 as Shape5,
  $0 as Shape6,
  W0 as Shape7,
  Eo as ShareIcn,
  Gn as SingleAside,
  Un as SingleBody,
  qn as SingleHeader,
  On as SingleHero,
  zn as SingleLayout,
  no as SingleNeutralCircleBoldIcn,
  ro as SingleNeutralIdCardIcn,
  ne as StarVerifiedIcon,
  o1 as StreamlineIcon,
  wn as StripePattern,
  D0 as SubHeadline,
  lo as SynchronizeArrowsIcn,
  so as TableRestaurantBeachIcn,
  ae as Tag,
  rn as TestimonialMainContent,
  go as TipBulbIcn,
  sn as Tooltip,
  Ln as TopContent,
  En as TopHero,
  xo as UnitedSpacesLogoIcn,
  ao as UploadIcn,
  ln as ValuePropositionMainContent,
  qo as VerticalBarChart,
  mo as WaitingRoomLampIcn,
  io as WarehouseStorageIcn,
  co as Warning500Icn,
  po as WineGlassIcn,
  je as YellowEdgeCard,
  Vn as chakraOccuTheme,
  Dn as chakraYtaTheme,
  D as convertChakraColorToCSS,
  an as formParams,
  I as mediaQuerybreakpoints
};
